/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
//
// THIS IS A GENERATED FILE
// DO NOT MODIFY IT! YOUR CHANGES WILL BE LOST
import {
  GrpcMessage,
  RecursivePartial,
  ToProtobufJSONOptions,
  uint8ArrayToBase64
} from '@ngx-grpc/common';
import { BinaryReader, BinaryWriter, ByteSource } from 'google-protobuf';
import * as googleProtobuf000 from '@ngx-grpc/well-known-types';
import * as googleProtobuf001 from '@ngx-grpc/well-known-types';
import * as googleProtobuf002 from '@ngx-grpc/well-known-types';
export enum GRPCSeverity {
  None = 0,
  Debug = 1,
  Information = 2,
  Warning = 3,
  Error = 4,
  Fatal = 5
}
/**
 * Message implementation for epicore.admin.RegisterRequest
 */
export class RegisterRequest implements GrpcMessage {
  static id = 'epicore.admin.RegisterRequest';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new RegisterRequest();
    RegisterRequest.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: RegisterRequest) {
    _instance.username = _instance.username || '';
    _instance.email = _instance.email || '';
    _instance.password = _instance.password || '';
    _instance.confirmPassword = _instance.confirmPassword || '';
    _instance.firstName = _instance.firstName || '';
    _instance.lastName = _instance.lastName || '';
    _instance.phoneNumber = _instance.phoneNumber || '';
    _instance.userGroupId = _instance.userGroupId || 0;
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: RegisterRequest,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.username = _reader.readString();
          break;
        case 2:
          _instance.email = _reader.readString();
          break;
        case 3:
          _instance.password = _reader.readString();
          break;
        case 4:
          _instance.confirmPassword = _reader.readString();
          break;
        case 5:
          _instance.firstName = _reader.readString();
          break;
        case 6:
          _instance.lastName = _reader.readString();
          break;
        case 7:
          _instance.phoneNumber = _reader.readString();
          break;
        case 8:
          _instance.userGroupId = _reader.readInt32();
          break;
        default:
          _reader.skipField();
      }
    }

    RegisterRequest.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: RegisterRequest,
    _writer: BinaryWriter
  ) {
    if (_instance.username) {
      _writer.writeString(1, _instance.username);
    }
    if (_instance.email) {
      _writer.writeString(2, _instance.email);
    }
    if (_instance.password) {
      _writer.writeString(3, _instance.password);
    }
    if (_instance.confirmPassword) {
      _writer.writeString(4, _instance.confirmPassword);
    }
    if (_instance.firstName) {
      _writer.writeString(5, _instance.firstName);
    }
    if (_instance.lastName) {
      _writer.writeString(6, _instance.lastName);
    }
    if (_instance.phoneNumber) {
      _writer.writeString(7, _instance.phoneNumber);
    }
    if (_instance.userGroupId) {
      _writer.writeInt32(8, _instance.userGroupId);
    }
  }

  private _username: string;
  private _email: string;
  private _password: string;
  private _confirmPassword: string;
  private _firstName: string;
  private _lastName: string;
  private _phoneNumber: string;
  private _userGroupId: number;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of RegisterRequest to deeply clone from
   */
  constructor(_value?: RecursivePartial<RegisterRequest.AsObject>) {
    _value = _value || {};
    this.username = _value.username;
    this.email = _value.email;
    this.password = _value.password;
    this.confirmPassword = _value.confirmPassword;
    this.firstName = _value.firstName;
    this.lastName = _value.lastName;
    this.phoneNumber = _value.phoneNumber;
    this.userGroupId = _value.userGroupId;
    RegisterRequest.refineValues(this);
  }
  get username(): string {
    return this._username;
  }
  set username(value: string) {
    this._username = value;
  }
  get email(): string {
    return this._email;
  }
  set email(value: string) {
    this._email = value;
  }
  get password(): string {
    return this._password;
  }
  set password(value: string) {
    this._password = value;
  }
  get confirmPassword(): string {
    return this._confirmPassword;
  }
  set confirmPassword(value: string) {
    this._confirmPassword = value;
  }
  get firstName(): string {
    return this._firstName;
  }
  set firstName(value: string) {
    this._firstName = value;
  }
  get lastName(): string {
    return this._lastName;
  }
  set lastName(value: string) {
    this._lastName = value;
  }
  get phoneNumber(): string {
    return this._phoneNumber;
  }
  set phoneNumber(value: string) {
    this._phoneNumber = value;
  }
  get userGroupId(): number {
    return this._userGroupId;
  }
  set userGroupId(value: number) {
    this._userGroupId = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    RegisterRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): RegisterRequest.AsObject {
    return {
      username: this.username,
      email: this.email,
      password: this.password,
      confirmPassword: this.confirmPassword,
      firstName: this.firstName,
      lastName: this.lastName,
      phoneNumber: this.phoneNumber,
      userGroupId: this.userGroupId
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): RegisterRequest.AsProtobufJSON {
    return {
      username: this.username,
      email: this.email,
      password: this.password,
      confirmPassword: this.confirmPassword,
      firstName: this.firstName,
      lastName: this.lastName,
      phoneNumber: this.phoneNumber,
      userGroupId: this.userGroupId
    };
  }
}
export module RegisterRequest {
  /**
   * Standard JavaScript object representation for RegisterRequest
   */
  export interface AsObject {
    username: string;
    email: string;
    password: string;
    confirmPassword: string;
    firstName: string;
    lastName: string;
    phoneNumber: string;
    userGroupId: number;
  }

  /**
   * Protobuf JSON representation for RegisterRequest
   */
  export interface AsProtobufJSON {
    username: string;
    email: string;
    password: string;
    confirmPassword: string;
    firstName: string;
    lastName: string;
    phoneNumber: string;
    userGroupId: number;
  }
}

/**
 * Message implementation for epicore.admin.RegisterResponse
 */
export class RegisterResponse implements GrpcMessage {
  static id = 'epicore.admin.RegisterResponse';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new RegisterResponse();
    RegisterResponse.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: RegisterResponse) {
    _instance.userId = _instance.userId || 0;
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: RegisterResponse,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.userId = _reader.readInt32();
          break;
        default:
          _reader.skipField();
      }
    }

    RegisterResponse.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: RegisterResponse,
    _writer: BinaryWriter
  ) {
    if (_instance.userId) {
      _writer.writeInt32(1, _instance.userId);
    }
  }

  private _userId: number;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of RegisterResponse to deeply clone from
   */
  constructor(_value?: RecursivePartial<RegisterResponse.AsObject>) {
    _value = _value || {};
    this.userId = _value.userId;
    RegisterResponse.refineValues(this);
  }
  get userId(): number {
    return this._userId;
  }
  set userId(value: number) {
    this._userId = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    RegisterResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): RegisterResponse.AsObject {
    return {
      userId: this.userId
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): RegisterResponse.AsProtobufJSON {
    return {
      userId: this.userId
    };
  }
}
export module RegisterResponse {
  /**
   * Standard JavaScript object representation for RegisterResponse
   */
  export interface AsObject {
    userId: number;
  }

  /**
   * Protobuf JSON representation for RegisterResponse
   */
  export interface AsProtobufJSON {
    userId: number;
  }
}

/**
 * Message implementation for epicore.admin.LoginRequest
 */
export class LoginRequest implements GrpcMessage {
  static id = 'epicore.admin.LoginRequest';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new LoginRequest();
    LoginRequest.deserializeBinaryFromReader(instance, new BinaryReader(bytes));
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: LoginRequest) {
    _instance.username = _instance.username || '';
    _instance.password = _instance.password || '';
    _instance.rememberMe = _instance.rememberMe || false;
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: LoginRequest,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.username = _reader.readString();
          break;
        case 2:
          _instance.password = _reader.readString();
          break;
        case 3:
          _instance.rememberMe = _reader.readBool();
          break;
        default:
          _reader.skipField();
      }
    }

    LoginRequest.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: LoginRequest,
    _writer: BinaryWriter
  ) {
    if (_instance.username) {
      _writer.writeString(1, _instance.username);
    }
    if (_instance.password) {
      _writer.writeString(2, _instance.password);
    }
    if (_instance.rememberMe) {
      _writer.writeBool(3, _instance.rememberMe);
    }
  }

  private _username: string;
  private _password: string;
  private _rememberMe: boolean;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of LoginRequest to deeply clone from
   */
  constructor(_value?: RecursivePartial<LoginRequest.AsObject>) {
    _value = _value || {};
    this.username = _value.username;
    this.password = _value.password;
    this.rememberMe = _value.rememberMe;
    LoginRequest.refineValues(this);
  }
  get username(): string {
    return this._username;
  }
  set username(value: string) {
    this._username = value;
  }
  get password(): string {
    return this._password;
  }
  set password(value: string) {
    this._password = value;
  }
  get rememberMe(): boolean {
    return this._rememberMe;
  }
  set rememberMe(value: boolean) {
    this._rememberMe = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    LoginRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): LoginRequest.AsObject {
    return {
      username: this.username,
      password: this.password,
      rememberMe: this.rememberMe
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): LoginRequest.AsProtobufJSON {
    return {
      username: this.username,
      password: this.password,
      rememberMe: this.rememberMe
    };
  }
}
export module LoginRequest {
  /**
   * Standard JavaScript object representation for LoginRequest
   */
  export interface AsObject {
    username: string;
    password: string;
    rememberMe: boolean;
  }

  /**
   * Protobuf JSON representation for LoginRequest
   */
  export interface AsProtobufJSON {
    username: string;
    password: string;
    rememberMe: boolean;
  }
}

/**
 * Message implementation for epicore.admin.LoginResponse
 */
export class LoginResponse implements GrpcMessage {
  static id = 'epicore.admin.LoginResponse';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new LoginResponse();
    LoginResponse.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: LoginResponse) {
    _instance.token = _instance.token || '';
    _instance.expiresIn = _instance.expiresIn || 0;
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: LoginResponse,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.token = _reader.readString();
          break;
        case 2:
          _instance.expiresIn = _reader.readInt32();
          break;
        default:
          _reader.skipField();
      }
    }

    LoginResponse.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: LoginResponse,
    _writer: BinaryWriter
  ) {
    if (_instance.token) {
      _writer.writeString(1, _instance.token);
    }
    if (_instance.expiresIn) {
      _writer.writeInt32(2, _instance.expiresIn);
    }
  }

  private _token: string;
  private _expiresIn: number;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of LoginResponse to deeply clone from
   */
  constructor(_value?: RecursivePartial<LoginResponse.AsObject>) {
    _value = _value || {};
    this.token = _value.token;
    this.expiresIn = _value.expiresIn;
    LoginResponse.refineValues(this);
  }
  get token(): string {
    return this._token;
  }
  set token(value: string) {
    this._token = value;
  }
  get expiresIn(): number {
    return this._expiresIn;
  }
  set expiresIn(value: number) {
    this._expiresIn = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    LoginResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): LoginResponse.AsObject {
    return {
      token: this.token,
      expiresIn: this.expiresIn
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): LoginResponse.AsProtobufJSON {
    return {
      token: this.token,
      expiresIn: this.expiresIn
    };
  }
}
export module LoginResponse {
  /**
   * Standard JavaScript object representation for LoginResponse
   */
  export interface AsObject {
    token: string;
    expiresIn: number;
  }

  /**
   * Protobuf JSON representation for LoginResponse
   */
  export interface AsProtobufJSON {
    token: string;
    expiresIn: number;
  }
}

/**
 * Message implementation for epicore.admin.UpdateUserRequest
 */
export class UpdateUserRequest implements GrpcMessage {
  static id = 'epicore.admin.UpdateUserRequest';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new UpdateUserRequest();
    UpdateUserRequest.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: UpdateUserRequest) {
    _instance.id = _instance.id || 0;
    _instance.firstName = _instance.firstName || '';
    _instance.lastName = _instance.lastName || '';
    _instance.phoneNumber = _instance.phoneNumber || '';
    _instance.groupIds = _instance.groupIds || [];
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: UpdateUserRequest,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.id = _reader.readInt32();
          break;
        case 2:
          _instance.firstName = _reader.readString();
          break;
        case 3:
          _instance.lastName = _reader.readString();
          break;
        case 4:
          _instance.phoneNumber = _reader.readString();
          break;
        case 5:
          (_instance.groupIds = _instance.groupIds || []).push(
            ...(_reader.readPackedInt32() || [])
          );
          break;
        default:
          _reader.skipField();
      }
    }

    UpdateUserRequest.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: UpdateUserRequest,
    _writer: BinaryWriter
  ) {
    if (_instance.id) {
      _writer.writeInt32(1, _instance.id);
    }
    if (_instance.firstName) {
      _writer.writeString(2, _instance.firstName);
    }
    if (_instance.lastName) {
      _writer.writeString(3, _instance.lastName);
    }
    if (_instance.phoneNumber) {
      _writer.writeString(4, _instance.phoneNumber);
    }
    if (_instance.groupIds && _instance.groupIds.length) {
      _writer.writePackedInt32(5, _instance.groupIds);
    }
  }

  private _id: number;
  private _firstName: string;
  private _lastName: string;
  private _phoneNumber: string;
  private _groupIds: number[];

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of UpdateUserRequest to deeply clone from
   */
  constructor(_value?: RecursivePartial<UpdateUserRequest.AsObject>) {
    _value = _value || {};
    this.id = _value.id;
    this.firstName = _value.firstName;
    this.lastName = _value.lastName;
    this.phoneNumber = _value.phoneNumber;
    this.groupIds = (_value.groupIds || []).slice();
    UpdateUserRequest.refineValues(this);
  }
  get id(): number {
    return this._id;
  }
  set id(value: number) {
    this._id = value;
  }
  get firstName(): string {
    return this._firstName;
  }
  set firstName(value: string) {
    this._firstName = value;
  }
  get lastName(): string {
    return this._lastName;
  }
  set lastName(value: string) {
    this._lastName = value;
  }
  get phoneNumber(): string {
    return this._phoneNumber;
  }
  set phoneNumber(value: string) {
    this._phoneNumber = value;
  }
  get groupIds(): number[] {
    return this._groupIds;
  }
  set groupIds(value: number[]) {
    this._groupIds = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    UpdateUserRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): UpdateUserRequest.AsObject {
    return {
      id: this.id,
      firstName: this.firstName,
      lastName: this.lastName,
      phoneNumber: this.phoneNumber,
      groupIds: (this.groupIds || []).slice()
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): UpdateUserRequest.AsProtobufJSON {
    return {
      id: this.id,
      firstName: this.firstName,
      lastName: this.lastName,
      phoneNumber: this.phoneNumber,
      groupIds: (this.groupIds || []).slice()
    };
  }
}
export module UpdateUserRequest {
  /**
   * Standard JavaScript object representation for UpdateUserRequest
   */
  export interface AsObject {
    id: number;
    firstName: string;
    lastName: string;
    phoneNumber: string;
    groupIds: number[];
  }

  /**
   * Protobuf JSON representation for UpdateUserRequest
   */
  export interface AsProtobufJSON {
    id: number;
    firstName: string;
    lastName: string;
    phoneNumber: string;
    groupIds: number[];
  }
}

/**
 * Message implementation for epicore.admin.UsersListResponse
 */
export class UsersListResponse implements GrpcMessage {
  static id = 'epicore.admin.UsersListResponse';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new UsersListResponse();
    UsersListResponse.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: UsersListResponse) {
    _instance.total = _instance.total || 0;
    _instance.data = _instance.data || [];
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: UsersListResponse,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.total = _reader.readInt32();
          break;
        case 2:
          const messageInitializer2 = new UserDto();
          _reader.readMessage(
            messageInitializer2,
            UserDto.deserializeBinaryFromReader
          );
          (_instance.data = _instance.data || []).push(messageInitializer2);
          break;
        default:
          _reader.skipField();
      }
    }

    UsersListResponse.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: UsersListResponse,
    _writer: BinaryWriter
  ) {
    if (_instance.total) {
      _writer.writeInt32(1, _instance.total);
    }
    if (_instance.data && _instance.data.length) {
      _writer.writeRepeatedMessage(
        2,
        _instance.data as any,
        UserDto.serializeBinaryToWriter
      );
    }
  }

  private _total: number;
  private _data?: UserDto[];

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of UsersListResponse to deeply clone from
   */
  constructor(_value?: RecursivePartial<UsersListResponse.AsObject>) {
    _value = _value || {};
    this.total = _value.total;
    this.data = (_value.data || []).map(m => new UserDto(m));
    UsersListResponse.refineValues(this);
  }
  get total(): number {
    return this._total;
  }
  set total(value: number) {
    this._total = value;
  }
  get data(): UserDto[] | undefined {
    return this._data;
  }
  set data(value: UserDto[] | undefined) {
    this._data = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    UsersListResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): UsersListResponse.AsObject {
    return {
      total: this.total,
      data: (this.data || []).map(m => m.toObject())
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): UsersListResponse.AsProtobufJSON {
    return {
      total: this.total,
      data: (this.data || []).map(m => m.toProtobufJSON(options))
    };
  }
}
export module UsersListResponse {
  /**
   * Standard JavaScript object representation for UsersListResponse
   */
  export interface AsObject {
    total: number;
    data?: UserDto.AsObject[];
  }

  /**
   * Protobuf JSON representation for UsersListResponse
   */
  export interface AsProtobufJSON {
    total: number;
    data: UserDto.AsProtobufJSON[] | null;
  }
}

/**
 * Message implementation for epicore.admin.UserDto
 */
export class UserDto implements GrpcMessage {
  static id = 'epicore.admin.UserDto';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new UserDto();
    UserDto.deserializeBinaryFromReader(instance, new BinaryReader(bytes));
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: UserDto) {
    _instance.id = _instance.id || 0;
    _instance.firstName = _instance.firstName || '';
    _instance.lastName = _instance.lastName || '';
    _instance.email = _instance.email || '';
    _instance.username = _instance.username || '';
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: UserDto,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.id = _reader.readInt32();
          break;
        case 2:
          _instance.firstName = _reader.readString();
          break;
        case 3:
          _instance.lastName = _reader.readString();
          break;
        case 4:
          _instance.email = _reader.readString();
          break;
        case 5:
          _instance.username = _reader.readString();
          break;
        default:
          _reader.skipField();
      }
    }

    UserDto.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(_instance: UserDto, _writer: BinaryWriter) {
    if (_instance.id) {
      _writer.writeInt32(1, _instance.id);
    }
    if (_instance.firstName) {
      _writer.writeString(2, _instance.firstName);
    }
    if (_instance.lastName) {
      _writer.writeString(3, _instance.lastName);
    }
    if (_instance.email) {
      _writer.writeString(4, _instance.email);
    }
    if (_instance.username) {
      _writer.writeString(5, _instance.username);
    }
  }

  private _id: number;
  private _firstName: string;
  private _lastName: string;
  private _email: string;
  private _username: string;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of UserDto to deeply clone from
   */
  constructor(_value?: RecursivePartial<UserDto.AsObject>) {
    _value = _value || {};
    this.id = _value.id;
    this.firstName = _value.firstName;
    this.lastName = _value.lastName;
    this.email = _value.email;
    this.username = _value.username;
    UserDto.refineValues(this);
  }
  get id(): number {
    return this._id;
  }
  set id(value: number) {
    this._id = value;
  }
  get firstName(): string {
    return this._firstName;
  }
  set firstName(value: string) {
    this._firstName = value;
  }
  get lastName(): string {
    return this._lastName;
  }
  set lastName(value: string) {
    this._lastName = value;
  }
  get email(): string {
    return this._email;
  }
  set email(value: string) {
    this._email = value;
  }
  get username(): string {
    return this._username;
  }
  set username(value: string) {
    this._username = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    UserDto.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): UserDto.AsObject {
    return {
      id: this.id,
      firstName: this.firstName,
      lastName: this.lastName,
      email: this.email,
      username: this.username
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): UserDto.AsProtobufJSON {
    return {
      id: this.id,
      firstName: this.firstName,
      lastName: this.lastName,
      email: this.email,
      username: this.username
    };
  }
}
export module UserDto {
  /**
   * Standard JavaScript object representation for UserDto
   */
  export interface AsObject {
    id: number;
    firstName: string;
    lastName: string;
    email: string;
    username: string;
  }

  /**
   * Protobuf JSON representation for UserDto
   */
  export interface AsProtobufJSON {
    id: number;
    firstName: string;
    lastName: string;
    email: string;
    username: string;
  }
}

/**
 * Message implementation for epicore.admin.UsersListRequest
 */
export class UsersListRequest implements GrpcMessage {
  static id = 'epicore.admin.UsersListRequest';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new UsersListRequest();
    UsersListRequest.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: UsersListRequest) {
    _instance.page = _instance.page || 0;
    _instance.pageSize = _instance.pageSize || 0;
    _instance.search = _instance.search || '';
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: UsersListRequest,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.page = _reader.readInt32();
          break;
        case 2:
          _instance.pageSize = _reader.readInt32();
          break;
        case 3:
          _instance.search = _reader.readString();
          break;
        default:
          _reader.skipField();
      }
    }

    UsersListRequest.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: UsersListRequest,
    _writer: BinaryWriter
  ) {
    if (_instance.page) {
      _writer.writeInt32(1, _instance.page);
    }
    if (_instance.pageSize) {
      _writer.writeInt32(2, _instance.pageSize);
    }
    if (_instance.search) {
      _writer.writeString(3, _instance.search);
    }
  }

  private _page: number;
  private _pageSize: number;
  private _search: string;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of UsersListRequest to deeply clone from
   */
  constructor(_value?: RecursivePartial<UsersListRequest.AsObject>) {
    _value = _value || {};
    this.page = _value.page;
    this.pageSize = _value.pageSize;
    this.search = _value.search;
    UsersListRequest.refineValues(this);
  }
  get page(): number {
    return this._page;
  }
  set page(value: number) {
    this._page = value;
  }
  get pageSize(): number {
    return this._pageSize;
  }
  set pageSize(value: number) {
    this._pageSize = value;
  }
  get search(): string {
    return this._search;
  }
  set search(value: string) {
    this._search = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    UsersListRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): UsersListRequest.AsObject {
    return {
      page: this.page,
      pageSize: this.pageSize,
      search: this.search
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): UsersListRequest.AsProtobufJSON {
    return {
      page: this.page,
      pageSize: this.pageSize,
      search: this.search
    };
  }
}
export module UsersListRequest {
  /**
   * Standard JavaScript object representation for UsersListRequest
   */
  export interface AsObject {
    page: number;
    pageSize: number;
    search: string;
  }

  /**
   * Protobuf JSON representation for UsersListRequest
   */
  export interface AsProtobufJSON {
    page: number;
    pageSize: number;
    search: string;
  }
}

/**
 * Message implementation for epicore.admin.GetUserRequest
 */
export class GetUserRequest implements GrpcMessage {
  static id = 'epicore.admin.GetUserRequest';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new GetUserRequest();
    GetUserRequest.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: GetUserRequest) {
    _instance.id = _instance.id || 0;
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: GetUserRequest,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.id = _reader.readInt32();
          break;
        default:
          _reader.skipField();
      }
    }

    GetUserRequest.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: GetUserRequest,
    _writer: BinaryWriter
  ) {
    if (_instance.id) {
      _writer.writeInt32(1, _instance.id);
    }
  }

  private _id: number;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of GetUserRequest to deeply clone from
   */
  constructor(_value?: RecursivePartial<GetUserRequest.AsObject>) {
    _value = _value || {};
    this.id = _value.id;
    GetUserRequest.refineValues(this);
  }
  get id(): number {
    return this._id;
  }
  set id(value: number) {
    this._id = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    GetUserRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): GetUserRequest.AsObject {
    return {
      id: this.id
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): GetUserRequest.AsProtobufJSON {
    return {
      id: this.id
    };
  }
}
export module GetUserRequest {
  /**
   * Standard JavaScript object representation for GetUserRequest
   */
  export interface AsObject {
    id: number;
  }

  /**
   * Protobuf JSON representation for GetUserRequest
   */
  export interface AsProtobufJSON {
    id: number;
  }
}

/**
 * Message implementation for epicore.admin.GetUserResponse
 */
export class GetUserResponse implements GrpcMessage {
  static id = 'epicore.admin.GetUserResponse';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new GetUserResponse();
    GetUserResponse.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: GetUserResponse) {
    _instance.id = _instance.id || 0;
    _instance.username = _instance.username || '';
    _instance.email = _instance.email || '';
    _instance.firstName = _instance.firstName || '';
    _instance.lastName = _instance.lastName || '';
    _instance.phoneNumber = _instance.phoneNumber || '';
    _instance.disabled = _instance.disabled || false;
    _instance.userGroups = _instance.userGroups || [];
    _instance.roles = _instance.roles || [];
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: GetUserResponse,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.id = _reader.readInt32();
          break;
        case 2:
          _instance.username = _reader.readString();
          break;
        case 3:
          _instance.email = _reader.readString();
          break;
        case 4:
          _instance.firstName = _reader.readString();
          break;
        case 5:
          _instance.lastName = _reader.readString();
          break;
        case 6:
          _instance.phoneNumber = _reader.readString();
          break;
        case 7:
          _instance.disabled = _reader.readBool();
          break;
        case 8:
          const messageInitializer8 = new UserGroupMessage();
          _reader.readMessage(
            messageInitializer8,
            UserGroupMessage.deserializeBinaryFromReader
          );
          (_instance.userGroups = _instance.userGroups || []).push(
            messageInitializer8
          );
          break;
        case 9:
          (_instance.roles = _instance.roles || []).push(_reader.readString());
          break;
        default:
          _reader.skipField();
      }
    }

    GetUserResponse.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: GetUserResponse,
    _writer: BinaryWriter
  ) {
    if (_instance.id) {
      _writer.writeInt32(1, _instance.id);
    }
    if (_instance.username) {
      _writer.writeString(2, _instance.username);
    }
    if (_instance.email) {
      _writer.writeString(3, _instance.email);
    }
    if (_instance.firstName) {
      _writer.writeString(4, _instance.firstName);
    }
    if (_instance.lastName) {
      _writer.writeString(5, _instance.lastName);
    }
    if (_instance.phoneNumber) {
      _writer.writeString(6, _instance.phoneNumber);
    }
    if (_instance.disabled) {
      _writer.writeBool(7, _instance.disabled);
    }
    if (_instance.userGroups && _instance.userGroups.length) {
      _writer.writeRepeatedMessage(
        8,
        _instance.userGroups as any,
        UserGroupMessage.serializeBinaryToWriter
      );
    }
    if (_instance.roles && _instance.roles.length) {
      _writer.writeRepeatedString(9, _instance.roles);
    }
  }

  private _id: number;
  private _username: string;
  private _email: string;
  private _firstName: string;
  private _lastName: string;
  private _phoneNumber: string;
  private _disabled: boolean;
  private _userGroups?: UserGroupMessage[];
  private _roles: string[];

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of GetUserResponse to deeply clone from
   */
  constructor(_value?: RecursivePartial<GetUserResponse.AsObject>) {
    _value = _value || {};
    this.id = _value.id;
    this.username = _value.username;
    this.email = _value.email;
    this.firstName = _value.firstName;
    this.lastName = _value.lastName;
    this.phoneNumber = _value.phoneNumber;
    this.disabled = _value.disabled;
    this.userGroups = (_value.userGroups || []).map(
      m => new UserGroupMessage(m)
    );
    this.roles = (_value.roles || []).slice();
    GetUserResponse.refineValues(this);
  }
  get id(): number {
    return this._id;
  }
  set id(value: number) {
    this._id = value;
  }
  get username(): string {
    return this._username;
  }
  set username(value: string) {
    this._username = value;
  }
  get email(): string {
    return this._email;
  }
  set email(value: string) {
    this._email = value;
  }
  get firstName(): string {
    return this._firstName;
  }
  set firstName(value: string) {
    this._firstName = value;
  }
  get lastName(): string {
    return this._lastName;
  }
  set lastName(value: string) {
    this._lastName = value;
  }
  get phoneNumber(): string {
    return this._phoneNumber;
  }
  set phoneNumber(value: string) {
    this._phoneNumber = value;
  }
  get disabled(): boolean {
    return this._disabled;
  }
  set disabled(value: boolean) {
    this._disabled = value;
  }
  get userGroups(): UserGroupMessage[] | undefined {
    return this._userGroups;
  }
  set userGroups(value: UserGroupMessage[] | undefined) {
    this._userGroups = value;
  }
  get roles(): string[] {
    return this._roles;
  }
  set roles(value: string[]) {
    this._roles = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    GetUserResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): GetUserResponse.AsObject {
    return {
      id: this.id,
      username: this.username,
      email: this.email,
      firstName: this.firstName,
      lastName: this.lastName,
      phoneNumber: this.phoneNumber,
      disabled: this.disabled,
      userGroups: (this.userGroups || []).map(m => m.toObject()),
      roles: (this.roles || []).slice()
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): GetUserResponse.AsProtobufJSON {
    return {
      id: this.id,
      username: this.username,
      email: this.email,
      firstName: this.firstName,
      lastName: this.lastName,
      phoneNumber: this.phoneNumber,
      disabled: this.disabled,
      userGroups: (this.userGroups || []).map(m => m.toProtobufJSON(options)),
      roles: (this.roles || []).slice()
    };
  }
}
export module GetUserResponse {
  /**
   * Standard JavaScript object representation for GetUserResponse
   */
  export interface AsObject {
    id: number;
    username: string;
    email: string;
    firstName: string;
    lastName: string;
    phoneNumber: string;
    disabled: boolean;
    userGroups?: UserGroupMessage.AsObject[];
    roles: string[];
  }

  /**
   * Protobuf JSON representation for GetUserResponse
   */
  export interface AsProtobufJSON {
    id: number;
    username: string;
    email: string;
    firstName: string;
    lastName: string;
    phoneNumber: string;
    disabled: boolean;
    userGroups: UserGroupMessage.AsProtobufJSON[] | null;
    roles: string[];
  }
}

/**
 * Message implementation for epicore.admin.UserGroupMessage
 */
export class UserGroupMessage implements GrpcMessage {
  static id = 'epicore.admin.UserGroupMessage';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new UserGroupMessage();
    UserGroupMessage.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: UserGroupMessage) {
    _instance.id = _instance.id || 0;
    _instance.title = _instance.title || '';
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: UserGroupMessage,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.id = _reader.readInt32();
          break;
        case 2:
          _instance.title = _reader.readString();
          break;
        default:
          _reader.skipField();
      }
    }

    UserGroupMessage.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: UserGroupMessage,
    _writer: BinaryWriter
  ) {
    if (_instance.id) {
      _writer.writeInt32(1, _instance.id);
    }
    if (_instance.title) {
      _writer.writeString(2, _instance.title);
    }
  }

  private _id: number;
  private _title: string;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of UserGroupMessage to deeply clone from
   */
  constructor(_value?: RecursivePartial<UserGroupMessage.AsObject>) {
    _value = _value || {};
    this.id = _value.id;
    this.title = _value.title;
    UserGroupMessage.refineValues(this);
  }
  get id(): number {
    return this._id;
  }
  set id(value: number) {
    this._id = value;
  }
  get title(): string {
    return this._title;
  }
  set title(value: string) {
    this._title = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    UserGroupMessage.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): UserGroupMessage.AsObject {
    return {
      id: this.id,
      title: this.title
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): UserGroupMessage.AsProtobufJSON {
    return {
      id: this.id,
      title: this.title
    };
  }
}
export module UserGroupMessage {
  /**
   * Standard JavaScript object representation for UserGroupMessage
   */
  export interface AsObject {
    id: number;
    title: string;
  }

  /**
   * Protobuf JSON representation for UserGroupMessage
   */
  export interface AsProtobufJSON {
    id: number;
    title: string;
  }
}

/**
 * Message implementation for epicore.admin.ResetPasswordRequest
 */
export class ResetPasswordRequest implements GrpcMessage {
  static id = 'epicore.admin.ResetPasswordRequest';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new ResetPasswordRequest();
    ResetPasswordRequest.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: ResetPasswordRequest) {
    _instance.id = _instance.id || 0;
    _instance.password = _instance.password || '';
    _instance.confirmPassword = _instance.confirmPassword || '';
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: ResetPasswordRequest,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.id = _reader.readInt32();
          break;
        case 2:
          _instance.password = _reader.readString();
          break;
        case 3:
          _instance.confirmPassword = _reader.readString();
          break;
        default:
          _reader.skipField();
      }
    }

    ResetPasswordRequest.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: ResetPasswordRequest,
    _writer: BinaryWriter
  ) {
    if (_instance.id) {
      _writer.writeInt32(1, _instance.id);
    }
    if (_instance.password) {
      _writer.writeString(2, _instance.password);
    }
    if (_instance.confirmPassword) {
      _writer.writeString(3, _instance.confirmPassword);
    }
  }

  private _id: number;
  private _password: string;
  private _confirmPassword: string;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of ResetPasswordRequest to deeply clone from
   */
  constructor(_value?: RecursivePartial<ResetPasswordRequest.AsObject>) {
    _value = _value || {};
    this.id = _value.id;
    this.password = _value.password;
    this.confirmPassword = _value.confirmPassword;
    ResetPasswordRequest.refineValues(this);
  }
  get id(): number {
    return this._id;
  }
  set id(value: number) {
    this._id = value;
  }
  get password(): string {
    return this._password;
  }
  set password(value: string) {
    this._password = value;
  }
  get confirmPassword(): string {
    return this._confirmPassword;
  }
  set confirmPassword(value: string) {
    this._confirmPassword = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    ResetPasswordRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): ResetPasswordRequest.AsObject {
    return {
      id: this.id,
      password: this.password,
      confirmPassword: this.confirmPassword
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): ResetPasswordRequest.AsProtobufJSON {
    return {
      id: this.id,
      password: this.password,
      confirmPassword: this.confirmPassword
    };
  }
}
export module ResetPasswordRequest {
  /**
   * Standard JavaScript object representation for ResetPasswordRequest
   */
  export interface AsObject {
    id: number;
    password: string;
    confirmPassword: string;
  }

  /**
   * Protobuf JSON representation for ResetPasswordRequest
   */
  export interface AsProtobufJSON {
    id: number;
    password: string;
    confirmPassword: string;
  }
}

/**
 * Message implementation for epicore.admin.CreateRoleRequest
 */
export class CreateRoleRequest implements GrpcMessage {
  static id = 'epicore.admin.CreateRoleRequest';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new CreateRoleRequest();
    CreateRoleRequest.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: CreateRoleRequest) {
    _instance.title = _instance.title || '';
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: CreateRoleRequest,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.title = _reader.readString();
          break;
        default:
          _reader.skipField();
      }
    }

    CreateRoleRequest.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: CreateRoleRequest,
    _writer: BinaryWriter
  ) {
    if (_instance.title) {
      _writer.writeString(1, _instance.title);
    }
  }

  private _title: string;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of CreateRoleRequest to deeply clone from
   */
  constructor(_value?: RecursivePartial<CreateRoleRequest.AsObject>) {
    _value = _value || {};
    this.title = _value.title;
    CreateRoleRequest.refineValues(this);
  }
  get title(): string {
    return this._title;
  }
  set title(value: string) {
    this._title = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    CreateRoleRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): CreateRoleRequest.AsObject {
    return {
      title: this.title
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): CreateRoleRequest.AsProtobufJSON {
    return {
      title: this.title
    };
  }
}
export module CreateRoleRequest {
  /**
   * Standard JavaScript object representation for CreateRoleRequest
   */
  export interface AsObject {
    title: string;
  }

  /**
   * Protobuf JSON representation for CreateRoleRequest
   */
  export interface AsProtobufJSON {
    title: string;
  }
}

/**
 * Message implementation for epicore.admin.UpdateRoleRequest
 */
export class UpdateRoleRequest implements GrpcMessage {
  static id = 'epicore.admin.UpdateRoleRequest';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new UpdateRoleRequest();
    UpdateRoleRequest.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: UpdateRoleRequest) {
    _instance.id = _instance.id || 0;
    _instance.title = _instance.title || '';
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: UpdateRoleRequest,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.id = _reader.readInt32();
          break;
        case 2:
          _instance.title = _reader.readString();
          break;
        default:
          _reader.skipField();
      }
    }

    UpdateRoleRequest.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: UpdateRoleRequest,
    _writer: BinaryWriter
  ) {
    if (_instance.id) {
      _writer.writeInt32(1, _instance.id);
    }
    if (_instance.title) {
      _writer.writeString(2, _instance.title);
    }
  }

  private _id: number;
  private _title: string;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of UpdateRoleRequest to deeply clone from
   */
  constructor(_value?: RecursivePartial<UpdateRoleRequest.AsObject>) {
    _value = _value || {};
    this.id = _value.id;
    this.title = _value.title;
    UpdateRoleRequest.refineValues(this);
  }
  get id(): number {
    return this._id;
  }
  set id(value: number) {
    this._id = value;
  }
  get title(): string {
    return this._title;
  }
  set title(value: string) {
    this._title = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    UpdateRoleRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): UpdateRoleRequest.AsObject {
    return {
      id: this.id,
      title: this.title
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): UpdateRoleRequest.AsProtobufJSON {
    return {
      id: this.id,
      title: this.title
    };
  }
}
export module UpdateRoleRequest {
  /**
   * Standard JavaScript object representation for UpdateRoleRequest
   */
  export interface AsObject {
    id: number;
    title: string;
  }

  /**
   * Protobuf JSON representation for UpdateRoleRequest
   */
  export interface AsProtobufJSON {
    id: number;
    title: string;
  }
}

/**
 * Message implementation for epicore.admin.DisableRoleRequest
 */
export class DisableRoleRequest implements GrpcMessage {
  static id = 'epicore.admin.DisableRoleRequest';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new DisableRoleRequest();
    DisableRoleRequest.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: DisableRoleRequest) {
    _instance.id = _instance.id || 0;
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: DisableRoleRequest,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.id = _reader.readInt32();
          break;
        default:
          _reader.skipField();
      }
    }

    DisableRoleRequest.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: DisableRoleRequest,
    _writer: BinaryWriter
  ) {
    if (_instance.id) {
      _writer.writeInt32(1, _instance.id);
    }
  }

  private _id: number;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of DisableRoleRequest to deeply clone from
   */
  constructor(_value?: RecursivePartial<DisableRoleRequest.AsObject>) {
    _value = _value || {};
    this.id = _value.id;
    DisableRoleRequest.refineValues(this);
  }
  get id(): number {
    return this._id;
  }
  set id(value: number) {
    this._id = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    DisableRoleRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): DisableRoleRequest.AsObject {
    return {
      id: this.id
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): DisableRoleRequest.AsProtobufJSON {
    return {
      id: this.id
    };
  }
}
export module DisableRoleRequest {
  /**
   * Standard JavaScript object representation for DisableRoleRequest
   */
  export interface AsObject {
    id: number;
  }

  /**
   * Protobuf JSON representation for DisableRoleRequest
   */
  export interface AsProtobufJSON {
    id: number;
  }
}

/**
 * Message implementation for epicore.admin.RoleDtoResult
 */
export class RoleDtoResult implements GrpcMessage {
  static id = 'epicore.admin.RoleDtoResult';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new RoleDtoResult();
    RoleDtoResult.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: RoleDtoResult) {
    _instance.id = _instance.id || 0;
    _instance.title = _instance.title || '';
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: RoleDtoResult,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.id = _reader.readInt32();
          break;
        case 2:
          _instance.title = _reader.readString();
          break;
        default:
          _reader.skipField();
      }
    }

    RoleDtoResult.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: RoleDtoResult,
    _writer: BinaryWriter
  ) {
    if (_instance.id) {
      _writer.writeInt32(1, _instance.id);
    }
    if (_instance.title) {
      _writer.writeString(2, _instance.title);
    }
  }

  private _id: number;
  private _title: string;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of RoleDtoResult to deeply clone from
   */
  constructor(_value?: RecursivePartial<RoleDtoResult.AsObject>) {
    _value = _value || {};
    this.id = _value.id;
    this.title = _value.title;
    RoleDtoResult.refineValues(this);
  }
  get id(): number {
    return this._id;
  }
  set id(value: number) {
    this._id = value;
  }
  get title(): string {
    return this._title;
  }
  set title(value: string) {
    this._title = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    RoleDtoResult.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): RoleDtoResult.AsObject {
    return {
      id: this.id,
      title: this.title
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): RoleDtoResult.AsProtobufJSON {
    return {
      id: this.id,
      title: this.title
    };
  }
}
export module RoleDtoResult {
  /**
   * Standard JavaScript object representation for RoleDtoResult
   */
  export interface AsObject {
    id: number;
    title: string;
  }

  /**
   * Protobuf JSON representation for RoleDtoResult
   */
  export interface AsProtobufJSON {
    id: number;
    title: string;
  }
}

/**
 * Message implementation for epicore.admin.UserRolesResponse
 */
export class UserRolesResponse implements GrpcMessage {
  static id = 'epicore.admin.UserRolesResponse';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new UserRolesResponse();
    UserRolesResponse.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: UserRolesResponse) {
    _instance.userRoles = _instance.userRoles || [];
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: UserRolesResponse,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          const messageInitializer1 = new UserRoleDto();
          _reader.readMessage(
            messageInitializer1,
            UserRoleDto.deserializeBinaryFromReader
          );
          (_instance.userRoles = _instance.userRoles || []).push(
            messageInitializer1
          );
          break;
        default:
          _reader.skipField();
      }
    }

    UserRolesResponse.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: UserRolesResponse,
    _writer: BinaryWriter
  ) {
    if (_instance.userRoles && _instance.userRoles.length) {
      _writer.writeRepeatedMessage(
        1,
        _instance.userRoles as any,
        UserRoleDto.serializeBinaryToWriter
      );
    }
  }

  private _userRoles?: UserRoleDto[];

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of UserRolesResponse to deeply clone from
   */
  constructor(_value?: RecursivePartial<UserRolesResponse.AsObject>) {
    _value = _value || {};
    this.userRoles = (_value.userRoles || []).map(m => new UserRoleDto(m));
    UserRolesResponse.refineValues(this);
  }
  get userRoles(): UserRoleDto[] | undefined {
    return this._userRoles;
  }
  set userRoles(value: UserRoleDto[] | undefined) {
    this._userRoles = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    UserRolesResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): UserRolesResponse.AsObject {
    return {
      userRoles: (this.userRoles || []).map(m => m.toObject())
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): UserRolesResponse.AsProtobufJSON {
    return {
      userRoles: (this.userRoles || []).map(m => m.toProtobufJSON(options))
    };
  }
}
export module UserRolesResponse {
  /**
   * Standard JavaScript object representation for UserRolesResponse
   */
  export interface AsObject {
    userRoles?: UserRoleDto.AsObject[];
  }

  /**
   * Protobuf JSON representation for UserRolesResponse
   */
  export interface AsProtobufJSON {
    userRoles: UserRoleDto.AsProtobufJSON[] | null;
  }
}

/**
 * Message implementation for epicore.admin.UserRoleDto
 */
export class UserRoleDto implements GrpcMessage {
  static id = 'epicore.admin.UserRoleDto';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new UserRoleDto();
    UserRoleDto.deserializeBinaryFromReader(instance, new BinaryReader(bytes));
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: UserRoleDto) {
    _instance.id = _instance.id || 0;
    _instance.title = _instance.title || '';
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: UserRoleDto,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.id = _reader.readInt32();
          break;
        case 2:
          _instance.title = _reader.readString();
          break;
        default:
          _reader.skipField();
      }
    }

    UserRoleDto.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: UserRoleDto,
    _writer: BinaryWriter
  ) {
    if (_instance.id) {
      _writer.writeInt32(1, _instance.id);
    }
    if (_instance.title) {
      _writer.writeString(2, _instance.title);
    }
  }

  private _id: number;
  private _title: string;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of UserRoleDto to deeply clone from
   */
  constructor(_value?: RecursivePartial<UserRoleDto.AsObject>) {
    _value = _value || {};
    this.id = _value.id;
    this.title = _value.title;
    UserRoleDto.refineValues(this);
  }
  get id(): number {
    return this._id;
  }
  set id(value: number) {
    this._id = value;
  }
  get title(): string {
    return this._title;
  }
  set title(value: string) {
    this._title = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    UserRoleDto.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): UserRoleDto.AsObject {
    return {
      id: this.id,
      title: this.title
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): UserRoleDto.AsProtobufJSON {
    return {
      id: this.id,
      title: this.title
    };
  }
}
export module UserRoleDto {
  /**
   * Standard JavaScript object representation for UserRoleDto
   */
  export interface AsObject {
    id: number;
    title: string;
  }

  /**
   * Protobuf JSON representation for UserRoleDto
   */
  export interface AsProtobufJSON {
    id: number;
    title: string;
  }
}

/**
 * Message implementation for epicore.admin.UserGroupsResponse
 */
export class UserGroupsResponse implements GrpcMessage {
  static id = 'epicore.admin.UserGroupsResponse';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new UserGroupsResponse();
    UserGroupsResponse.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: UserGroupsResponse) {
    _instance.userGroups = _instance.userGroups || [];
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: UserGroupsResponse,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          const messageInitializer1 = new UserGroupDto();
          _reader.readMessage(
            messageInitializer1,
            UserGroupDto.deserializeBinaryFromReader
          );
          (_instance.userGroups = _instance.userGroups || []).push(
            messageInitializer1
          );
          break;
        default:
          _reader.skipField();
      }
    }

    UserGroupsResponse.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: UserGroupsResponse,
    _writer: BinaryWriter
  ) {
    if (_instance.userGroups && _instance.userGroups.length) {
      _writer.writeRepeatedMessage(
        1,
        _instance.userGroups as any,
        UserGroupDto.serializeBinaryToWriter
      );
    }
  }

  private _userGroups?: UserGroupDto[];

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of UserGroupsResponse to deeply clone from
   */
  constructor(_value?: RecursivePartial<UserGroupsResponse.AsObject>) {
    _value = _value || {};
    this.userGroups = (_value.userGroups || []).map(m => new UserGroupDto(m));
    UserGroupsResponse.refineValues(this);
  }
  get userGroups(): UserGroupDto[] | undefined {
    return this._userGroups;
  }
  set userGroups(value: UserGroupDto[] | undefined) {
    this._userGroups = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    UserGroupsResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): UserGroupsResponse.AsObject {
    return {
      userGroups: (this.userGroups || []).map(m => m.toObject())
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): UserGroupsResponse.AsProtobufJSON {
    return {
      userGroups: (this.userGroups || []).map(m => m.toProtobufJSON(options))
    };
  }
}
export module UserGroupsResponse {
  /**
   * Standard JavaScript object representation for UserGroupsResponse
   */
  export interface AsObject {
    userGroups?: UserGroupDto.AsObject[];
  }

  /**
   * Protobuf JSON representation for UserGroupsResponse
   */
  export interface AsProtobufJSON {
    userGroups: UserGroupDto.AsProtobufJSON[] | null;
  }
}

/**
 * Message implementation for epicore.admin.UserGroupDto
 */
export class UserGroupDto implements GrpcMessage {
  static id = 'epicore.admin.UserGroupDto';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new UserGroupDto();
    UserGroupDto.deserializeBinaryFromReader(instance, new BinaryReader(bytes));
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: UserGroupDto) {
    _instance.id = _instance.id || 0;
    _instance.title = _instance.title || '';
    _instance.disabled = _instance.disabled || false;
    _instance.roles = _instance.roles || [];
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: UserGroupDto,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.id = _reader.readInt32();
          break;
        case 2:
          _instance.title = _reader.readString();
          break;
        case 3:
          _instance.disabled = _reader.readBool();
          break;
        case 4:
          (_instance.roles = _instance.roles || []).push(
            ...(_reader.readPackedInt32() || [])
          );
          break;
        default:
          _reader.skipField();
      }
    }

    UserGroupDto.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: UserGroupDto,
    _writer: BinaryWriter
  ) {
    if (_instance.id) {
      _writer.writeInt32(1, _instance.id);
    }
    if (_instance.title) {
      _writer.writeString(2, _instance.title);
    }
    if (_instance.disabled) {
      _writer.writeBool(3, _instance.disabled);
    }
    if (_instance.roles && _instance.roles.length) {
      _writer.writePackedInt32(4, _instance.roles);
    }
  }

  private _id: number;
  private _title: string;
  private _disabled: boolean;
  private _roles: number[];

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of UserGroupDto to deeply clone from
   */
  constructor(_value?: RecursivePartial<UserGroupDto.AsObject>) {
    _value = _value || {};
    this.id = _value.id;
    this.title = _value.title;
    this.disabled = _value.disabled;
    this.roles = (_value.roles || []).slice();
    UserGroupDto.refineValues(this);
  }
  get id(): number {
    return this._id;
  }
  set id(value: number) {
    this._id = value;
  }
  get title(): string {
    return this._title;
  }
  set title(value: string) {
    this._title = value;
  }
  get disabled(): boolean {
    return this._disabled;
  }
  set disabled(value: boolean) {
    this._disabled = value;
  }
  get roles(): number[] {
    return this._roles;
  }
  set roles(value: number[]) {
    this._roles = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    UserGroupDto.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): UserGroupDto.AsObject {
    return {
      id: this.id,
      title: this.title,
      disabled: this.disabled,
      roles: (this.roles || []).slice()
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): UserGroupDto.AsProtobufJSON {
    return {
      id: this.id,
      title: this.title,
      disabled: this.disabled,
      roles: (this.roles || []).slice()
    };
  }
}
export module UserGroupDto {
  /**
   * Standard JavaScript object representation for UserGroupDto
   */
  export interface AsObject {
    id: number;
    title: string;
    disabled: boolean;
    roles: number[];
  }

  /**
   * Protobuf JSON representation for UserGroupDto
   */
  export interface AsProtobufJSON {
    id: number;
    title: string;
    disabled: boolean;
    roles: number[];
  }
}

/**
 * Message implementation for epicore.admin.CreateGroupRequest
 */
export class CreateGroupRequest implements GrpcMessage {
  static id = 'epicore.admin.CreateGroupRequest';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new CreateGroupRequest();
    CreateGroupRequest.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: CreateGroupRequest) {
    _instance.title = _instance.title || '';
    _instance.roles = _instance.roles || [];
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: CreateGroupRequest,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.title = _reader.readString();
          break;
        case 2:
          (_instance.roles = _instance.roles || []).push(
            ...(_reader.readPackedInt32() || [])
          );
          break;
        default:
          _reader.skipField();
      }
    }

    CreateGroupRequest.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: CreateGroupRequest,
    _writer: BinaryWriter
  ) {
    if (_instance.title) {
      _writer.writeString(1, _instance.title);
    }
    if (_instance.roles && _instance.roles.length) {
      _writer.writePackedInt32(2, _instance.roles);
    }
  }

  private _title: string;
  private _roles: number[];

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of CreateGroupRequest to deeply clone from
   */
  constructor(_value?: RecursivePartial<CreateGroupRequest.AsObject>) {
    _value = _value || {};
    this.title = _value.title;
    this.roles = (_value.roles || []).slice();
    CreateGroupRequest.refineValues(this);
  }
  get title(): string {
    return this._title;
  }
  set title(value: string) {
    this._title = value;
  }
  get roles(): number[] {
    return this._roles;
  }
  set roles(value: number[]) {
    this._roles = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    CreateGroupRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): CreateGroupRequest.AsObject {
    return {
      title: this.title,
      roles: (this.roles || []).slice()
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): CreateGroupRequest.AsProtobufJSON {
    return {
      title: this.title,
      roles: (this.roles || []).slice()
    };
  }
}
export module CreateGroupRequest {
  /**
   * Standard JavaScript object representation for CreateGroupRequest
   */
  export interface AsObject {
    title: string;
    roles: number[];
  }

  /**
   * Protobuf JSON representation for CreateGroupRequest
   */
  export interface AsProtobufJSON {
    title: string;
    roles: number[];
  }
}

/**
 * Message implementation for epicore.admin.UpdateGroupRequest
 */
export class UpdateGroupRequest implements GrpcMessage {
  static id = 'epicore.admin.UpdateGroupRequest';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new UpdateGroupRequest();
    UpdateGroupRequest.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: UpdateGroupRequest) {
    _instance.id = _instance.id || 0;
    _instance.title = _instance.title || '';
    _instance.roles = _instance.roles || [];
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: UpdateGroupRequest,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.id = _reader.readInt32();
          break;
        case 2:
          _instance.title = _reader.readString();
          break;
        case 3:
          (_instance.roles = _instance.roles || []).push(
            ...(_reader.readPackedInt32() || [])
          );
          break;
        default:
          _reader.skipField();
      }
    }

    UpdateGroupRequest.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: UpdateGroupRequest,
    _writer: BinaryWriter
  ) {
    if (_instance.id) {
      _writer.writeInt32(1, _instance.id);
    }
    if (_instance.title) {
      _writer.writeString(2, _instance.title);
    }
    if (_instance.roles && _instance.roles.length) {
      _writer.writePackedInt32(3, _instance.roles);
    }
  }

  private _id: number;
  private _title: string;
  private _roles: number[];

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of UpdateGroupRequest to deeply clone from
   */
  constructor(_value?: RecursivePartial<UpdateGroupRequest.AsObject>) {
    _value = _value || {};
    this.id = _value.id;
    this.title = _value.title;
    this.roles = (_value.roles || []).slice();
    UpdateGroupRequest.refineValues(this);
  }
  get id(): number {
    return this._id;
  }
  set id(value: number) {
    this._id = value;
  }
  get title(): string {
    return this._title;
  }
  set title(value: string) {
    this._title = value;
  }
  get roles(): number[] {
    return this._roles;
  }
  set roles(value: number[]) {
    this._roles = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    UpdateGroupRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): UpdateGroupRequest.AsObject {
    return {
      id: this.id,
      title: this.title,
      roles: (this.roles || []).slice()
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): UpdateGroupRequest.AsProtobufJSON {
    return {
      id: this.id,
      title: this.title,
      roles: (this.roles || []).slice()
    };
  }
}
export module UpdateGroupRequest {
  /**
   * Standard JavaScript object representation for UpdateGroupRequest
   */
  export interface AsObject {
    id: number;
    title: string;
    roles: number[];
  }

  /**
   * Protobuf JSON representation for UpdateGroupRequest
   */
  export interface AsProtobufJSON {
    id: number;
    title: string;
    roles: number[];
  }
}

/**
 * Message implementation for epicore.admin.DisableGroupStatusRequest
 */
export class DisableGroupStatusRequest implements GrpcMessage {
  static id = 'epicore.admin.DisableGroupStatusRequest';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new DisableGroupStatusRequest();
    DisableGroupStatusRequest.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: DisableGroupStatusRequest) {
    _instance.id = _instance.id || 0;
    _instance.status = _instance.status || false;
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: DisableGroupStatusRequest,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.id = _reader.readInt32();
          break;
        case 2:
          _instance.status = _reader.readBool();
          break;
        default:
          _reader.skipField();
      }
    }

    DisableGroupStatusRequest.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: DisableGroupStatusRequest,
    _writer: BinaryWriter
  ) {
    if (_instance.id) {
      _writer.writeInt32(1, _instance.id);
    }
    if (_instance.status) {
      _writer.writeBool(2, _instance.status);
    }
  }

  private _id: number;
  private _status: boolean;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of DisableGroupStatusRequest to deeply clone from
   */
  constructor(_value?: RecursivePartial<DisableGroupStatusRequest.AsObject>) {
    _value = _value || {};
    this.id = _value.id;
    this.status = _value.status;
    DisableGroupStatusRequest.refineValues(this);
  }
  get id(): number {
    return this._id;
  }
  set id(value: number) {
    this._id = value;
  }
  get status(): boolean {
    return this._status;
  }
  set status(value: boolean) {
    this._status = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    DisableGroupStatusRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): DisableGroupStatusRequest.AsObject {
    return {
      id: this.id,
      status: this.status
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): DisableGroupStatusRequest.AsProtobufJSON {
    return {
      id: this.id,
      status: this.status
    };
  }
}
export module DisableGroupStatusRequest {
  /**
   * Standard JavaScript object representation for DisableGroupStatusRequest
   */
  export interface AsObject {
    id: number;
    status: boolean;
  }

  /**
   * Protobuf JSON representation for DisableGroupStatusRequest
   */
  export interface AsProtobufJSON {
    id: number;
    status: boolean;
  }
}

/**
 * Message implementation for epicore.admin.GetAddPlantPrerequisitesResponse
 */
export class GetAddPlantPrerequisitesResponse implements GrpcMessage {
  static id = 'epicore.admin.GetAddPlantPrerequisitesResponse';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new GetAddPlantPrerequisitesResponse();
    GetAddPlantPrerequisitesResponse.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: GetAddPlantPrerequisitesResponse) {
    _instance.externalServiceName = _instance.externalServiceName || [];
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: GetAddPlantPrerequisitesResponse,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          (_instance.externalServiceName =
            _instance.externalServiceName || []).push(_reader.readString());
          break;
        default:
          _reader.skipField();
      }
    }

    GetAddPlantPrerequisitesResponse.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: GetAddPlantPrerequisitesResponse,
    _writer: BinaryWriter
  ) {
    if (_instance.externalServiceName && _instance.externalServiceName.length) {
      _writer.writeRepeatedString(1, _instance.externalServiceName);
    }
  }

  private _externalServiceName: string[];

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of GetAddPlantPrerequisitesResponse to deeply clone from
   */
  constructor(
    _value?: RecursivePartial<GetAddPlantPrerequisitesResponse.AsObject>
  ) {
    _value = _value || {};
    this.externalServiceName = (_value.externalServiceName || []).slice();
    GetAddPlantPrerequisitesResponse.refineValues(this);
  }
  get externalServiceName(): string[] {
    return this._externalServiceName;
  }
  set externalServiceName(value: string[]) {
    this._externalServiceName = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    GetAddPlantPrerequisitesResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): GetAddPlantPrerequisitesResponse.AsObject {
    return {
      externalServiceName: (this.externalServiceName || []).slice()
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): GetAddPlantPrerequisitesResponse.AsProtobufJSON {
    return {
      externalServiceName: (this.externalServiceName || []).slice()
    };
  }
}
export module GetAddPlantPrerequisitesResponse {
  /**
   * Standard JavaScript object representation for GetAddPlantPrerequisitesResponse
   */
  export interface AsObject {
    externalServiceName: string[];
  }

  /**
   * Protobuf JSON representation for GetAddPlantPrerequisitesResponse
   */
  export interface AsProtobufJSON {
    externalServiceName: string[];
  }
}

/**
 * Message implementation for epicore.admin.GetPlantsRequest
 */
export class GetPlantsRequest implements GrpcMessage {
  static id = 'epicore.admin.GetPlantsRequest';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new GetPlantsRequest();
    GetPlantsRequest.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: GetPlantsRequest) {
    _instance.searchText = _instance.searchText || '';
    _instance.page = _instance.page || 0;
    _instance.pageSize = _instance.pageSize || 0;
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: GetPlantsRequest,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.searchText = _reader.readString();
          break;
        case 2:
          _instance.page = _reader.readInt32();
          break;
        case 3:
          _instance.pageSize = _reader.readInt32();
          break;
        default:
          _reader.skipField();
      }
    }

    GetPlantsRequest.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: GetPlantsRequest,
    _writer: BinaryWriter
  ) {
    if (_instance.searchText) {
      _writer.writeString(1, _instance.searchText);
    }
    if (_instance.page) {
      _writer.writeInt32(2, _instance.page);
    }
    if (_instance.pageSize) {
      _writer.writeInt32(3, _instance.pageSize);
    }
  }

  private _searchText: string;
  private _page: number;
  private _pageSize: number;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of GetPlantsRequest to deeply clone from
   */
  constructor(_value?: RecursivePartial<GetPlantsRequest.AsObject>) {
    _value = _value || {};
    this.searchText = _value.searchText;
    this.page = _value.page;
    this.pageSize = _value.pageSize;
    GetPlantsRequest.refineValues(this);
  }
  get searchText(): string {
    return this._searchText;
  }
  set searchText(value: string) {
    this._searchText = value;
  }
  get page(): number {
    return this._page;
  }
  set page(value: number) {
    this._page = value;
  }
  get pageSize(): number {
    return this._pageSize;
  }
  set pageSize(value: number) {
    this._pageSize = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    GetPlantsRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): GetPlantsRequest.AsObject {
    return {
      searchText: this.searchText,
      page: this.page,
      pageSize: this.pageSize
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): GetPlantsRequest.AsProtobufJSON {
    return {
      searchText: this.searchText,
      page: this.page,
      pageSize: this.pageSize
    };
  }
}
export module GetPlantsRequest {
  /**
   * Standard JavaScript object representation for GetPlantsRequest
   */
  export interface AsObject {
    searchText: string;
    page: number;
    pageSize: number;
  }

  /**
   * Protobuf JSON representation for GetPlantsRequest
   */
  export interface AsProtobufJSON {
    searchText: string;
    page: number;
    pageSize: number;
  }
}

/**
 * Message implementation for epicore.admin.GetPlantFullDetailByUserIdRequest
 */
export class GetPlantFullDetailByUserIdRequest implements GrpcMessage {
  static id = 'epicore.admin.GetPlantFullDetailByUserIdRequest';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new GetPlantFullDetailByUserIdRequest();
    GetPlantFullDetailByUserIdRequest.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: GetPlantFullDetailByUserIdRequest) {
    _instance.userId = _instance.userId || 0;
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: GetPlantFullDetailByUserIdRequest,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.userId = _reader.readInt32();
          break;
        default:
          _reader.skipField();
      }
    }

    GetPlantFullDetailByUserIdRequest.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: GetPlantFullDetailByUserIdRequest,
    _writer: BinaryWriter
  ) {
    if (_instance.userId) {
      _writer.writeInt32(1, _instance.userId);
    }
  }

  private _userId: number;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of GetPlantFullDetailByUserIdRequest to deeply clone from
   */
  constructor(
    _value?: RecursivePartial<GetPlantFullDetailByUserIdRequest.AsObject>
  ) {
    _value = _value || {};
    this.userId = _value.userId;
    GetPlantFullDetailByUserIdRequest.refineValues(this);
  }
  get userId(): number {
    return this._userId;
  }
  set userId(value: number) {
    this._userId = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    GetPlantFullDetailByUserIdRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): GetPlantFullDetailByUserIdRequest.AsObject {
    return {
      userId: this.userId
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): GetPlantFullDetailByUserIdRequest.AsProtobufJSON {
    return {
      userId: this.userId
    };
  }
}
export module GetPlantFullDetailByUserIdRequest {
  /**
   * Standard JavaScript object representation for GetPlantFullDetailByUserIdRequest
   */
  export interface AsObject {
    userId: number;
  }

  /**
   * Protobuf JSON representation for GetPlantFullDetailByUserIdRequest
   */
  export interface AsProtobufJSON {
    userId: number;
  }
}

/**
 * Message implementation for epicore.admin.PlantFullDetailListResponse
 */
export class PlantFullDetailListResponse implements GrpcMessage {
  static id = 'epicore.admin.PlantFullDetailListResponse';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new PlantFullDetailListResponse();
    PlantFullDetailListResponse.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: PlantFullDetailListResponse) {
    _instance.plantsFullDetailResponse =
      _instance.plantsFullDetailResponse || [];
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: PlantFullDetailListResponse,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          const messageInitializer1 = new PlantFullDetailResponse();
          _reader.readMessage(
            messageInitializer1,
            PlantFullDetailResponse.deserializeBinaryFromReader
          );
          (_instance.plantsFullDetailResponse =
            _instance.plantsFullDetailResponse || []).push(messageInitializer1);
          break;
        default:
          _reader.skipField();
      }
    }

    PlantFullDetailListResponse.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: PlantFullDetailListResponse,
    _writer: BinaryWriter
  ) {
    if (
      _instance.plantsFullDetailResponse &&
      _instance.plantsFullDetailResponse.length
    ) {
      _writer.writeRepeatedMessage(
        1,
        _instance.plantsFullDetailResponse as any,
        PlantFullDetailResponse.serializeBinaryToWriter
      );
    }
  }

  private _plantsFullDetailResponse?: PlantFullDetailResponse[];

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of PlantFullDetailListResponse to deeply clone from
   */
  constructor(_value?: RecursivePartial<PlantFullDetailListResponse.AsObject>) {
    _value = _value || {};
    this.plantsFullDetailResponse = (_value.plantsFullDetailResponse || []).map(
      m => new PlantFullDetailResponse(m)
    );
    PlantFullDetailListResponse.refineValues(this);
  }
  get plantsFullDetailResponse(): PlantFullDetailResponse[] | undefined {
    return this._plantsFullDetailResponse;
  }
  set plantsFullDetailResponse(value: PlantFullDetailResponse[] | undefined) {
    this._plantsFullDetailResponse = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    PlantFullDetailListResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): PlantFullDetailListResponse.AsObject {
    return {
      plantsFullDetailResponse: (this.plantsFullDetailResponse || []).map(m =>
        m.toObject()
      )
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): PlantFullDetailListResponse.AsProtobufJSON {
    return {
      plantsFullDetailResponse: (this.plantsFullDetailResponse || []).map(m =>
        m.toProtobufJSON(options)
      )
    };
  }
}
export module PlantFullDetailListResponse {
  /**
   * Standard JavaScript object representation for PlantFullDetailListResponse
   */
  export interface AsObject {
    plantsFullDetailResponse?: PlantFullDetailResponse.AsObject[];
  }

  /**
   * Protobuf JSON representation for PlantFullDetailListResponse
   */
  export interface AsProtobufJSON {
    plantsFullDetailResponse: PlantFullDetailResponse.AsProtobufJSON[] | null;
  }
}

/**
 * Message implementation for epicore.admin.GePlantFullDetailByIdRequest
 */
export class GePlantFullDetailByIdRequest implements GrpcMessage {
  static id = 'epicore.admin.GePlantFullDetailByIdRequest';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new GePlantFullDetailByIdRequest();
    GePlantFullDetailByIdRequest.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: GePlantFullDetailByIdRequest) {
    _instance.id = _instance.id || 0;
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: GePlantFullDetailByIdRequest,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.id = _reader.readInt32();
          break;
        default:
          _reader.skipField();
      }
    }

    GePlantFullDetailByIdRequest.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: GePlantFullDetailByIdRequest,
    _writer: BinaryWriter
  ) {
    if (_instance.id) {
      _writer.writeInt32(1, _instance.id);
    }
  }

  private _id: number;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of GePlantFullDetailByIdRequest to deeply clone from
   */
  constructor(
    _value?: RecursivePartial<GePlantFullDetailByIdRequest.AsObject>
  ) {
    _value = _value || {};
    this.id = _value.id;
    GePlantFullDetailByIdRequest.refineValues(this);
  }
  get id(): number {
    return this._id;
  }
  set id(value: number) {
    this._id = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    GePlantFullDetailByIdRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): GePlantFullDetailByIdRequest.AsObject {
    return {
      id: this.id
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): GePlantFullDetailByIdRequest.AsProtobufJSON {
    return {
      id: this.id
    };
  }
}
export module GePlantFullDetailByIdRequest {
  /**
   * Standard JavaScript object representation for GePlantFullDetailByIdRequest
   */
  export interface AsObject {
    id: number;
  }

  /**
   * Protobuf JSON representation for GePlantFullDetailByIdRequest
   */
  export interface AsProtobufJSON {
    id: number;
  }
}

/**
 * Message implementation for epicore.admin.PlantFullDetailResponse
 */
export class PlantFullDetailResponse implements GrpcMessage {
  static id = 'epicore.admin.PlantFullDetailResponse';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new PlantFullDetailResponse();
    PlantFullDetailResponse.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: PlantFullDetailResponse) {
    _instance.plantInfo = _instance.plantInfo || undefined;
    _instance.inverters = _instance.inverters || [];
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: PlantFullDetailResponse,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.plantInfo = new PlantResponse();
          _reader.readMessage(
            _instance.plantInfo,
            PlantResponse.deserializeBinaryFromReader
          );
          break;
        case 2:
          const messageInitializer2 = new PlantInvertersInfo();
          _reader.readMessage(
            messageInitializer2,
            PlantInvertersInfo.deserializeBinaryFromReader
          );
          (_instance.inverters = _instance.inverters || []).push(
            messageInitializer2
          );
          break;
        default:
          _reader.skipField();
      }
    }

    PlantFullDetailResponse.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: PlantFullDetailResponse,
    _writer: BinaryWriter
  ) {
    if (_instance.plantInfo) {
      _writer.writeMessage(
        1,
        _instance.plantInfo as any,
        PlantResponse.serializeBinaryToWriter
      );
    }
    if (_instance.inverters && _instance.inverters.length) {
      _writer.writeRepeatedMessage(
        2,
        _instance.inverters as any,
        PlantInvertersInfo.serializeBinaryToWriter
      );
    }
  }

  private _plantInfo?: PlantResponse;
  private _inverters?: PlantInvertersInfo[];

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of PlantFullDetailResponse to deeply clone from
   */
  constructor(_value?: RecursivePartial<PlantFullDetailResponse.AsObject>) {
    _value = _value || {};
    this.plantInfo = _value.plantInfo
      ? new PlantResponse(_value.plantInfo)
      : undefined;
    this.inverters = (_value.inverters || []).map(
      m => new PlantInvertersInfo(m)
    );
    PlantFullDetailResponse.refineValues(this);
  }
  get plantInfo(): PlantResponse | undefined {
    return this._plantInfo;
  }
  set plantInfo(value: PlantResponse | undefined) {
    this._plantInfo = value;
  }
  get inverters(): PlantInvertersInfo[] | undefined {
    return this._inverters;
  }
  set inverters(value: PlantInvertersInfo[] | undefined) {
    this._inverters = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    PlantFullDetailResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): PlantFullDetailResponse.AsObject {
    return {
      plantInfo: this.plantInfo ? this.plantInfo.toObject() : undefined,
      inverters: (this.inverters || []).map(m => m.toObject())
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): PlantFullDetailResponse.AsProtobufJSON {
    return {
      plantInfo: this.plantInfo ? this.plantInfo.toProtobufJSON(options) : null,
      inverters: (this.inverters || []).map(m => m.toProtobufJSON(options))
    };
  }
}
export module PlantFullDetailResponse {
  /**
   * Standard JavaScript object representation for PlantFullDetailResponse
   */
  export interface AsObject {
    plantInfo?: PlantResponse.AsObject;
    inverters?: PlantInvertersInfo.AsObject[];
  }

  /**
   * Protobuf JSON representation for PlantFullDetailResponse
   */
  export interface AsProtobufJSON {
    plantInfo: PlantResponse.AsProtobufJSON | null;
    inverters: PlantInvertersInfo.AsProtobufJSON[] | null;
  }
}

/**
 * Message implementation for epicore.admin.ToggleDisablePlantRequest
 */
export class ToggleDisablePlantRequest implements GrpcMessage {
  static id = 'epicore.admin.ToggleDisablePlantRequest';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new ToggleDisablePlantRequest();
    ToggleDisablePlantRequest.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: ToggleDisablePlantRequest) {
    _instance.id = _instance.id || 0;
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: ToggleDisablePlantRequest,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.id = _reader.readInt32();
          break;
        default:
          _reader.skipField();
      }
    }

    ToggleDisablePlantRequest.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: ToggleDisablePlantRequest,
    _writer: BinaryWriter
  ) {
    if (_instance.id) {
      _writer.writeInt32(1, _instance.id);
    }
  }

  private _id: number;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of ToggleDisablePlantRequest to deeply clone from
   */
  constructor(_value?: RecursivePartial<ToggleDisablePlantRequest.AsObject>) {
    _value = _value || {};
    this.id = _value.id;
    ToggleDisablePlantRequest.refineValues(this);
  }
  get id(): number {
    return this._id;
  }
  set id(value: number) {
    this._id = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    ToggleDisablePlantRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): ToggleDisablePlantRequest.AsObject {
    return {
      id: this.id
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): ToggleDisablePlantRequest.AsProtobufJSON {
    return {
      id: this.id
    };
  }
}
export module ToggleDisablePlantRequest {
  /**
   * Standard JavaScript object representation for ToggleDisablePlantRequest
   */
  export interface AsObject {
    id: number;
  }

  /**
   * Protobuf JSON representation for ToggleDisablePlantRequest
   */
  export interface AsProtobufJSON {
    id: number;
  }
}

/**
 * Message implementation for epicore.admin.ToggleDisablePlantResponse
 */
export class ToggleDisablePlantResponse implements GrpcMessage {
  static id = 'epicore.admin.ToggleDisablePlantResponse';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new ToggleDisablePlantResponse();
    ToggleDisablePlantResponse.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: ToggleDisablePlantResponse) {
    _instance.currentStatus = _instance.currentStatus || false;
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: ToggleDisablePlantResponse,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.currentStatus = _reader.readBool();
          break;
        default:
          _reader.skipField();
      }
    }

    ToggleDisablePlantResponse.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: ToggleDisablePlantResponse,
    _writer: BinaryWriter
  ) {
    if (_instance.currentStatus) {
      _writer.writeBool(1, _instance.currentStatus);
    }
  }

  private _currentStatus: boolean;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of ToggleDisablePlantResponse to deeply clone from
   */
  constructor(_value?: RecursivePartial<ToggleDisablePlantResponse.AsObject>) {
    _value = _value || {};
    this.currentStatus = _value.currentStatus;
    ToggleDisablePlantResponse.refineValues(this);
  }
  get currentStatus(): boolean {
    return this._currentStatus;
  }
  set currentStatus(value: boolean) {
    this._currentStatus = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    ToggleDisablePlantResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): ToggleDisablePlantResponse.AsObject {
    return {
      currentStatus: this.currentStatus
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): ToggleDisablePlantResponse.AsProtobufJSON {
    return {
      currentStatus: this.currentStatus
    };
  }
}
export module ToggleDisablePlantResponse {
  /**
   * Standard JavaScript object representation for ToggleDisablePlantResponse
   */
  export interface AsObject {
    currentStatus: boolean;
  }

  /**
   * Protobuf JSON representation for ToggleDisablePlantResponse
   */
  export interface AsProtobufJSON {
    currentStatus: boolean;
  }
}

/**
 * Message implementation for epicore.admin.NewPlantRequest
 */
export class NewPlantRequest implements GrpcMessage {
  static id = 'epicore.admin.NewPlantRequest';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new NewPlantRequest();
    NewPlantRequest.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: NewPlantRequest) {
    _instance.plantOwner = _instance.plantOwner || '';
    _instance.cityId = _instance.cityId || 0;
    _instance.userName = _instance.userName || '';
    _instance.email = _instance.email || '';
    _instance.phoneNumber = _instance.phoneNumber || '';
    _instance.latitude = _instance.latitude || 0;
    _instance.longitude = _instance.longitude || 0;
    _instance.plantImage = _instance.plantImage || '';
    _instance.address = _instance.address || '';
    _instance.userId = _instance.userId || 0;
    _instance.lowPriceThreshold = _instance.lowPriceThreshold || '';
    _instance.priceClass = _instance.priceClass || '';
    _instance.customerType = _instance.customerType || '';
    _instance.externalReferences = _instance.externalReferences || [];
    _instance.installationDate = _instance.installationDate || '';
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: NewPlantRequest,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.plantOwner = _reader.readString();
          break;
        case 2:
          _instance.cityId = _reader.readInt32();
          break;
        case 3:
          _instance.userName = _reader.readString();
          break;
        case 4:
          _instance.email = _reader.readString();
          break;
        case 5:
          _instance.phoneNumber = _reader.readString();
          break;
        case 6:
          _instance.latitude = _reader.readDouble();
          break;
        case 7:
          _instance.longitude = _reader.readDouble();
          break;
        case 8:
          _instance.plantImage = _reader.readString();
          break;
        case 9:
          _instance.address = _reader.readString();
          break;
        case 10:
          _instance.userId = _reader.readInt32();
          break;
        case 11:
          _instance.lowPriceThreshold = _reader.readString();
          break;
        case 12:
          _instance.priceClass = _reader.readString();
          break;
        case 13:
          _instance.customerType = _reader.readString();
          break;
        case 14:
          const messageInitializer14 = new ExternalReferences();
          _reader.readMessage(
            messageInitializer14,
            ExternalReferences.deserializeBinaryFromReader
          );
          (_instance.externalReferences =
            _instance.externalReferences || []).push(messageInitializer14);
          break;
        case 15:
          _instance.installationDate = _reader.readString();
          break;
        default:
          _reader.skipField();
      }
    }

    NewPlantRequest.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: NewPlantRequest,
    _writer: BinaryWriter
  ) {
    if (_instance.plantOwner) {
      _writer.writeString(1, _instance.plantOwner);
    }
    if (_instance.cityId) {
      _writer.writeInt32(2, _instance.cityId);
    }
    if (_instance.userName) {
      _writer.writeString(3, _instance.userName);
    }
    if (_instance.email) {
      _writer.writeString(4, _instance.email);
    }
    if (_instance.phoneNumber) {
      _writer.writeString(5, _instance.phoneNumber);
    }
    if (_instance.latitude) {
      _writer.writeDouble(6, _instance.latitude);
    }
    if (_instance.longitude) {
      _writer.writeDouble(7, _instance.longitude);
    }
    if (_instance.plantImage) {
      _writer.writeString(8, _instance.plantImage);
    }
    if (_instance.address) {
      _writer.writeString(9, _instance.address);
    }
    if (_instance.userId) {
      _writer.writeInt32(10, _instance.userId);
    }
    if (_instance.lowPriceThreshold) {
      _writer.writeString(11, _instance.lowPriceThreshold);
    }
    if (_instance.priceClass) {
      _writer.writeString(12, _instance.priceClass);
    }
    if (_instance.customerType) {
      _writer.writeString(13, _instance.customerType);
    }
    if (_instance.externalReferences && _instance.externalReferences.length) {
      _writer.writeRepeatedMessage(
        14,
        _instance.externalReferences as any,
        ExternalReferences.serializeBinaryToWriter
      );
    }
    if (_instance.installationDate) {
      _writer.writeString(15, _instance.installationDate);
    }
  }

  private _plantOwner: string;
  private _cityId: number;
  private _userName: string;
  private _email: string;
  private _phoneNumber: string;
  private _latitude: number;
  private _longitude: number;
  private _plantImage: string;
  private _address: string;
  private _userId: number;
  private _lowPriceThreshold: string;
  private _priceClass: string;
  private _customerType: string;
  private _externalReferences?: ExternalReferences[];
  private _installationDate: string;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of NewPlantRequest to deeply clone from
   */
  constructor(_value?: RecursivePartial<NewPlantRequest.AsObject>) {
    _value = _value || {};
    this.plantOwner = _value.plantOwner;
    this.cityId = _value.cityId;
    this.userName = _value.userName;
    this.email = _value.email;
    this.phoneNumber = _value.phoneNumber;
    this.latitude = _value.latitude;
    this.longitude = _value.longitude;
    this.plantImage = _value.plantImage;
    this.address = _value.address;
    this.userId = _value.userId;
    this.lowPriceThreshold = _value.lowPriceThreshold;
    this.priceClass = _value.priceClass;
    this.customerType = _value.customerType;
    this.externalReferences = (_value.externalReferences || []).map(
      m => new ExternalReferences(m)
    );
    this.installationDate = _value.installationDate;
    NewPlantRequest.refineValues(this);
  }
  get plantOwner(): string {
    return this._plantOwner;
  }
  set plantOwner(value: string) {
    this._plantOwner = value;
  }
  get cityId(): number {
    return this._cityId;
  }
  set cityId(value: number) {
    this._cityId = value;
  }
  get userName(): string {
    return this._userName;
  }
  set userName(value: string) {
    this._userName = value;
  }
  get email(): string {
    return this._email;
  }
  set email(value: string) {
    this._email = value;
  }
  get phoneNumber(): string {
    return this._phoneNumber;
  }
  set phoneNumber(value: string) {
    this._phoneNumber = value;
  }
  get latitude(): number {
    return this._latitude;
  }
  set latitude(value: number) {
    this._latitude = value;
  }
  get longitude(): number {
    return this._longitude;
  }
  set longitude(value: number) {
    this._longitude = value;
  }
  get plantImage(): string {
    return this._plantImage;
  }
  set plantImage(value: string) {
    this._plantImage = value;
  }
  get address(): string {
    return this._address;
  }
  set address(value: string) {
    this._address = value;
  }
  get userId(): number {
    return this._userId;
  }
  set userId(value: number) {
    this._userId = value;
  }
  get lowPriceThreshold(): string {
    return this._lowPriceThreshold;
  }
  set lowPriceThreshold(value: string) {
    this._lowPriceThreshold = value;
  }
  get priceClass(): string {
    return this._priceClass;
  }
  set priceClass(value: string) {
    this._priceClass = value;
  }
  get customerType(): string {
    return this._customerType;
  }
  set customerType(value: string) {
    this._customerType = value;
  }
  get externalReferences(): ExternalReferences[] | undefined {
    return this._externalReferences;
  }
  set externalReferences(value: ExternalReferences[] | undefined) {
    this._externalReferences = value;
  }
  get installationDate(): string {
    return this._installationDate;
  }
  set installationDate(value: string) {
    this._installationDate = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    NewPlantRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): NewPlantRequest.AsObject {
    return {
      plantOwner: this.plantOwner,
      cityId: this.cityId,
      userName: this.userName,
      email: this.email,
      phoneNumber: this.phoneNumber,
      latitude: this.latitude,
      longitude: this.longitude,
      plantImage: this.plantImage,
      address: this.address,
      userId: this.userId,
      lowPriceThreshold: this.lowPriceThreshold,
      priceClass: this.priceClass,
      customerType: this.customerType,
      externalReferences: (this.externalReferences || []).map(m =>
        m.toObject()
      ),
      installationDate: this.installationDate
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): NewPlantRequest.AsProtobufJSON {
    return {
      plantOwner: this.plantOwner,
      cityId: this.cityId,
      userName: this.userName,
      email: this.email,
      phoneNumber: this.phoneNumber,
      latitude: this.latitude,
      longitude: this.longitude,
      plantImage: this.plantImage,
      address: this.address,
      userId: this.userId,
      lowPriceThreshold: this.lowPriceThreshold,
      priceClass: this.priceClass,
      customerType: this.customerType,
      externalReferences: (this.externalReferences || []).map(m =>
        m.toProtobufJSON(options)
      ),
      installationDate: this.installationDate
    };
  }
}
export module NewPlantRequest {
  /**
   * Standard JavaScript object representation for NewPlantRequest
   */
  export interface AsObject {
    plantOwner: string;
    cityId: number;
    userName: string;
    email: string;
    phoneNumber: string;
    latitude: number;
    longitude: number;
    plantImage: string;
    address: string;
    userId: number;
    lowPriceThreshold: string;
    priceClass: string;
    customerType: string;
    externalReferences?: ExternalReferences.AsObject[];
    installationDate: string;
  }

  /**
   * Protobuf JSON representation for NewPlantRequest
   */
  export interface AsProtobufJSON {
    plantOwner: string;
    cityId: number;
    userName: string;
    email: string;
    phoneNumber: string;
    latitude: number;
    longitude: number;
    plantImage: string;
    address: string;
    userId: number;
    lowPriceThreshold: string;
    priceClass: string;
    customerType: string;
    externalReferences: ExternalReferences.AsProtobufJSON[] | null;
    installationDate: string;
  }
}

/**
 * Message implementation for epicore.admin.ExternalReferences
 */
export class ExternalReferences implements GrpcMessage {
  static id = 'epicore.admin.ExternalReferences';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new ExternalReferences();
    ExternalReferences.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: ExternalReferences) {
    _instance.serviceName = _instance.serviceName || '';
    _instance.serviceValue = _instance.serviceValue || '';
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: ExternalReferences,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.serviceName = _reader.readString();
          break;
        case 2:
          _instance.serviceValue = _reader.readString();
          break;
        default:
          _reader.skipField();
      }
    }

    ExternalReferences.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: ExternalReferences,
    _writer: BinaryWriter
  ) {
    if (_instance.serviceName) {
      _writer.writeString(1, _instance.serviceName);
    }
    if (_instance.serviceValue) {
      _writer.writeString(2, _instance.serviceValue);
    }
  }

  private _serviceName: string;
  private _serviceValue: string;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of ExternalReferences to deeply clone from
   */
  constructor(_value?: RecursivePartial<ExternalReferences.AsObject>) {
    _value = _value || {};
    this.serviceName = _value.serviceName;
    this.serviceValue = _value.serviceValue;
    ExternalReferences.refineValues(this);
  }
  get serviceName(): string {
    return this._serviceName;
  }
  set serviceName(value: string) {
    this._serviceName = value;
  }
  get serviceValue(): string {
    return this._serviceValue;
  }
  set serviceValue(value: string) {
    this._serviceValue = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    ExternalReferences.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): ExternalReferences.AsObject {
    return {
      serviceName: this.serviceName,
      serviceValue: this.serviceValue
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): ExternalReferences.AsProtobufJSON {
    return {
      serviceName: this.serviceName,
      serviceValue: this.serviceValue
    };
  }
}
export module ExternalReferences {
  /**
   * Standard JavaScript object representation for ExternalReferences
   */
  export interface AsObject {
    serviceName: string;
    serviceValue: string;
  }

  /**
   * Protobuf JSON representation for ExternalReferences
   */
  export interface AsProtobufJSON {
    serviceName: string;
    serviceValue: string;
  }
}

/**
 * Message implementation for epicore.admin.UpdatePlantRequest
 */
export class UpdatePlantRequest implements GrpcMessage {
  static id = 'epicore.admin.UpdatePlantRequest';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new UpdatePlantRequest();
    UpdatePlantRequest.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: UpdatePlantRequest) {
    _instance.id = _instance.id || 0;
    _instance.plantOwner = _instance.plantOwner || '';
    _instance.cityId = _instance.cityId || 0;
    _instance.email = _instance.email || '';
    _instance.phoneNumber = _instance.phoneNumber || '';
    _instance.latitude = _instance.latitude || 0;
    _instance.longitude = _instance.longitude || 0;
    _instance.plantImage = _instance.plantImage || '';
    _instance.address = _instance.address || '';
    _instance.lowPriceThreshold = _instance.lowPriceThreshold || '';
    _instance.priceClass = _instance.priceClass || '';
    _instance.customerType = _instance.customerType || '';
    _instance.externalReferences = _instance.externalReferences || [];
    _instance.installationDate = _instance.installationDate || '';
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: UpdatePlantRequest,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.id = _reader.readInt32();
          break;
        case 2:
          _instance.plantOwner = _reader.readString();
          break;
        case 3:
          _instance.cityId = _reader.readInt32();
          break;
        case 5:
          _instance.email = _reader.readString();
          break;
        case 6:
          _instance.phoneNumber = _reader.readString();
          break;
        case 7:
          _instance.latitude = _reader.readDouble();
          break;
        case 8:
          _instance.longitude = _reader.readDouble();
          break;
        case 9:
          _instance.plantImage = _reader.readString();
          break;
        case 10:
          _instance.address = _reader.readString();
          break;
        case 11:
          _instance.lowPriceThreshold = _reader.readString();
          break;
        case 12:
          _instance.priceClass = _reader.readString();
          break;
        case 13:
          _instance.customerType = _reader.readString();
          break;
        case 14:
          const messageInitializer14 = new ExternalReferences();
          _reader.readMessage(
            messageInitializer14,
            ExternalReferences.deserializeBinaryFromReader
          );
          (_instance.externalReferences =
            _instance.externalReferences || []).push(messageInitializer14);
          break;
        case 15:
          _instance.installationDate = _reader.readString();
          break;
        default:
          _reader.skipField();
      }
    }

    UpdatePlantRequest.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: UpdatePlantRequest,
    _writer: BinaryWriter
  ) {
    if (_instance.id) {
      _writer.writeInt32(1, _instance.id);
    }
    if (_instance.plantOwner) {
      _writer.writeString(2, _instance.plantOwner);
    }
    if (_instance.cityId) {
      _writer.writeInt32(3, _instance.cityId);
    }
    if (_instance.email) {
      _writer.writeString(5, _instance.email);
    }
    if (_instance.phoneNumber) {
      _writer.writeString(6, _instance.phoneNumber);
    }
    if (_instance.latitude) {
      _writer.writeDouble(7, _instance.latitude);
    }
    if (_instance.longitude) {
      _writer.writeDouble(8, _instance.longitude);
    }
    if (_instance.plantImage) {
      _writer.writeString(9, _instance.plantImage);
    }
    if (_instance.address) {
      _writer.writeString(10, _instance.address);
    }
    if (_instance.lowPriceThreshold) {
      _writer.writeString(11, _instance.lowPriceThreshold);
    }
    if (_instance.priceClass) {
      _writer.writeString(12, _instance.priceClass);
    }
    if (_instance.customerType) {
      _writer.writeString(13, _instance.customerType);
    }
    if (_instance.externalReferences && _instance.externalReferences.length) {
      _writer.writeRepeatedMessage(
        14,
        _instance.externalReferences as any,
        ExternalReferences.serializeBinaryToWriter
      );
    }
    if (_instance.installationDate) {
      _writer.writeString(15, _instance.installationDate);
    }
  }

  private _id: number;
  private _plantOwner: string;
  private _cityId: number;
  private _email: string;
  private _phoneNumber: string;
  private _latitude: number;
  private _longitude: number;
  private _plantImage: string;
  private _address: string;
  private _lowPriceThreshold: string;
  private _priceClass: string;
  private _customerType: string;
  private _externalReferences?: ExternalReferences[];
  private _installationDate: string;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of UpdatePlantRequest to deeply clone from
   */
  constructor(_value?: RecursivePartial<UpdatePlantRequest.AsObject>) {
    _value = _value || {};
    this.id = _value.id;
    this.plantOwner = _value.plantOwner;
    this.cityId = _value.cityId;
    this.email = _value.email;
    this.phoneNumber = _value.phoneNumber;
    this.latitude = _value.latitude;
    this.longitude = _value.longitude;
    this.plantImage = _value.plantImage;
    this.address = _value.address;
    this.lowPriceThreshold = _value.lowPriceThreshold;
    this.priceClass = _value.priceClass;
    this.customerType = _value.customerType;
    this.externalReferences = (_value.externalReferences || []).map(
      m => new ExternalReferences(m)
    );
    this.installationDate = _value.installationDate;
    UpdatePlantRequest.refineValues(this);
  }
  get id(): number {
    return this._id;
  }
  set id(value: number) {
    this._id = value;
  }
  get plantOwner(): string {
    return this._plantOwner;
  }
  set plantOwner(value: string) {
    this._plantOwner = value;
  }
  get cityId(): number {
    return this._cityId;
  }
  set cityId(value: number) {
    this._cityId = value;
  }
  get email(): string {
    return this._email;
  }
  set email(value: string) {
    this._email = value;
  }
  get phoneNumber(): string {
    return this._phoneNumber;
  }
  set phoneNumber(value: string) {
    this._phoneNumber = value;
  }
  get latitude(): number {
    return this._latitude;
  }
  set latitude(value: number) {
    this._latitude = value;
  }
  get longitude(): number {
    return this._longitude;
  }
  set longitude(value: number) {
    this._longitude = value;
  }
  get plantImage(): string {
    return this._plantImage;
  }
  set plantImage(value: string) {
    this._plantImage = value;
  }
  get address(): string {
    return this._address;
  }
  set address(value: string) {
    this._address = value;
  }
  get lowPriceThreshold(): string {
    return this._lowPriceThreshold;
  }
  set lowPriceThreshold(value: string) {
    this._lowPriceThreshold = value;
  }
  get priceClass(): string {
    return this._priceClass;
  }
  set priceClass(value: string) {
    this._priceClass = value;
  }
  get customerType(): string {
    return this._customerType;
  }
  set customerType(value: string) {
    this._customerType = value;
  }
  get externalReferences(): ExternalReferences[] | undefined {
    return this._externalReferences;
  }
  set externalReferences(value: ExternalReferences[] | undefined) {
    this._externalReferences = value;
  }
  get installationDate(): string {
    return this._installationDate;
  }
  set installationDate(value: string) {
    this._installationDate = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    UpdatePlantRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): UpdatePlantRequest.AsObject {
    return {
      id: this.id,
      plantOwner: this.plantOwner,
      cityId: this.cityId,
      email: this.email,
      phoneNumber: this.phoneNumber,
      latitude: this.latitude,
      longitude: this.longitude,
      plantImage: this.plantImage,
      address: this.address,
      lowPriceThreshold: this.lowPriceThreshold,
      priceClass: this.priceClass,
      customerType: this.customerType,
      externalReferences: (this.externalReferences || []).map(m =>
        m.toObject()
      ),
      installationDate: this.installationDate
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): UpdatePlantRequest.AsProtobufJSON {
    return {
      id: this.id,
      plantOwner: this.plantOwner,
      cityId: this.cityId,
      email: this.email,
      phoneNumber: this.phoneNumber,
      latitude: this.latitude,
      longitude: this.longitude,
      plantImage: this.plantImage,
      address: this.address,
      lowPriceThreshold: this.lowPriceThreshold,
      priceClass: this.priceClass,
      customerType: this.customerType,
      externalReferences: (this.externalReferences || []).map(m =>
        m.toProtobufJSON(options)
      ),
      installationDate: this.installationDate
    };
  }
}
export module UpdatePlantRequest {
  /**
   * Standard JavaScript object representation for UpdatePlantRequest
   */
  export interface AsObject {
    id: number;
    plantOwner: string;
    cityId: number;
    email: string;
    phoneNumber: string;
    latitude: number;
    longitude: number;
    plantImage: string;
    address: string;
    lowPriceThreshold: string;
    priceClass: string;
    customerType: string;
    externalReferences?: ExternalReferences.AsObject[];
    installationDate: string;
  }

  /**
   * Protobuf JSON representation for UpdatePlantRequest
   */
  export interface AsProtobufJSON {
    id: number;
    plantOwner: string;
    cityId: number;
    email: string;
    phoneNumber: string;
    latitude: number;
    longitude: number;
    plantImage: string;
    address: string;
    lowPriceThreshold: string;
    priceClass: string;
    customerType: string;
    externalReferences: ExternalReferences.AsProtobufJSON[] | null;
    installationDate: string;
  }
}

/**
 * Message implementation for epicore.admin.PlantResponse
 */
export class PlantResponse implements GrpcMessage {
  static id = 'epicore.admin.PlantResponse';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new PlantResponse();
    PlantResponse.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: PlantResponse) {
    _instance.id = _instance.id || 0;
    _instance.plantOwner = _instance.plantOwner || '';
    _instance.cityId = _instance.cityId || 0;
    _instance.userName = _instance.userName || '';
    _instance.email = _instance.email || '';
    _instance.phoneNumber = _instance.phoneNumber || '';
    _instance.latitude = _instance.latitude || '';
    _instance.longitude = _instance.longitude || '';
    _instance.plantImage = _instance.plantImage || '';
    _instance.address = _instance.address || '';
    _instance.disabled = _instance.disabled || false;
    _instance.createdAt = _instance.createdAt || undefined;
    _instance.lastUpdate = _instance.lastUpdate || undefined;
    _instance.userId = _instance.userId || 0;
    _instance.lowPriceThreshold = _instance.lowPriceThreshold || '';
    _instance.priceClass = _instance.priceClass || '';
    _instance.customerType = _instance.customerType || '';
    _instance.externalReferences = _instance.externalReferences || [];
    _instance.cityName = _instance.cityName || '';
    _instance.installationDate = _instance.installationDate || '';
    _instance.hasOfflineDevices = _instance.hasOfflineDevices || false;
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: PlantResponse,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.id = _reader.readInt32();
          break;
        case 2:
          _instance.plantOwner = _reader.readString();
          break;
        case 3:
          _instance.cityId = _reader.readInt32();
          break;
        case 4:
          _instance.userName = _reader.readString();
          break;
        case 5:
          _instance.email = _reader.readString();
          break;
        case 6:
          _instance.phoneNumber = _reader.readString();
          break;
        case 7:
          _instance.latitude = _reader.readString();
          break;
        case 8:
          _instance.longitude = _reader.readString();
          break;
        case 9:
          _instance.plantImage = _reader.readString();
          break;
        case 10:
          _instance.address = _reader.readString();
          break;
        case 11:
          _instance.disabled = _reader.readBool();
          break;
        case 12:
          _instance.createdAt = new googleProtobuf001.Timestamp();
          _reader.readMessage(
            _instance.createdAt,
            googleProtobuf001.Timestamp.deserializeBinaryFromReader
          );
          break;
        case 13:
          _instance.lastUpdate = new googleProtobuf001.Timestamp();
          _reader.readMessage(
            _instance.lastUpdate,
            googleProtobuf001.Timestamp.deserializeBinaryFromReader
          );
          break;
        case 14:
          _instance.userId = _reader.readInt32();
          break;
        case 15:
          _instance.lowPriceThreshold = _reader.readString();
          break;
        case 16:
          _instance.priceClass = _reader.readString();
          break;
        case 17:
          _instance.customerType = _reader.readString();
          break;
        case 18:
          const messageInitializer18 = new ExternalReferences();
          _reader.readMessage(
            messageInitializer18,
            ExternalReferences.deserializeBinaryFromReader
          );
          (_instance.externalReferences =
            _instance.externalReferences || []).push(messageInitializer18);
          break;
        case 19:
          _instance.cityName = _reader.readString();
          break;
        case 20:
          _instance.installationDate = _reader.readString();
          break;
        case 21:
          _instance.hasOfflineDevices = _reader.readBool();
          break;
        default:
          _reader.skipField();
      }
    }

    PlantResponse.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: PlantResponse,
    _writer: BinaryWriter
  ) {
    if (_instance.id) {
      _writer.writeInt32(1, _instance.id);
    }
    if (_instance.plantOwner) {
      _writer.writeString(2, _instance.plantOwner);
    }
    if (_instance.cityId) {
      _writer.writeInt32(3, _instance.cityId);
    }
    if (_instance.userName) {
      _writer.writeString(4, _instance.userName);
    }
    if (_instance.email) {
      _writer.writeString(5, _instance.email);
    }
    if (_instance.phoneNumber) {
      _writer.writeString(6, _instance.phoneNumber);
    }
    if (_instance.latitude) {
      _writer.writeString(7, _instance.latitude);
    }
    if (_instance.longitude) {
      _writer.writeString(8, _instance.longitude);
    }
    if (_instance.plantImage) {
      _writer.writeString(9, _instance.plantImage);
    }
    if (_instance.address) {
      _writer.writeString(10, _instance.address);
    }
    if (_instance.disabled) {
      _writer.writeBool(11, _instance.disabled);
    }
    if (_instance.createdAt) {
      _writer.writeMessage(
        12,
        _instance.createdAt as any,
        googleProtobuf001.Timestamp.serializeBinaryToWriter
      );
    }
    if (_instance.lastUpdate) {
      _writer.writeMessage(
        13,
        _instance.lastUpdate as any,
        googleProtobuf001.Timestamp.serializeBinaryToWriter
      );
    }
    if (_instance.userId) {
      _writer.writeInt32(14, _instance.userId);
    }
    if (_instance.lowPriceThreshold) {
      _writer.writeString(15, _instance.lowPriceThreshold);
    }
    if (_instance.priceClass) {
      _writer.writeString(16, _instance.priceClass);
    }
    if (_instance.customerType) {
      _writer.writeString(17, _instance.customerType);
    }
    if (_instance.externalReferences && _instance.externalReferences.length) {
      _writer.writeRepeatedMessage(
        18,
        _instance.externalReferences as any,
        ExternalReferences.serializeBinaryToWriter
      );
    }
    if (_instance.cityName) {
      _writer.writeString(19, _instance.cityName);
    }
    if (_instance.installationDate) {
      _writer.writeString(20, _instance.installationDate);
    }
    if (_instance.hasOfflineDevices) {
      _writer.writeBool(21, _instance.hasOfflineDevices);
    }
  }

  private _id: number;
  private _plantOwner: string;
  private _cityId: number;
  private _userName: string;
  private _email: string;
  private _phoneNumber: string;
  private _latitude: string;
  private _longitude: string;
  private _plantImage: string;
  private _address: string;
  private _disabled: boolean;
  private _createdAt?: googleProtobuf001.Timestamp;
  private _lastUpdate?: googleProtobuf001.Timestamp;
  private _userId: number;
  private _lowPriceThreshold: string;
  private _priceClass: string;
  private _customerType: string;
  private _externalReferences?: ExternalReferences[];
  private _cityName: string;
  private _installationDate: string;
  private _hasOfflineDevices: boolean;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of PlantResponse to deeply clone from
   */
  constructor(_value?: RecursivePartial<PlantResponse.AsObject>) {
    _value = _value || {};
    this.id = _value.id;
    this.plantOwner = _value.plantOwner;
    this.cityId = _value.cityId;
    this.userName = _value.userName;
    this.email = _value.email;
    this.phoneNumber = _value.phoneNumber;
    this.latitude = _value.latitude;
    this.longitude = _value.longitude;
    this.plantImage = _value.plantImage;
    this.address = _value.address;
    this.disabled = _value.disabled;
    this.createdAt = _value.createdAt
      ? new googleProtobuf001.Timestamp(_value.createdAt)
      : undefined;
    this.lastUpdate = _value.lastUpdate
      ? new googleProtobuf001.Timestamp(_value.lastUpdate)
      : undefined;
    this.userId = _value.userId;
    this.lowPriceThreshold = _value.lowPriceThreshold;
    this.priceClass = _value.priceClass;
    this.customerType = _value.customerType;
    this.externalReferences = (_value.externalReferences || []).map(
      m => new ExternalReferences(m)
    );
    this.cityName = _value.cityName;
    this.installationDate = _value.installationDate;
    this.hasOfflineDevices = _value.hasOfflineDevices;
    PlantResponse.refineValues(this);
  }
  get id(): number {
    return this._id;
  }
  set id(value: number) {
    this._id = value;
  }
  get plantOwner(): string {
    return this._plantOwner;
  }
  set plantOwner(value: string) {
    this._plantOwner = value;
  }
  get cityId(): number {
    return this._cityId;
  }
  set cityId(value: number) {
    this._cityId = value;
  }
  get userName(): string {
    return this._userName;
  }
  set userName(value: string) {
    this._userName = value;
  }
  get email(): string {
    return this._email;
  }
  set email(value: string) {
    this._email = value;
  }
  get phoneNumber(): string {
    return this._phoneNumber;
  }
  set phoneNumber(value: string) {
    this._phoneNumber = value;
  }
  get latitude(): string {
    return this._latitude;
  }
  set latitude(value: string) {
    this._latitude = value;
  }
  get longitude(): string {
    return this._longitude;
  }
  set longitude(value: string) {
    this._longitude = value;
  }
  get plantImage(): string {
    return this._plantImage;
  }
  set plantImage(value: string) {
    this._plantImage = value;
  }
  get address(): string {
    return this._address;
  }
  set address(value: string) {
    this._address = value;
  }
  get disabled(): boolean {
    return this._disabled;
  }
  set disabled(value: boolean) {
    this._disabled = value;
  }
  get createdAt(): googleProtobuf001.Timestamp | undefined {
    return this._createdAt;
  }
  set createdAt(value: googleProtobuf001.Timestamp | undefined) {
    this._createdAt = value;
  }
  get lastUpdate(): googleProtobuf001.Timestamp | undefined {
    return this._lastUpdate;
  }
  set lastUpdate(value: googleProtobuf001.Timestamp | undefined) {
    this._lastUpdate = value;
  }
  get userId(): number {
    return this._userId;
  }
  set userId(value: number) {
    this._userId = value;
  }
  get lowPriceThreshold(): string {
    return this._lowPriceThreshold;
  }
  set lowPriceThreshold(value: string) {
    this._lowPriceThreshold = value;
  }
  get priceClass(): string {
    return this._priceClass;
  }
  set priceClass(value: string) {
    this._priceClass = value;
  }
  get customerType(): string {
    return this._customerType;
  }
  set customerType(value: string) {
    this._customerType = value;
  }
  get externalReferences(): ExternalReferences[] | undefined {
    return this._externalReferences;
  }
  set externalReferences(value: ExternalReferences[] | undefined) {
    this._externalReferences = value;
  }
  get cityName(): string {
    return this._cityName;
  }
  set cityName(value: string) {
    this._cityName = value;
  }
  get installationDate(): string {
    return this._installationDate;
  }
  set installationDate(value: string) {
    this._installationDate = value;
  }
  get hasOfflineDevices(): boolean {
    return this._hasOfflineDevices;
  }
  set hasOfflineDevices(value: boolean) {
    this._hasOfflineDevices = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    PlantResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): PlantResponse.AsObject {
    return {
      id: this.id,
      plantOwner: this.plantOwner,
      cityId: this.cityId,
      userName: this.userName,
      email: this.email,
      phoneNumber: this.phoneNumber,
      latitude: this.latitude,
      longitude: this.longitude,
      plantImage: this.plantImage,
      address: this.address,
      disabled: this.disabled,
      createdAt: this.createdAt ? this.createdAt.toObject() : undefined,
      lastUpdate: this.lastUpdate ? this.lastUpdate.toObject() : undefined,
      userId: this.userId,
      lowPriceThreshold: this.lowPriceThreshold,
      priceClass: this.priceClass,
      customerType: this.customerType,
      externalReferences: (this.externalReferences || []).map(m =>
        m.toObject()
      ),
      cityName: this.cityName,
      installationDate: this.installationDate,
      hasOfflineDevices: this.hasOfflineDevices
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): PlantResponse.AsProtobufJSON {
    return {
      id: this.id,
      plantOwner: this.plantOwner,
      cityId: this.cityId,
      userName: this.userName,
      email: this.email,
      phoneNumber: this.phoneNumber,
      latitude: this.latitude,
      longitude: this.longitude,
      plantImage: this.plantImage,
      address: this.address,
      disabled: this.disabled,
      createdAt: this.createdAt ? this.createdAt.toProtobufJSON(options) : null,
      lastUpdate: this.lastUpdate
        ? this.lastUpdate.toProtobufJSON(options)
        : null,
      userId: this.userId,
      lowPriceThreshold: this.lowPriceThreshold,
      priceClass: this.priceClass,
      customerType: this.customerType,
      externalReferences: (this.externalReferences || []).map(m =>
        m.toProtobufJSON(options)
      ),
      cityName: this.cityName,
      installationDate: this.installationDate,
      hasOfflineDevices: this.hasOfflineDevices
    };
  }
}
export module PlantResponse {
  /**
   * Standard JavaScript object representation for PlantResponse
   */
  export interface AsObject {
    id: number;
    plantOwner: string;
    cityId: number;
    userName: string;
    email: string;
    phoneNumber: string;
    latitude: string;
    longitude: string;
    plantImage: string;
    address: string;
    disabled: boolean;
    createdAt?: googleProtobuf001.Timestamp.AsObject;
    lastUpdate?: googleProtobuf001.Timestamp.AsObject;
    userId: number;
    lowPriceThreshold: string;
    priceClass: string;
    customerType: string;
    externalReferences?: ExternalReferences.AsObject[];
    cityName: string;
    installationDate: string;
    hasOfflineDevices: boolean;
  }

  /**
   * Protobuf JSON representation for PlantResponse
   */
  export interface AsProtobufJSON {
    id: number;
    plantOwner: string;
    cityId: number;
    userName: string;
    email: string;
    phoneNumber: string;
    latitude: string;
    longitude: string;
    plantImage: string;
    address: string;
    disabled: boolean;
    createdAt: googleProtobuf001.Timestamp.AsProtobufJSON | null;
    lastUpdate: googleProtobuf001.Timestamp.AsProtobufJSON | null;
    userId: number;
    lowPriceThreshold: string;
    priceClass: string;
    customerType: string;
    externalReferences: ExternalReferences.AsProtobufJSON[] | null;
    cityName: string;
    installationDate: string;
    hasOfflineDevices: boolean;
  }
}

/**
 * Message implementation for epicore.admin.PlantsResponse
 */
export class PlantsResponse implements GrpcMessage {
  static id = 'epicore.admin.PlantsResponse';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new PlantsResponse();
    PlantsResponse.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: PlantsResponse) {
    _instance.plants = _instance.plants || [];
    _instance.totalCount = _instance.totalCount || 0;
    _instance.page = _instance.page || 0;
    _instance.pageSize = _instance.pageSize || 0;
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: PlantsResponse,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          const messageInitializer1 = new PlantResponse();
          _reader.readMessage(
            messageInitializer1,
            PlantResponse.deserializeBinaryFromReader
          );
          (_instance.plants = _instance.plants || []).push(messageInitializer1);
          break;
        case 2:
          _instance.totalCount = _reader.readInt32();
          break;
        case 3:
          _instance.page = _reader.readInt32();
          break;
        case 4:
          _instance.pageSize = _reader.readInt32();
          break;
        default:
          _reader.skipField();
      }
    }

    PlantsResponse.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: PlantsResponse,
    _writer: BinaryWriter
  ) {
    if (_instance.plants && _instance.plants.length) {
      _writer.writeRepeatedMessage(
        1,
        _instance.plants as any,
        PlantResponse.serializeBinaryToWriter
      );
    }
    if (_instance.totalCount) {
      _writer.writeInt32(2, _instance.totalCount);
    }
    if (_instance.page) {
      _writer.writeInt32(3, _instance.page);
    }
    if (_instance.pageSize) {
      _writer.writeInt32(4, _instance.pageSize);
    }
  }

  private _plants?: PlantResponse[];
  private _totalCount: number;
  private _page: number;
  private _pageSize: number;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of PlantsResponse to deeply clone from
   */
  constructor(_value?: RecursivePartial<PlantsResponse.AsObject>) {
    _value = _value || {};
    this.plants = (_value.plants || []).map(m => new PlantResponse(m));
    this.totalCount = _value.totalCount;
    this.page = _value.page;
    this.pageSize = _value.pageSize;
    PlantsResponse.refineValues(this);
  }
  get plants(): PlantResponse[] | undefined {
    return this._plants;
  }
  set plants(value: PlantResponse[] | undefined) {
    this._plants = value;
  }
  get totalCount(): number {
    return this._totalCount;
  }
  set totalCount(value: number) {
    this._totalCount = value;
  }
  get page(): number {
    return this._page;
  }
  set page(value: number) {
    this._page = value;
  }
  get pageSize(): number {
    return this._pageSize;
  }
  set pageSize(value: number) {
    this._pageSize = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    PlantsResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): PlantsResponse.AsObject {
    return {
      plants: (this.plants || []).map(m => m.toObject()),
      totalCount: this.totalCount,
      page: this.page,
      pageSize: this.pageSize
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): PlantsResponse.AsProtobufJSON {
    return {
      plants: (this.plants || []).map(m => m.toProtobufJSON(options)),
      totalCount: this.totalCount,
      page: this.page,
      pageSize: this.pageSize
    };
  }
}
export module PlantsResponse {
  /**
   * Standard JavaScript object representation for PlantsResponse
   */
  export interface AsObject {
    plants?: PlantResponse.AsObject[];
    totalCount: number;
    page: number;
    pageSize: number;
  }

  /**
   * Protobuf JSON representation for PlantsResponse
   */
  export interface AsProtobufJSON {
    plants: PlantResponse.AsProtobufJSON[] | null;
    totalCount: number;
    page: number;
    pageSize: number;
  }
}

/**
 * Message implementation for epicore.admin.InverterBrandDto
 */
export class InverterBrandDto implements GrpcMessage {
  static id = 'epicore.admin.InverterBrandDto';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new InverterBrandDto();
    InverterBrandDto.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: InverterBrandDto) {
    _instance.title = _instance.title || '';
    _instance.models = _instance.models || [];
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: InverterBrandDto,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.title = _reader.readString();
          break;
        case 2:
          const messageInitializer2 = new InverterModelDto();
          _reader.readMessage(
            messageInitializer2,
            InverterModelDto.deserializeBinaryFromReader
          );
          (_instance.models = _instance.models || []).push(messageInitializer2);
          break;
        default:
          _reader.skipField();
      }
    }

    InverterBrandDto.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: InverterBrandDto,
    _writer: BinaryWriter
  ) {
    if (_instance.title) {
      _writer.writeString(1, _instance.title);
    }
    if (_instance.models && _instance.models.length) {
      _writer.writeRepeatedMessage(
        2,
        _instance.models as any,
        InverterModelDto.serializeBinaryToWriter
      );
    }
  }

  private _title: string;
  private _models?: InverterModelDto[];

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of InverterBrandDto to deeply clone from
   */
  constructor(_value?: RecursivePartial<InverterBrandDto.AsObject>) {
    _value = _value || {};
    this.title = _value.title;
    this.models = (_value.models || []).map(m => new InverterModelDto(m));
    InverterBrandDto.refineValues(this);
  }
  get title(): string {
    return this._title;
  }
  set title(value: string) {
    this._title = value;
  }
  get models(): InverterModelDto[] | undefined {
    return this._models;
  }
  set models(value: InverterModelDto[] | undefined) {
    this._models = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    InverterBrandDto.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): InverterBrandDto.AsObject {
    return {
      title: this.title,
      models: (this.models || []).map(m => m.toObject())
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): InverterBrandDto.AsProtobufJSON {
    return {
      title: this.title,
      models: (this.models || []).map(m => m.toProtobufJSON(options))
    };
  }
}
export module InverterBrandDto {
  /**
   * Standard JavaScript object representation for InverterBrandDto
   */
  export interface AsObject {
    title: string;
    models?: InverterModelDto.AsObject[];
  }

  /**
   * Protobuf JSON representation for InverterBrandDto
   */
  export interface AsProtobufJSON {
    title: string;
    models: InverterModelDto.AsProtobufJSON[] | null;
  }
}

/**
 * Message implementation for epicore.admin.InverterModelDto
 */
export class InverterModelDto implements GrpcMessage {
  static id = 'epicore.admin.InverterModelDto';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new InverterModelDto();
    InverterModelDto.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: InverterModelDto) {
    _instance.title = _instance.title || '';
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: InverterModelDto,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.title = _reader.readString();
          break;
        default:
          _reader.skipField();
      }
    }

    InverterModelDto.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: InverterModelDto,
    _writer: BinaryWriter
  ) {
    if (_instance.title) {
      _writer.writeString(1, _instance.title);
    }
  }

  private _title: string;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of InverterModelDto to deeply clone from
   */
  constructor(_value?: RecursivePartial<InverterModelDto.AsObject>) {
    _value = _value || {};
    this.title = _value.title;
    InverterModelDto.refineValues(this);
  }
  get title(): string {
    return this._title;
  }
  set title(value: string) {
    this._title = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    InverterModelDto.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): InverterModelDto.AsObject {
    return {
      title: this.title
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): InverterModelDto.AsProtobufJSON {
    return {
      title: this.title
    };
  }
}
export module InverterModelDto {
  /**
   * Standard JavaScript object representation for InverterModelDto
   */
  export interface AsObject {
    title: string;
  }

  /**
   * Protobuf JSON representation for InverterModelDto
   */
  export interface AsProtobufJSON {
    title: string;
  }
}

/**
 * Message implementation for epicore.admin.MeterTypes
 */
export class MeterTypes implements GrpcMessage {
  static id = 'epicore.admin.MeterTypes';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new MeterTypes();
    MeterTypes.deserializeBinaryFromReader(instance, new BinaryReader(bytes));
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: MeterTypes) {
    _instance.title = _instance.title || '';
    _instance.description = _instance.description || '';
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: MeterTypes,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.title = _reader.readString();
          break;
        case 2:
          _instance.description = _reader.readString();
          break;
        default:
          _reader.skipField();
      }
    }

    MeterTypes.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(_instance: MeterTypes, _writer: BinaryWriter) {
    if (_instance.title) {
      _writer.writeString(1, _instance.title);
    }
    if (_instance.description) {
      _writer.writeString(2, _instance.description);
    }
  }

  private _title: string;
  private _description: string;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of MeterTypes to deeply clone from
   */
  constructor(_value?: RecursivePartial<MeterTypes.AsObject>) {
    _value = _value || {};
    this.title = _value.title;
    this.description = _value.description;
    MeterTypes.refineValues(this);
  }
  get title(): string {
    return this._title;
  }
  set title(value: string) {
    this._title = value;
  }
  get description(): string {
    return this._description;
  }
  set description(value: string) {
    this._description = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    MeterTypes.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): MeterTypes.AsObject {
    return {
      title: this.title,
      description: this.description
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): MeterTypes.AsProtobufJSON {
    return {
      title: this.title,
      description: this.description
    };
  }
}
export module MeterTypes {
  /**
   * Standard JavaScript object representation for MeterTypes
   */
  export interface AsObject {
    title: string;
    description: string;
  }

  /**
   * Protobuf JSON representation for MeterTypes
   */
  export interface AsProtobufJSON {
    title: string;
    description: string;
  }
}

/**
 * Message implementation for epicore.admin.CustomerTypes
 */
export class CustomerTypes implements GrpcMessage {
  static id = 'epicore.admin.CustomerTypes';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new CustomerTypes();
    CustomerTypes.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: CustomerTypes) {
    _instance.title = _instance.title || '';
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: CustomerTypes,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.title = _reader.readString();
          break;
        default:
          _reader.skipField();
      }
    }

    CustomerTypes.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: CustomerTypes,
    _writer: BinaryWriter
  ) {
    if (_instance.title) {
      _writer.writeString(1, _instance.title);
    }
  }

  private _title: string;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of CustomerTypes to deeply clone from
   */
  constructor(_value?: RecursivePartial<CustomerTypes.AsObject>) {
    _value = _value || {};
    this.title = _value.title;
    CustomerTypes.refineValues(this);
  }
  get title(): string {
    return this._title;
  }
  set title(value: string) {
    this._title = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    CustomerTypes.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): CustomerTypes.AsObject {
    return {
      title: this.title
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): CustomerTypes.AsProtobufJSON {
    return {
      title: this.title
    };
  }
}
export module CustomerTypes {
  /**
   * Standard JavaScript object representation for CustomerTypes
   */
  export interface AsObject {
    title: string;
  }

  /**
   * Protobuf JSON representation for CustomerTypes
   */
  export interface AsProtobufJSON {
    title: string;
  }
}

/**
 * Message implementation for epicore.admin.GetPrerequisitesResponse
 */
export class GetPrerequisitesResponse implements GrpcMessage {
  static id = 'epicore.admin.GetPrerequisitesResponse';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new GetPrerequisitesResponse();
    GetPrerequisitesResponse.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: GetPrerequisitesResponse) {
    _instance.brands = _instance.brands || [];
    _instance.meterTypes = _instance.meterTypes || [];
    _instance.customerTypes = _instance.customerTypes || [];
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: GetPrerequisitesResponse,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          const messageInitializer1 = new InverterBrandDto();
          _reader.readMessage(
            messageInitializer1,
            InverterBrandDto.deserializeBinaryFromReader
          );
          (_instance.brands = _instance.brands || []).push(messageInitializer1);
          break;
        case 2:
          const messageInitializer2 = new MeterTypes();
          _reader.readMessage(
            messageInitializer2,
            MeterTypes.deserializeBinaryFromReader
          );
          (_instance.meterTypes = _instance.meterTypes || []).push(
            messageInitializer2
          );
          break;
        case 3:
          const messageInitializer3 = new CustomerTypes();
          _reader.readMessage(
            messageInitializer3,
            CustomerTypes.deserializeBinaryFromReader
          );
          (_instance.customerTypes = _instance.customerTypes || []).push(
            messageInitializer3
          );
          break;
        default:
          _reader.skipField();
      }
    }

    GetPrerequisitesResponse.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: GetPrerequisitesResponse,
    _writer: BinaryWriter
  ) {
    if (_instance.brands && _instance.brands.length) {
      _writer.writeRepeatedMessage(
        1,
        _instance.brands as any,
        InverterBrandDto.serializeBinaryToWriter
      );
    }
    if (_instance.meterTypes && _instance.meterTypes.length) {
      _writer.writeRepeatedMessage(
        2,
        _instance.meterTypes as any,
        MeterTypes.serializeBinaryToWriter
      );
    }
    if (_instance.customerTypes && _instance.customerTypes.length) {
      _writer.writeRepeatedMessage(
        3,
        _instance.customerTypes as any,
        CustomerTypes.serializeBinaryToWriter
      );
    }
  }

  private _brands?: InverterBrandDto[];
  private _meterTypes?: MeterTypes[];
  private _customerTypes?: CustomerTypes[];

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of GetPrerequisitesResponse to deeply clone from
   */
  constructor(_value?: RecursivePartial<GetPrerequisitesResponse.AsObject>) {
    _value = _value || {};
    this.brands = (_value.brands || []).map(m => new InverterBrandDto(m));
    this.meterTypes = (_value.meterTypes || []).map(m => new MeterTypes(m));
    this.customerTypes = (_value.customerTypes || []).map(
      m => new CustomerTypes(m)
    );
    GetPrerequisitesResponse.refineValues(this);
  }
  get brands(): InverterBrandDto[] | undefined {
    return this._brands;
  }
  set brands(value: InverterBrandDto[] | undefined) {
    this._brands = value;
  }
  get meterTypes(): MeterTypes[] | undefined {
    return this._meterTypes;
  }
  set meterTypes(value: MeterTypes[] | undefined) {
    this._meterTypes = value;
  }
  get customerTypes(): CustomerTypes[] | undefined {
    return this._customerTypes;
  }
  set customerTypes(value: CustomerTypes[] | undefined) {
    this._customerTypes = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    GetPrerequisitesResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): GetPrerequisitesResponse.AsObject {
    return {
      brands: (this.brands || []).map(m => m.toObject()),
      meterTypes: (this.meterTypes || []).map(m => m.toObject()),
      customerTypes: (this.customerTypes || []).map(m => m.toObject())
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): GetPrerequisitesResponse.AsProtobufJSON {
    return {
      brands: (this.brands || []).map(m => m.toProtobufJSON(options)),
      meterTypes: (this.meterTypes || []).map(m => m.toProtobufJSON(options)),
      customerTypes: (this.customerTypes || []).map(m =>
        m.toProtobufJSON(options)
      )
    };
  }
}
export module GetPrerequisitesResponse {
  /**
   * Standard JavaScript object representation for GetPrerequisitesResponse
   */
  export interface AsObject {
    brands?: InverterBrandDto.AsObject[];
    meterTypes?: MeterTypes.AsObject[];
    customerTypes?: CustomerTypes.AsObject[];
  }

  /**
   * Protobuf JSON representation for GetPrerequisitesResponse
   */
  export interface AsProtobufJSON {
    brands: InverterBrandDto.AsProtobufJSON[] | null;
    meterTypes: MeterTypes.AsProtobufJSON[] | null;
    customerTypes: CustomerTypes.AsProtobufJSON[] | null;
  }
}

/**
 * Message implementation for epicore.admin.AddPlantInverterRequest
 */
export class AddPlantInverterRequest implements GrpcMessage {
  static id = 'epicore.admin.AddPlantInverterRequest';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new AddPlantInverterRequest();
    AddPlantInverterRequest.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: AddPlantInverterRequest) {
    _instance.plantId = _instance.plantId || 0;
    _instance.serialNumber = _instance.serialNumber || '';
    _instance.meteringPointIds = _instance.meteringPointIds || [];
    _instance.maxProductionCapacity = _instance.maxProductionCapacity || '';
    _instance.brand = _instance.brand || '';
    _instance.model = _instance.model || '';
    _instance.totalBatteryCapacityKwh = _instance.totalBatteryCapacityKwh || '';
    _instance.totalPanelPowerKwh = _instance.totalPanelPowerKwh || '';
    _instance.batteryChargePowerRateKw =
      _instance.batteryChargePowerRateKw || '';
    _instance.solarFactorThreshold = _instance.solarFactorThreshold || '';
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: AddPlantInverterRequest,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.plantId = _reader.readInt32();
          break;
        case 2:
          _instance.serialNumber = _reader.readString();
          break;
        case 3:
          const messageInitializer3 = new MeteringPoint();
          _reader.readMessage(
            messageInitializer3,
            MeteringPoint.deserializeBinaryFromReader
          );
          (_instance.meteringPointIds = _instance.meteringPointIds || []).push(
            messageInitializer3
          );
          break;
        case 4:
          _instance.maxProductionCapacity = _reader.readString();
          break;
        case 5:
          _instance.brand = _reader.readString();
          break;
        case 6:
          _instance.model = _reader.readString();
          break;
        case 7:
          _instance.totalBatteryCapacityKwh = _reader.readString();
          break;
        case 8:
          _instance.totalPanelPowerKwh = _reader.readString();
          break;
        case 9:
          _instance.batteryChargePowerRateKw = _reader.readString();
          break;
        case 10:
          _instance.solarFactorThreshold = _reader.readString();
          break;
        default:
          _reader.skipField();
      }
    }

    AddPlantInverterRequest.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: AddPlantInverterRequest,
    _writer: BinaryWriter
  ) {
    if (_instance.plantId) {
      _writer.writeInt32(1, _instance.plantId);
    }
    if (_instance.serialNumber) {
      _writer.writeString(2, _instance.serialNumber);
    }
    if (_instance.meteringPointIds && _instance.meteringPointIds.length) {
      _writer.writeRepeatedMessage(
        3,
        _instance.meteringPointIds as any,
        MeteringPoint.serializeBinaryToWriter
      );
    }
    if (_instance.maxProductionCapacity) {
      _writer.writeString(4, _instance.maxProductionCapacity);
    }
    if (_instance.brand) {
      _writer.writeString(5, _instance.brand);
    }
    if (_instance.model) {
      _writer.writeString(6, _instance.model);
    }
    if (_instance.totalBatteryCapacityKwh) {
      _writer.writeString(7, _instance.totalBatteryCapacityKwh);
    }
    if (_instance.totalPanelPowerKwh) {
      _writer.writeString(8, _instance.totalPanelPowerKwh);
    }
    if (_instance.batteryChargePowerRateKw) {
      _writer.writeString(9, _instance.batteryChargePowerRateKw);
    }
    if (_instance.solarFactorThreshold) {
      _writer.writeString(10, _instance.solarFactorThreshold);
    }
  }

  private _plantId: number;
  private _serialNumber: string;
  private _meteringPointIds?: MeteringPoint[];
  private _maxProductionCapacity: string;
  private _brand: string;
  private _model: string;
  private _totalBatteryCapacityKwh: string;
  private _totalPanelPowerKwh: string;
  private _batteryChargePowerRateKw: string;
  private _solarFactorThreshold: string;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of AddPlantInverterRequest to deeply clone from
   */
  constructor(_value?: RecursivePartial<AddPlantInverterRequest.AsObject>) {
    _value = _value || {};
    this.plantId = _value.plantId;
    this.serialNumber = _value.serialNumber;
    this.meteringPointIds = (_value.meteringPointIds || []).map(
      m => new MeteringPoint(m)
    );
    this.maxProductionCapacity = _value.maxProductionCapacity;
    this.brand = _value.brand;
    this.model = _value.model;
    this.totalBatteryCapacityKwh = _value.totalBatteryCapacityKwh;
    this.totalPanelPowerKwh = _value.totalPanelPowerKwh;
    this.batteryChargePowerRateKw = _value.batteryChargePowerRateKw;
    this.solarFactorThreshold = _value.solarFactorThreshold;
    AddPlantInverterRequest.refineValues(this);
  }
  get plantId(): number {
    return this._plantId;
  }
  set plantId(value: number) {
    this._plantId = value;
  }
  get serialNumber(): string {
    return this._serialNumber;
  }
  set serialNumber(value: string) {
    this._serialNumber = value;
  }
  get meteringPointIds(): MeteringPoint[] | undefined {
    return this._meteringPointIds;
  }
  set meteringPointIds(value: MeteringPoint[] | undefined) {
    this._meteringPointIds = value;
  }
  get maxProductionCapacity(): string {
    return this._maxProductionCapacity;
  }
  set maxProductionCapacity(value: string) {
    this._maxProductionCapacity = value;
  }
  get brand(): string {
    return this._brand;
  }
  set brand(value: string) {
    this._brand = value;
  }
  get model(): string {
    return this._model;
  }
  set model(value: string) {
    this._model = value;
  }
  get totalBatteryCapacityKwh(): string {
    return this._totalBatteryCapacityKwh;
  }
  set totalBatteryCapacityKwh(value: string) {
    this._totalBatteryCapacityKwh = value;
  }
  get totalPanelPowerKwh(): string {
    return this._totalPanelPowerKwh;
  }
  set totalPanelPowerKwh(value: string) {
    this._totalPanelPowerKwh = value;
  }
  get batteryChargePowerRateKw(): string {
    return this._batteryChargePowerRateKw;
  }
  set batteryChargePowerRateKw(value: string) {
    this._batteryChargePowerRateKw = value;
  }
  get solarFactorThreshold(): string {
    return this._solarFactorThreshold;
  }
  set solarFactorThreshold(value: string) {
    this._solarFactorThreshold = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    AddPlantInverterRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): AddPlantInverterRequest.AsObject {
    return {
      plantId: this.plantId,
      serialNumber: this.serialNumber,
      meteringPointIds: (this.meteringPointIds || []).map(m => m.toObject()),
      maxProductionCapacity: this.maxProductionCapacity,
      brand: this.brand,
      model: this.model,
      totalBatteryCapacityKwh: this.totalBatteryCapacityKwh,
      totalPanelPowerKwh: this.totalPanelPowerKwh,
      batteryChargePowerRateKw: this.batteryChargePowerRateKw,
      solarFactorThreshold: this.solarFactorThreshold
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): AddPlantInverterRequest.AsProtobufJSON {
    return {
      plantId: this.plantId,
      serialNumber: this.serialNumber,
      meteringPointIds: (this.meteringPointIds || []).map(m =>
        m.toProtobufJSON(options)
      ),
      maxProductionCapacity: this.maxProductionCapacity,
      brand: this.brand,
      model: this.model,
      totalBatteryCapacityKwh: this.totalBatteryCapacityKwh,
      totalPanelPowerKwh: this.totalPanelPowerKwh,
      batteryChargePowerRateKw: this.batteryChargePowerRateKw,
      solarFactorThreshold: this.solarFactorThreshold
    };
  }
}
export module AddPlantInverterRequest {
  /**
   * Standard JavaScript object representation for AddPlantInverterRequest
   */
  export interface AsObject {
    plantId: number;
    serialNumber: string;
    meteringPointIds?: MeteringPoint.AsObject[];
    maxProductionCapacity: string;
    brand: string;
    model: string;
    totalBatteryCapacityKwh: string;
    totalPanelPowerKwh: string;
    batteryChargePowerRateKw: string;
    solarFactorThreshold: string;
  }

  /**
   * Protobuf JSON representation for AddPlantInverterRequest
   */
  export interface AsProtobufJSON {
    plantId: number;
    serialNumber: string;
    meteringPointIds: MeteringPoint.AsProtobufJSON[] | null;
    maxProductionCapacity: string;
    brand: string;
    model: string;
    totalBatteryCapacityKwh: string;
    totalPanelPowerKwh: string;
    batteryChargePowerRateKw: string;
    solarFactorThreshold: string;
  }
}

/**
 * Message implementation for epicore.admin.UpdatePlantInverterRequest
 */
export class UpdatePlantInverterRequest implements GrpcMessage {
  static id = 'epicore.admin.UpdatePlantInverterRequest';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new UpdatePlantInverterRequest();
    UpdatePlantInverterRequest.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: UpdatePlantInverterRequest) {
    _instance.plantId = _instance.plantId || 0;
    _instance.id = _instance.id || 0;
    _instance.serialNumber = _instance.serialNumber || '';
    _instance.meteringPointIds = _instance.meteringPointIds || [];
    _instance.maxProductionCapacity = _instance.maxProductionCapacity || '';
    _instance.brand = _instance.brand || '';
    _instance.model = _instance.model || '';
    _instance.totalBatteryCapacityKwh = _instance.totalBatteryCapacityKwh || '';
    _instance.totalPanelPowerKwh = _instance.totalPanelPowerKwh || '';
    _instance.batteryChargePowerRateKw =
      _instance.batteryChargePowerRateKw || '';
    _instance.solarFactorThreshold = _instance.solarFactorThreshold || '';
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: UpdatePlantInverterRequest,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.plantId = _reader.readInt32();
          break;
        case 2:
          _instance.id = _reader.readInt32();
          break;
        case 3:
          _instance.serialNumber = _reader.readString();
          break;
        case 4:
          const messageInitializer4 = new MeteringPoint();
          _reader.readMessage(
            messageInitializer4,
            MeteringPoint.deserializeBinaryFromReader
          );
          (_instance.meteringPointIds = _instance.meteringPointIds || []).push(
            messageInitializer4
          );
          break;
        case 5:
          _instance.maxProductionCapacity = _reader.readString();
          break;
        case 6:
          _instance.brand = _reader.readString();
          break;
        case 7:
          _instance.model = _reader.readString();
          break;
        case 8:
          _instance.totalBatteryCapacityKwh = _reader.readString();
          break;
        case 9:
          _instance.totalPanelPowerKwh = _reader.readString();
          break;
        case 10:
          _instance.batteryChargePowerRateKw = _reader.readString();
          break;
        case 11:
          _instance.solarFactorThreshold = _reader.readString();
          break;
        default:
          _reader.skipField();
      }
    }

    UpdatePlantInverterRequest.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: UpdatePlantInverterRequest,
    _writer: BinaryWriter
  ) {
    if (_instance.plantId) {
      _writer.writeInt32(1, _instance.plantId);
    }
    if (_instance.id) {
      _writer.writeInt32(2, _instance.id);
    }
    if (_instance.serialNumber) {
      _writer.writeString(3, _instance.serialNumber);
    }
    if (_instance.meteringPointIds && _instance.meteringPointIds.length) {
      _writer.writeRepeatedMessage(
        4,
        _instance.meteringPointIds as any,
        MeteringPoint.serializeBinaryToWriter
      );
    }
    if (_instance.maxProductionCapacity) {
      _writer.writeString(5, _instance.maxProductionCapacity);
    }
    if (_instance.brand) {
      _writer.writeString(6, _instance.brand);
    }
    if (_instance.model) {
      _writer.writeString(7, _instance.model);
    }
    if (_instance.totalBatteryCapacityKwh) {
      _writer.writeString(8, _instance.totalBatteryCapacityKwh);
    }
    if (_instance.totalPanelPowerKwh) {
      _writer.writeString(9, _instance.totalPanelPowerKwh);
    }
    if (_instance.batteryChargePowerRateKw) {
      _writer.writeString(10, _instance.batteryChargePowerRateKw);
    }
    if (_instance.solarFactorThreshold) {
      _writer.writeString(11, _instance.solarFactorThreshold);
    }
  }

  private _plantId: number;
  private _id: number;
  private _serialNumber: string;
  private _meteringPointIds?: MeteringPoint[];
  private _maxProductionCapacity: string;
  private _brand: string;
  private _model: string;
  private _totalBatteryCapacityKwh: string;
  private _totalPanelPowerKwh: string;
  private _batteryChargePowerRateKw: string;
  private _solarFactorThreshold: string;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of UpdatePlantInverterRequest to deeply clone from
   */
  constructor(_value?: RecursivePartial<UpdatePlantInverterRequest.AsObject>) {
    _value = _value || {};
    this.plantId = _value.plantId;
    this.id = _value.id;
    this.serialNumber = _value.serialNumber;
    this.meteringPointIds = (_value.meteringPointIds || []).map(
      m => new MeteringPoint(m)
    );
    this.maxProductionCapacity = _value.maxProductionCapacity;
    this.brand = _value.brand;
    this.model = _value.model;
    this.totalBatteryCapacityKwh = _value.totalBatteryCapacityKwh;
    this.totalPanelPowerKwh = _value.totalPanelPowerKwh;
    this.batteryChargePowerRateKw = _value.batteryChargePowerRateKw;
    this.solarFactorThreshold = _value.solarFactorThreshold;
    UpdatePlantInverterRequest.refineValues(this);
  }
  get plantId(): number {
    return this._plantId;
  }
  set plantId(value: number) {
    this._plantId = value;
  }
  get id(): number {
    return this._id;
  }
  set id(value: number) {
    this._id = value;
  }
  get serialNumber(): string {
    return this._serialNumber;
  }
  set serialNumber(value: string) {
    this._serialNumber = value;
  }
  get meteringPointIds(): MeteringPoint[] | undefined {
    return this._meteringPointIds;
  }
  set meteringPointIds(value: MeteringPoint[] | undefined) {
    this._meteringPointIds = value;
  }
  get maxProductionCapacity(): string {
    return this._maxProductionCapacity;
  }
  set maxProductionCapacity(value: string) {
    this._maxProductionCapacity = value;
  }
  get brand(): string {
    return this._brand;
  }
  set brand(value: string) {
    this._brand = value;
  }
  get model(): string {
    return this._model;
  }
  set model(value: string) {
    this._model = value;
  }
  get totalBatteryCapacityKwh(): string {
    return this._totalBatteryCapacityKwh;
  }
  set totalBatteryCapacityKwh(value: string) {
    this._totalBatteryCapacityKwh = value;
  }
  get totalPanelPowerKwh(): string {
    return this._totalPanelPowerKwh;
  }
  set totalPanelPowerKwh(value: string) {
    this._totalPanelPowerKwh = value;
  }
  get batteryChargePowerRateKw(): string {
    return this._batteryChargePowerRateKw;
  }
  set batteryChargePowerRateKw(value: string) {
    this._batteryChargePowerRateKw = value;
  }
  get solarFactorThreshold(): string {
    return this._solarFactorThreshold;
  }
  set solarFactorThreshold(value: string) {
    this._solarFactorThreshold = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    UpdatePlantInverterRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): UpdatePlantInverterRequest.AsObject {
    return {
      plantId: this.plantId,
      id: this.id,
      serialNumber: this.serialNumber,
      meteringPointIds: (this.meteringPointIds || []).map(m => m.toObject()),
      maxProductionCapacity: this.maxProductionCapacity,
      brand: this.brand,
      model: this.model,
      totalBatteryCapacityKwh: this.totalBatteryCapacityKwh,
      totalPanelPowerKwh: this.totalPanelPowerKwh,
      batteryChargePowerRateKw: this.batteryChargePowerRateKw,
      solarFactorThreshold: this.solarFactorThreshold
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): UpdatePlantInverterRequest.AsProtobufJSON {
    return {
      plantId: this.plantId,
      id: this.id,
      serialNumber: this.serialNumber,
      meteringPointIds: (this.meteringPointIds || []).map(m =>
        m.toProtobufJSON(options)
      ),
      maxProductionCapacity: this.maxProductionCapacity,
      brand: this.brand,
      model: this.model,
      totalBatteryCapacityKwh: this.totalBatteryCapacityKwh,
      totalPanelPowerKwh: this.totalPanelPowerKwh,
      batteryChargePowerRateKw: this.batteryChargePowerRateKw,
      solarFactorThreshold: this.solarFactorThreshold
    };
  }
}
export module UpdatePlantInverterRequest {
  /**
   * Standard JavaScript object representation for UpdatePlantInverterRequest
   */
  export interface AsObject {
    plantId: number;
    id: number;
    serialNumber: string;
    meteringPointIds?: MeteringPoint.AsObject[];
    maxProductionCapacity: string;
    brand: string;
    model: string;
    totalBatteryCapacityKwh: string;
    totalPanelPowerKwh: string;
    batteryChargePowerRateKw: string;
    solarFactorThreshold: string;
  }

  /**
   * Protobuf JSON representation for UpdatePlantInverterRequest
   */
  export interface AsProtobufJSON {
    plantId: number;
    id: number;
    serialNumber: string;
    meteringPointIds: MeteringPoint.AsProtobufJSON[] | null;
    maxProductionCapacity: string;
    brand: string;
    model: string;
    totalBatteryCapacityKwh: string;
    totalPanelPowerKwh: string;
    batteryChargePowerRateKw: string;
    solarFactorThreshold: string;
  }
}

/**
 * Message implementation for epicore.admin.MeteringPoint
 */
export class MeteringPoint implements GrpcMessage {
  static id = 'epicore.admin.MeteringPoint';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new MeteringPoint();
    MeteringPoint.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: MeteringPoint) {
    _instance.meteringPointId = _instance.meteringPointId || '';
    _instance.meterType = _instance.meterType || '';
    _instance.isMain = _instance.isMain || false;
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: MeteringPoint,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.meteringPointId = _reader.readString();
          break;
        case 2:
          _instance.meterType = _reader.readString();
          break;
        case 3:
          _instance.isMain = _reader.readBool();
          break;
        default:
          _reader.skipField();
      }
    }

    MeteringPoint.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: MeteringPoint,
    _writer: BinaryWriter
  ) {
    if (_instance.meteringPointId) {
      _writer.writeString(1, _instance.meteringPointId);
    }
    if (_instance.meterType) {
      _writer.writeString(2, _instance.meterType);
    }
    if (_instance.isMain) {
      _writer.writeBool(3, _instance.isMain);
    }
  }

  private _meteringPointId: string;
  private _meterType: string;
  private _isMain: boolean;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of MeteringPoint to deeply clone from
   */
  constructor(_value?: RecursivePartial<MeteringPoint.AsObject>) {
    _value = _value || {};
    this.meteringPointId = _value.meteringPointId;
    this.meterType = _value.meterType;
    this.isMain = _value.isMain;
    MeteringPoint.refineValues(this);
  }
  get meteringPointId(): string {
    return this._meteringPointId;
  }
  set meteringPointId(value: string) {
    this._meteringPointId = value;
  }
  get meterType(): string {
    return this._meterType;
  }
  set meterType(value: string) {
    this._meterType = value;
  }
  get isMain(): boolean {
    return this._isMain;
  }
  set isMain(value: boolean) {
    this._isMain = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    MeteringPoint.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): MeteringPoint.AsObject {
    return {
      meteringPointId: this.meteringPointId,
      meterType: this.meterType,
      isMain: this.isMain
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): MeteringPoint.AsProtobufJSON {
    return {
      meteringPointId: this.meteringPointId,
      meterType: this.meterType,
      isMain: this.isMain
    };
  }
}
export module MeteringPoint {
  /**
   * Standard JavaScript object representation for MeteringPoint
   */
  export interface AsObject {
    meteringPointId: string;
    meterType: string;
    isMain: boolean;
  }

  /**
   * Protobuf JSON representation for MeteringPoint
   */
  export interface AsProtobufJSON {
    meteringPointId: string;
    meterType: string;
    isMain: boolean;
  }
}

/**
 * Message implementation for epicore.admin.PlantInvertersInfo
 */
export class PlantInvertersInfo implements GrpcMessage {
  static id = 'epicore.admin.PlantInvertersInfo';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new PlantInvertersInfo();
    PlantInvertersInfo.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: PlantInvertersInfo) {
    _instance.plantId = _instance.plantId || 0;
    _instance.id = _instance.id || 0;
    _instance.serialNumber = _instance.serialNumber || '';
    _instance.meteringPointIds = _instance.meteringPointIds || [];
    _instance.maxProductionCapacity = _instance.maxProductionCapacity || '';
    _instance.brand = _instance.brand || '';
    _instance.model = _instance.model || '';
    _instance.lastUpdate = _instance.lastUpdate || undefined;
    _instance.createdAt = _instance.createdAt || undefined;
    _instance.disabled = _instance.disabled || false;
    _instance.totalBatteryCapacityKwh = _instance.totalBatteryCapacityKwh || '';
    _instance.totalPanelPowerKwh = _instance.totalPanelPowerKwh || '';
    _instance.batteryChargePowerRateKw =
      _instance.batteryChargePowerRateKw || '';
    _instance.solarFactorThreshold = _instance.solarFactorThreshold || '';
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: PlantInvertersInfo,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.plantId = _reader.readInt32();
          break;
        case 2:
          _instance.id = _reader.readInt32();
          break;
        case 3:
          _instance.serialNumber = _reader.readString();
          break;
        case 4:
          const messageInitializer4 = new MeteringPoint();
          _reader.readMessage(
            messageInitializer4,
            MeteringPoint.deserializeBinaryFromReader
          );
          (_instance.meteringPointIds = _instance.meteringPointIds || []).push(
            messageInitializer4
          );
          break;
        case 5:
          _instance.maxProductionCapacity = _reader.readString();
          break;
        case 6:
          _instance.brand = _reader.readString();
          break;
        case 7:
          _instance.model = _reader.readString();
          break;
        case 8:
          _instance.lastUpdate = new googleProtobuf001.Timestamp();
          _reader.readMessage(
            _instance.lastUpdate,
            googleProtobuf001.Timestamp.deserializeBinaryFromReader
          );
          break;
        case 9:
          _instance.createdAt = new googleProtobuf001.Timestamp();
          _reader.readMessage(
            _instance.createdAt,
            googleProtobuf001.Timestamp.deserializeBinaryFromReader
          );
          break;
        case 10:
          _instance.disabled = _reader.readBool();
          break;
        case 11:
          _instance.totalBatteryCapacityKwh = _reader.readString();
          break;
        case 12:
          _instance.totalPanelPowerKwh = _reader.readString();
          break;
        case 13:
          _instance.batteryChargePowerRateKw = _reader.readString();
          break;
        case 14:
          _instance.solarFactorThreshold = _reader.readString();
          break;
        default:
          _reader.skipField();
      }
    }

    PlantInvertersInfo.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: PlantInvertersInfo,
    _writer: BinaryWriter
  ) {
    if (_instance.plantId) {
      _writer.writeInt32(1, _instance.plantId);
    }
    if (_instance.id) {
      _writer.writeInt32(2, _instance.id);
    }
    if (_instance.serialNumber) {
      _writer.writeString(3, _instance.serialNumber);
    }
    if (_instance.meteringPointIds && _instance.meteringPointIds.length) {
      _writer.writeRepeatedMessage(
        4,
        _instance.meteringPointIds as any,
        MeteringPoint.serializeBinaryToWriter
      );
    }
    if (_instance.maxProductionCapacity) {
      _writer.writeString(5, _instance.maxProductionCapacity);
    }
    if (_instance.brand) {
      _writer.writeString(6, _instance.brand);
    }
    if (_instance.model) {
      _writer.writeString(7, _instance.model);
    }
    if (_instance.lastUpdate) {
      _writer.writeMessage(
        8,
        _instance.lastUpdate as any,
        googleProtobuf001.Timestamp.serializeBinaryToWriter
      );
    }
    if (_instance.createdAt) {
      _writer.writeMessage(
        9,
        _instance.createdAt as any,
        googleProtobuf001.Timestamp.serializeBinaryToWriter
      );
    }
    if (_instance.disabled) {
      _writer.writeBool(10, _instance.disabled);
    }
    if (_instance.totalBatteryCapacityKwh) {
      _writer.writeString(11, _instance.totalBatteryCapacityKwh);
    }
    if (_instance.totalPanelPowerKwh) {
      _writer.writeString(12, _instance.totalPanelPowerKwh);
    }
    if (_instance.batteryChargePowerRateKw) {
      _writer.writeString(13, _instance.batteryChargePowerRateKw);
    }
    if (_instance.solarFactorThreshold) {
      _writer.writeString(14, _instance.solarFactorThreshold);
    }
  }

  private _plantId: number;
  private _id: number;
  private _serialNumber: string;
  private _meteringPointIds?: MeteringPoint[];
  private _maxProductionCapacity: string;
  private _brand: string;
  private _model: string;
  private _lastUpdate?: googleProtobuf001.Timestamp;
  private _createdAt?: googleProtobuf001.Timestamp;
  private _disabled: boolean;
  private _totalBatteryCapacityKwh: string;
  private _totalPanelPowerKwh: string;
  private _batteryChargePowerRateKw: string;
  private _solarFactorThreshold: string;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of PlantInvertersInfo to deeply clone from
   */
  constructor(_value?: RecursivePartial<PlantInvertersInfo.AsObject>) {
    _value = _value || {};
    this.plantId = _value.plantId;
    this.id = _value.id;
    this.serialNumber = _value.serialNumber;
    this.meteringPointIds = (_value.meteringPointIds || []).map(
      m => new MeteringPoint(m)
    );
    this.maxProductionCapacity = _value.maxProductionCapacity;
    this.brand = _value.brand;
    this.model = _value.model;
    this.lastUpdate = _value.lastUpdate
      ? new googleProtobuf001.Timestamp(_value.lastUpdate)
      : undefined;
    this.createdAt = _value.createdAt
      ? new googleProtobuf001.Timestamp(_value.createdAt)
      : undefined;
    this.disabled = _value.disabled;
    this.totalBatteryCapacityKwh = _value.totalBatteryCapacityKwh;
    this.totalPanelPowerKwh = _value.totalPanelPowerKwh;
    this.batteryChargePowerRateKw = _value.batteryChargePowerRateKw;
    this.solarFactorThreshold = _value.solarFactorThreshold;
    PlantInvertersInfo.refineValues(this);
  }
  get plantId(): number {
    return this._plantId;
  }
  set plantId(value: number) {
    this._plantId = value;
  }
  get id(): number {
    return this._id;
  }
  set id(value: number) {
    this._id = value;
  }
  get serialNumber(): string {
    return this._serialNumber;
  }
  set serialNumber(value: string) {
    this._serialNumber = value;
  }
  get meteringPointIds(): MeteringPoint[] | undefined {
    return this._meteringPointIds;
  }
  set meteringPointIds(value: MeteringPoint[] | undefined) {
    this._meteringPointIds = value;
  }
  get maxProductionCapacity(): string {
    return this._maxProductionCapacity;
  }
  set maxProductionCapacity(value: string) {
    this._maxProductionCapacity = value;
  }
  get brand(): string {
    return this._brand;
  }
  set brand(value: string) {
    this._brand = value;
  }
  get model(): string {
    return this._model;
  }
  set model(value: string) {
    this._model = value;
  }
  get lastUpdate(): googleProtobuf001.Timestamp | undefined {
    return this._lastUpdate;
  }
  set lastUpdate(value: googleProtobuf001.Timestamp | undefined) {
    this._lastUpdate = value;
  }
  get createdAt(): googleProtobuf001.Timestamp | undefined {
    return this._createdAt;
  }
  set createdAt(value: googleProtobuf001.Timestamp | undefined) {
    this._createdAt = value;
  }
  get disabled(): boolean {
    return this._disabled;
  }
  set disabled(value: boolean) {
    this._disabled = value;
  }
  get totalBatteryCapacityKwh(): string {
    return this._totalBatteryCapacityKwh;
  }
  set totalBatteryCapacityKwh(value: string) {
    this._totalBatteryCapacityKwh = value;
  }
  get totalPanelPowerKwh(): string {
    return this._totalPanelPowerKwh;
  }
  set totalPanelPowerKwh(value: string) {
    this._totalPanelPowerKwh = value;
  }
  get batteryChargePowerRateKw(): string {
    return this._batteryChargePowerRateKw;
  }
  set batteryChargePowerRateKw(value: string) {
    this._batteryChargePowerRateKw = value;
  }
  get solarFactorThreshold(): string {
    return this._solarFactorThreshold;
  }
  set solarFactorThreshold(value: string) {
    this._solarFactorThreshold = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    PlantInvertersInfo.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): PlantInvertersInfo.AsObject {
    return {
      plantId: this.plantId,
      id: this.id,
      serialNumber: this.serialNumber,
      meteringPointIds: (this.meteringPointIds || []).map(m => m.toObject()),
      maxProductionCapacity: this.maxProductionCapacity,
      brand: this.brand,
      model: this.model,
      lastUpdate: this.lastUpdate ? this.lastUpdate.toObject() : undefined,
      createdAt: this.createdAt ? this.createdAt.toObject() : undefined,
      disabled: this.disabled,
      totalBatteryCapacityKwh: this.totalBatteryCapacityKwh,
      totalPanelPowerKwh: this.totalPanelPowerKwh,
      batteryChargePowerRateKw: this.batteryChargePowerRateKw,
      solarFactorThreshold: this.solarFactorThreshold
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): PlantInvertersInfo.AsProtobufJSON {
    return {
      plantId: this.plantId,
      id: this.id,
      serialNumber: this.serialNumber,
      meteringPointIds: (this.meteringPointIds || []).map(m =>
        m.toProtobufJSON(options)
      ),
      maxProductionCapacity: this.maxProductionCapacity,
      brand: this.brand,
      model: this.model,
      lastUpdate: this.lastUpdate
        ? this.lastUpdate.toProtobufJSON(options)
        : null,
      createdAt: this.createdAt ? this.createdAt.toProtobufJSON(options) : null,
      disabled: this.disabled,
      totalBatteryCapacityKwh: this.totalBatteryCapacityKwh,
      totalPanelPowerKwh: this.totalPanelPowerKwh,
      batteryChargePowerRateKw: this.batteryChargePowerRateKw,
      solarFactorThreshold: this.solarFactorThreshold
    };
  }
}
export module PlantInvertersInfo {
  /**
   * Standard JavaScript object representation for PlantInvertersInfo
   */
  export interface AsObject {
    plantId: number;
    id: number;
    serialNumber: string;
    meteringPointIds?: MeteringPoint.AsObject[];
    maxProductionCapacity: string;
    brand: string;
    model: string;
    lastUpdate?: googleProtobuf001.Timestamp.AsObject;
    createdAt?: googleProtobuf001.Timestamp.AsObject;
    disabled: boolean;
    totalBatteryCapacityKwh: string;
    totalPanelPowerKwh: string;
    batteryChargePowerRateKw: string;
    solarFactorThreshold: string;
  }

  /**
   * Protobuf JSON representation for PlantInvertersInfo
   */
  export interface AsProtobufJSON {
    plantId: number;
    id: number;
    serialNumber: string;
    meteringPointIds: MeteringPoint.AsProtobufJSON[] | null;
    maxProductionCapacity: string;
    brand: string;
    model: string;
    lastUpdate: googleProtobuf001.Timestamp.AsProtobufJSON | null;
    createdAt: googleProtobuf001.Timestamp.AsProtobufJSON | null;
    disabled: boolean;
    totalBatteryCapacityKwh: string;
    totalPanelPowerKwh: string;
    batteryChargePowerRateKw: string;
    solarFactorThreshold: string;
  }
}

/**
 * Message implementation for epicore.admin.ToggleDisableInverterRequest
 */
export class ToggleDisableInverterRequest implements GrpcMessage {
  static id = 'epicore.admin.ToggleDisableInverterRequest';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new ToggleDisableInverterRequest();
    ToggleDisableInverterRequest.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: ToggleDisableInverterRequest) {
    _instance.plantId = _instance.plantId || 0;
    _instance.inverterId = _instance.inverterId || 0;
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: ToggleDisableInverterRequest,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.plantId = _reader.readInt32();
          break;
        case 2:
          _instance.inverterId = _reader.readInt32();
          break;
        default:
          _reader.skipField();
      }
    }

    ToggleDisableInverterRequest.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: ToggleDisableInverterRequest,
    _writer: BinaryWriter
  ) {
    if (_instance.plantId) {
      _writer.writeInt32(1, _instance.plantId);
    }
    if (_instance.inverterId) {
      _writer.writeInt32(2, _instance.inverterId);
    }
  }

  private _plantId: number;
  private _inverterId: number;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of ToggleDisableInverterRequest to deeply clone from
   */
  constructor(
    _value?: RecursivePartial<ToggleDisableInverterRequest.AsObject>
  ) {
    _value = _value || {};
    this.plantId = _value.plantId;
    this.inverterId = _value.inverterId;
    ToggleDisableInverterRequest.refineValues(this);
  }
  get plantId(): number {
    return this._plantId;
  }
  set plantId(value: number) {
    this._plantId = value;
  }
  get inverterId(): number {
    return this._inverterId;
  }
  set inverterId(value: number) {
    this._inverterId = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    ToggleDisableInverterRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): ToggleDisableInverterRequest.AsObject {
    return {
      plantId: this.plantId,
      inverterId: this.inverterId
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): ToggleDisableInverterRequest.AsProtobufJSON {
    return {
      plantId: this.plantId,
      inverterId: this.inverterId
    };
  }
}
export module ToggleDisableInverterRequest {
  /**
   * Standard JavaScript object representation for ToggleDisableInverterRequest
   */
  export interface AsObject {
    plantId: number;
    inverterId: number;
  }

  /**
   * Protobuf JSON representation for ToggleDisableInverterRequest
   */
  export interface AsProtobufJSON {
    plantId: number;
    inverterId: number;
  }
}

/**
 * Message implementation for epicore.admin.ToggleDisableInverterResponse
 */
export class ToggleDisableInverterResponse implements GrpcMessage {
  static id = 'epicore.admin.ToggleDisableInverterResponse';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new ToggleDisableInverterResponse();
    ToggleDisableInverterResponse.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: ToggleDisableInverterResponse) {
    _instance.currentStatus = _instance.currentStatus || false;
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: ToggleDisableInverterResponse,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.currentStatus = _reader.readBool();
          break;
        default:
          _reader.skipField();
      }
    }

    ToggleDisableInverterResponse.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: ToggleDisableInverterResponse,
    _writer: BinaryWriter
  ) {
    if (_instance.currentStatus) {
      _writer.writeBool(1, _instance.currentStatus);
    }
  }

  private _currentStatus: boolean;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of ToggleDisableInverterResponse to deeply clone from
   */
  constructor(
    _value?: RecursivePartial<ToggleDisableInverterResponse.AsObject>
  ) {
    _value = _value || {};
    this.currentStatus = _value.currentStatus;
    ToggleDisableInverterResponse.refineValues(this);
  }
  get currentStatus(): boolean {
    return this._currentStatus;
  }
  set currentStatus(value: boolean) {
    this._currentStatus = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    ToggleDisableInverterResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): ToggleDisableInverterResponse.AsObject {
    return {
      currentStatus: this.currentStatus
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): ToggleDisableInverterResponse.AsProtobufJSON {
    return {
      currentStatus: this.currentStatus
    };
  }
}
export module ToggleDisableInverterResponse {
  /**
   * Standard JavaScript object representation for ToggleDisableInverterResponse
   */
  export interface AsObject {
    currentStatus: boolean;
  }

  /**
   * Protobuf JSON representation for ToggleDisableInverterResponse
   */
  export interface AsProtobufJSON {
    currentStatus: boolean;
  }
}

/**
 * Message implementation for epicore.admin.TimeZonesResponse
 */
export class TimeZonesResponse implements GrpcMessage {
  static id = 'epicore.admin.TimeZonesResponse';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new TimeZonesResponse();
    TimeZonesResponse.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: TimeZonesResponse) {
    _instance.timeZones = _instance.timeZones || [];
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: TimeZonesResponse,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          const messageInitializer1 = new CityZoneId();
          _reader.readMessage(
            messageInitializer1,
            CityZoneId.deserializeBinaryFromReader
          );
          (_instance.timeZones = _instance.timeZones || []).push(
            messageInitializer1
          );
          break;
        default:
          _reader.skipField();
      }
    }

    TimeZonesResponse.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: TimeZonesResponse,
    _writer: BinaryWriter
  ) {
    if (_instance.timeZones && _instance.timeZones.length) {
      _writer.writeRepeatedMessage(
        1,
        _instance.timeZones as any,
        CityZoneId.serializeBinaryToWriter
      );
    }
  }

  private _timeZones?: CityZoneId[];

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of TimeZonesResponse to deeply clone from
   */
  constructor(_value?: RecursivePartial<TimeZonesResponse.AsObject>) {
    _value = _value || {};
    this.timeZones = (_value.timeZones || []).map(m => new CityZoneId(m));
    TimeZonesResponse.refineValues(this);
  }
  get timeZones(): CityZoneId[] | undefined {
    return this._timeZones;
  }
  set timeZones(value: CityZoneId[] | undefined) {
    this._timeZones = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    TimeZonesResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): TimeZonesResponse.AsObject {
    return {
      timeZones: (this.timeZones || []).map(m => m.toObject())
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): TimeZonesResponse.AsProtobufJSON {
    return {
      timeZones: (this.timeZones || []).map(m => m.toProtobufJSON(options))
    };
  }
}
export module TimeZonesResponse {
  /**
   * Standard JavaScript object representation for TimeZonesResponse
   */
  export interface AsObject {
    timeZones?: CityZoneId.AsObject[];
  }

  /**
   * Protobuf JSON representation for TimeZonesResponse
   */
  export interface AsProtobufJSON {
    timeZones: CityZoneId.AsProtobufJSON[] | null;
  }
}

/**
 * Message implementation for epicore.admin.CityZoneId
 */
export class CityZoneId implements GrpcMessage {
  static id = 'epicore.admin.CityZoneId';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new CityZoneId();
    CityZoneId.deserializeBinaryFromReader(instance, new BinaryReader(bytes));
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: CityZoneId) {
    _instance.title = _instance.title || '';
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: CityZoneId,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.title = _reader.readString();
          break;
        default:
          _reader.skipField();
      }
    }

    CityZoneId.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(_instance: CityZoneId, _writer: BinaryWriter) {
    if (_instance.title) {
      _writer.writeString(1, _instance.title);
    }
  }

  private _title: string;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of CityZoneId to deeply clone from
   */
  constructor(_value?: RecursivePartial<CityZoneId.AsObject>) {
    _value = _value || {};
    this.title = _value.title;
    CityZoneId.refineValues(this);
  }
  get title(): string {
    return this._title;
  }
  set title(value: string) {
    this._title = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    CityZoneId.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): CityZoneId.AsObject {
    return {
      title: this.title
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): CityZoneId.AsProtobufJSON {
    return {
      title: this.title
    };
  }
}
export module CityZoneId {
  /**
   * Standard JavaScript object representation for CityZoneId
   */
  export interface AsObject {
    title: string;
  }

  /**
   * Protobuf JSON representation for CityZoneId
   */
  export interface AsProtobufJSON {
    title: string;
  }
}

/**
 * Message implementation for epicore.admin.GetCitiesRequest
 */
export class GetCitiesRequest implements GrpcMessage {
  static id = 'epicore.admin.GetCitiesRequest';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new GetCitiesRequest();
    GetCitiesRequest.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: GetCitiesRequest) {
    _instance.searchText = _instance.searchText || '';
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: GetCitiesRequest,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.searchText = _reader.readString();
          break;
        default:
          _reader.skipField();
      }
    }

    GetCitiesRequest.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: GetCitiesRequest,
    _writer: BinaryWriter
  ) {
    if (_instance.searchText) {
      _writer.writeString(1, _instance.searchText);
    }
  }

  private _searchText: string;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of GetCitiesRequest to deeply clone from
   */
  constructor(_value?: RecursivePartial<GetCitiesRequest.AsObject>) {
    _value = _value || {};
    this.searchText = _value.searchText;
    GetCitiesRequest.refineValues(this);
  }
  get searchText(): string {
    return this._searchText;
  }
  set searchText(value: string) {
    this._searchText = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    GetCitiesRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): GetCitiesRequest.AsObject {
    return {
      searchText: this.searchText
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): GetCitiesRequest.AsProtobufJSON {
    return {
      searchText: this.searchText
    };
  }
}
export module GetCitiesRequest {
  /**
   * Standard JavaScript object representation for GetCitiesRequest
   */
  export interface AsObject {
    searchText: string;
  }

  /**
   * Protobuf JSON representation for GetCitiesRequest
   */
  export interface AsProtobufJSON {
    searchText: string;
  }
}

/**
 * Message implementation for epicore.admin.ToggleDisableCityRequest
 */
export class ToggleDisableCityRequest implements GrpcMessage {
  static id = 'epicore.admin.ToggleDisableCityRequest';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new ToggleDisableCityRequest();
    ToggleDisableCityRequest.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: ToggleDisableCityRequest) {
    _instance.id = _instance.id || 0;
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: ToggleDisableCityRequest,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.id = _reader.readInt32();
          break;
        default:
          _reader.skipField();
      }
    }

    ToggleDisableCityRequest.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: ToggleDisableCityRequest,
    _writer: BinaryWriter
  ) {
    if (_instance.id) {
      _writer.writeInt32(1, _instance.id);
    }
  }

  private _id: number;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of ToggleDisableCityRequest to deeply clone from
   */
  constructor(_value?: RecursivePartial<ToggleDisableCityRequest.AsObject>) {
    _value = _value || {};
    this.id = _value.id;
    ToggleDisableCityRequest.refineValues(this);
  }
  get id(): number {
    return this._id;
  }
  set id(value: number) {
    this._id = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    ToggleDisableCityRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): ToggleDisableCityRequest.AsObject {
    return {
      id: this.id
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): ToggleDisableCityRequest.AsProtobufJSON {
    return {
      id: this.id
    };
  }
}
export module ToggleDisableCityRequest {
  /**
   * Standard JavaScript object representation for ToggleDisableCityRequest
   */
  export interface AsObject {
    id: number;
  }

  /**
   * Protobuf JSON representation for ToggleDisableCityRequest
   */
  export interface AsProtobufJSON {
    id: number;
  }
}

/**
 * Message implementation for epicore.admin.NewCityRequest
 */
export class NewCityRequest implements GrpcMessage {
  static id = 'epicore.admin.NewCityRequest';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new NewCityRequest();
    NewCityRequest.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: NewCityRequest) {
    _instance.title = _instance.title || '';
    _instance.timeZoneId = _instance.timeZoneId || '';
    _instance.latitude = _instance.latitude || 0;
    _instance.longitude = _instance.longitude || 0;
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: NewCityRequest,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.title = _reader.readString();
          break;
        case 2:
          _instance.timeZoneId = _reader.readString();
          break;
        case 3:
          _instance.latitude = _reader.readDouble();
          break;
        case 4:
          _instance.longitude = _reader.readDouble();
          break;
        default:
          _reader.skipField();
      }
    }

    NewCityRequest.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: NewCityRequest,
    _writer: BinaryWriter
  ) {
    if (_instance.title) {
      _writer.writeString(1, _instance.title);
    }
    if (_instance.timeZoneId) {
      _writer.writeString(2, _instance.timeZoneId);
    }
    if (_instance.latitude) {
      _writer.writeDouble(3, _instance.latitude);
    }
    if (_instance.longitude) {
      _writer.writeDouble(4, _instance.longitude);
    }
  }

  private _title: string;
  private _timeZoneId: string;
  private _latitude: number;
  private _longitude: number;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of NewCityRequest to deeply clone from
   */
  constructor(_value?: RecursivePartial<NewCityRequest.AsObject>) {
    _value = _value || {};
    this.title = _value.title;
    this.timeZoneId = _value.timeZoneId;
    this.latitude = _value.latitude;
    this.longitude = _value.longitude;
    NewCityRequest.refineValues(this);
  }
  get title(): string {
    return this._title;
  }
  set title(value: string) {
    this._title = value;
  }
  get timeZoneId(): string {
    return this._timeZoneId;
  }
  set timeZoneId(value: string) {
    this._timeZoneId = value;
  }
  get latitude(): number {
    return this._latitude;
  }
  set latitude(value: number) {
    this._latitude = value;
  }
  get longitude(): number {
    return this._longitude;
  }
  set longitude(value: number) {
    this._longitude = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    NewCityRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): NewCityRequest.AsObject {
    return {
      title: this.title,
      timeZoneId: this.timeZoneId,
      latitude: this.latitude,
      longitude: this.longitude
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): NewCityRequest.AsProtobufJSON {
    return {
      title: this.title,
      timeZoneId: this.timeZoneId,
      latitude: this.latitude,
      longitude: this.longitude
    };
  }
}
export module NewCityRequest {
  /**
   * Standard JavaScript object representation for NewCityRequest
   */
  export interface AsObject {
    title: string;
    timeZoneId: string;
    latitude: number;
    longitude: number;
  }

  /**
   * Protobuf JSON representation for NewCityRequest
   */
  export interface AsProtobufJSON {
    title: string;
    timeZoneId: string;
    latitude: number;
    longitude: number;
  }
}

/**
 * Message implementation for epicore.admin.ToggleDisableCityResponse
 */
export class ToggleDisableCityResponse implements GrpcMessage {
  static id = 'epicore.admin.ToggleDisableCityResponse';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new ToggleDisableCityResponse();
    ToggleDisableCityResponse.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: ToggleDisableCityResponse) {
    _instance.currentStatus = _instance.currentStatus || false;
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: ToggleDisableCityResponse,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.currentStatus = _reader.readBool();
          break;
        default:
          _reader.skipField();
      }
    }

    ToggleDisableCityResponse.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: ToggleDisableCityResponse,
    _writer: BinaryWriter
  ) {
    if (_instance.currentStatus) {
      _writer.writeBool(1, _instance.currentStatus);
    }
  }

  private _currentStatus: boolean;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of ToggleDisableCityResponse to deeply clone from
   */
  constructor(_value?: RecursivePartial<ToggleDisableCityResponse.AsObject>) {
    _value = _value || {};
    this.currentStatus = _value.currentStatus;
    ToggleDisableCityResponse.refineValues(this);
  }
  get currentStatus(): boolean {
    return this._currentStatus;
  }
  set currentStatus(value: boolean) {
    this._currentStatus = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    ToggleDisableCityResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): ToggleDisableCityResponse.AsObject {
    return {
      currentStatus: this.currentStatus
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): ToggleDisableCityResponse.AsProtobufJSON {
    return {
      currentStatus: this.currentStatus
    };
  }
}
export module ToggleDisableCityResponse {
  /**
   * Standard JavaScript object representation for ToggleDisableCityResponse
   */
  export interface AsObject {
    currentStatus: boolean;
  }

  /**
   * Protobuf JSON representation for ToggleDisableCityResponse
   */
  export interface AsProtobufJSON {
    currentStatus: boolean;
  }
}

/**
 * Message implementation for epicore.admin.UpdateCityRequest
 */
export class UpdateCityRequest implements GrpcMessage {
  static id = 'epicore.admin.UpdateCityRequest';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new UpdateCityRequest();
    UpdateCityRequest.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: UpdateCityRequest) {
    _instance.id = _instance.id || 0;
    _instance.title = _instance.title || '';
    _instance.timeZoneId = _instance.timeZoneId || '';
    _instance.latitude = _instance.latitude || 0;
    _instance.longitude = _instance.longitude || 0;
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: UpdateCityRequest,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.id = _reader.readInt32();
          break;
        case 2:
          _instance.title = _reader.readString();
          break;
        case 3:
          _instance.timeZoneId = _reader.readString();
          break;
        case 4:
          _instance.latitude = _reader.readDouble();
          break;
        case 5:
          _instance.longitude = _reader.readDouble();
          break;
        default:
          _reader.skipField();
      }
    }

    UpdateCityRequest.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: UpdateCityRequest,
    _writer: BinaryWriter
  ) {
    if (_instance.id) {
      _writer.writeInt32(1, _instance.id);
    }
    if (_instance.title) {
      _writer.writeString(2, _instance.title);
    }
    if (_instance.timeZoneId) {
      _writer.writeString(3, _instance.timeZoneId);
    }
    if (_instance.latitude) {
      _writer.writeDouble(4, _instance.latitude);
    }
    if (_instance.longitude) {
      _writer.writeDouble(5, _instance.longitude);
    }
  }

  private _id: number;
  private _title: string;
  private _timeZoneId: string;
  private _latitude: number;
  private _longitude: number;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of UpdateCityRequest to deeply clone from
   */
  constructor(_value?: RecursivePartial<UpdateCityRequest.AsObject>) {
    _value = _value || {};
    this.id = _value.id;
    this.title = _value.title;
    this.timeZoneId = _value.timeZoneId;
    this.latitude = _value.latitude;
    this.longitude = _value.longitude;
    UpdateCityRequest.refineValues(this);
  }
  get id(): number {
    return this._id;
  }
  set id(value: number) {
    this._id = value;
  }
  get title(): string {
    return this._title;
  }
  set title(value: string) {
    this._title = value;
  }
  get timeZoneId(): string {
    return this._timeZoneId;
  }
  set timeZoneId(value: string) {
    this._timeZoneId = value;
  }
  get latitude(): number {
    return this._latitude;
  }
  set latitude(value: number) {
    this._latitude = value;
  }
  get longitude(): number {
    return this._longitude;
  }
  set longitude(value: number) {
    this._longitude = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    UpdateCityRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): UpdateCityRequest.AsObject {
    return {
      id: this.id,
      title: this.title,
      timeZoneId: this.timeZoneId,
      latitude: this.latitude,
      longitude: this.longitude
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): UpdateCityRequest.AsProtobufJSON {
    return {
      id: this.id,
      title: this.title,
      timeZoneId: this.timeZoneId,
      latitude: this.latitude,
      longitude: this.longitude
    };
  }
}
export module UpdateCityRequest {
  /**
   * Standard JavaScript object representation for UpdateCityRequest
   */
  export interface AsObject {
    id: number;
    title: string;
    timeZoneId: string;
    latitude: number;
    longitude: number;
  }

  /**
   * Protobuf JSON representation for UpdateCityRequest
   */
  export interface AsProtobufJSON {
    id: number;
    title: string;
    timeZoneId: string;
    latitude: number;
    longitude: number;
  }
}

/**
 * Message implementation for epicore.admin.CityResponse
 */
export class CityResponse implements GrpcMessage {
  static id = 'epicore.admin.CityResponse';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new CityResponse();
    CityResponse.deserializeBinaryFromReader(instance, new BinaryReader(bytes));
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: CityResponse) {
    _instance.id = _instance.id || 0;
    _instance.title = _instance.title || '';
    _instance.timeZoneId = _instance.timeZoneId || '';
    _instance.disabled = _instance.disabled || false;
    _instance.createdAt = _instance.createdAt || undefined;
    _instance.lastUpdate = _instance.lastUpdate || undefined;
    _instance.latitude = _instance.latitude || 0;
    _instance.longitude = _instance.longitude || 0;
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: CityResponse,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.id = _reader.readInt32();
          break;
        case 2:
          _instance.title = _reader.readString();
          break;
        case 3:
          _instance.timeZoneId = _reader.readString();
          break;
        case 4:
          _instance.disabled = _reader.readBool();
          break;
        case 5:
          _instance.createdAt = new googleProtobuf001.Timestamp();
          _reader.readMessage(
            _instance.createdAt,
            googleProtobuf001.Timestamp.deserializeBinaryFromReader
          );
          break;
        case 6:
          _instance.lastUpdate = new googleProtobuf001.Timestamp();
          _reader.readMessage(
            _instance.lastUpdate,
            googleProtobuf001.Timestamp.deserializeBinaryFromReader
          );
          break;
        case 7:
          _instance.latitude = _reader.readDouble();
          break;
        case 8:
          _instance.longitude = _reader.readDouble();
          break;
        default:
          _reader.skipField();
      }
    }

    CityResponse.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: CityResponse,
    _writer: BinaryWriter
  ) {
    if (_instance.id) {
      _writer.writeInt32(1, _instance.id);
    }
    if (_instance.title) {
      _writer.writeString(2, _instance.title);
    }
    if (_instance.timeZoneId) {
      _writer.writeString(3, _instance.timeZoneId);
    }
    if (_instance.disabled) {
      _writer.writeBool(4, _instance.disabled);
    }
    if (_instance.createdAt) {
      _writer.writeMessage(
        5,
        _instance.createdAt as any,
        googleProtobuf001.Timestamp.serializeBinaryToWriter
      );
    }
    if (_instance.lastUpdate) {
      _writer.writeMessage(
        6,
        _instance.lastUpdate as any,
        googleProtobuf001.Timestamp.serializeBinaryToWriter
      );
    }
    if (_instance.latitude) {
      _writer.writeDouble(7, _instance.latitude);
    }
    if (_instance.longitude) {
      _writer.writeDouble(8, _instance.longitude);
    }
  }

  private _id: number;
  private _title: string;
  private _timeZoneId: string;
  private _disabled: boolean;
  private _createdAt?: googleProtobuf001.Timestamp;
  private _lastUpdate?: googleProtobuf001.Timestamp;
  private _latitude: number;
  private _longitude: number;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of CityResponse to deeply clone from
   */
  constructor(_value?: RecursivePartial<CityResponse.AsObject>) {
    _value = _value || {};
    this.id = _value.id;
    this.title = _value.title;
    this.timeZoneId = _value.timeZoneId;
    this.disabled = _value.disabled;
    this.createdAt = _value.createdAt
      ? new googleProtobuf001.Timestamp(_value.createdAt)
      : undefined;
    this.lastUpdate = _value.lastUpdate
      ? new googleProtobuf001.Timestamp(_value.lastUpdate)
      : undefined;
    this.latitude = _value.latitude;
    this.longitude = _value.longitude;
    CityResponse.refineValues(this);
  }
  get id(): number {
    return this._id;
  }
  set id(value: number) {
    this._id = value;
  }
  get title(): string {
    return this._title;
  }
  set title(value: string) {
    this._title = value;
  }
  get timeZoneId(): string {
    return this._timeZoneId;
  }
  set timeZoneId(value: string) {
    this._timeZoneId = value;
  }
  get disabled(): boolean {
    return this._disabled;
  }
  set disabled(value: boolean) {
    this._disabled = value;
  }
  get createdAt(): googleProtobuf001.Timestamp | undefined {
    return this._createdAt;
  }
  set createdAt(value: googleProtobuf001.Timestamp | undefined) {
    this._createdAt = value;
  }
  get lastUpdate(): googleProtobuf001.Timestamp | undefined {
    return this._lastUpdate;
  }
  set lastUpdate(value: googleProtobuf001.Timestamp | undefined) {
    this._lastUpdate = value;
  }
  get latitude(): number {
    return this._latitude;
  }
  set latitude(value: number) {
    this._latitude = value;
  }
  get longitude(): number {
    return this._longitude;
  }
  set longitude(value: number) {
    this._longitude = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    CityResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): CityResponse.AsObject {
    return {
      id: this.id,
      title: this.title,
      timeZoneId: this.timeZoneId,
      disabled: this.disabled,
      createdAt: this.createdAt ? this.createdAt.toObject() : undefined,
      lastUpdate: this.lastUpdate ? this.lastUpdate.toObject() : undefined,
      latitude: this.latitude,
      longitude: this.longitude
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): CityResponse.AsProtobufJSON {
    return {
      id: this.id,
      title: this.title,
      timeZoneId: this.timeZoneId,
      disabled: this.disabled,
      createdAt: this.createdAt ? this.createdAt.toProtobufJSON(options) : null,
      lastUpdate: this.lastUpdate
        ? this.lastUpdate.toProtobufJSON(options)
        : null,
      latitude: this.latitude,
      longitude: this.longitude
    };
  }
}
export module CityResponse {
  /**
   * Standard JavaScript object representation for CityResponse
   */
  export interface AsObject {
    id: number;
    title: string;
    timeZoneId: string;
    disabled: boolean;
    createdAt?: googleProtobuf001.Timestamp.AsObject;
    lastUpdate?: googleProtobuf001.Timestamp.AsObject;
    latitude: number;
    longitude: number;
  }

  /**
   * Protobuf JSON representation for CityResponse
   */
  export interface AsProtobufJSON {
    id: number;
    title: string;
    timeZoneId: string;
    disabled: boolean;
    createdAt: googleProtobuf001.Timestamp.AsProtobufJSON | null;
    lastUpdate: googleProtobuf001.Timestamp.AsProtobufJSON | null;
    latitude: number;
    longitude: number;
  }
}

/**
 * Message implementation for epicore.admin.CitiesResponse
 */
export class CitiesResponse implements GrpcMessage {
  static id = 'epicore.admin.CitiesResponse';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new CitiesResponse();
    CitiesResponse.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: CitiesResponse) {
    _instance.cities = _instance.cities || [];
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: CitiesResponse,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          const messageInitializer1 = new CityResponse();
          _reader.readMessage(
            messageInitializer1,
            CityResponse.deserializeBinaryFromReader
          );
          (_instance.cities = _instance.cities || []).push(messageInitializer1);
          break;
        default:
          _reader.skipField();
      }
    }

    CitiesResponse.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: CitiesResponse,
    _writer: BinaryWriter
  ) {
    if (_instance.cities && _instance.cities.length) {
      _writer.writeRepeatedMessage(
        1,
        _instance.cities as any,
        CityResponse.serializeBinaryToWriter
      );
    }
  }

  private _cities?: CityResponse[];

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of CitiesResponse to deeply clone from
   */
  constructor(_value?: RecursivePartial<CitiesResponse.AsObject>) {
    _value = _value || {};
    this.cities = (_value.cities || []).map(m => new CityResponse(m));
    CitiesResponse.refineValues(this);
  }
  get cities(): CityResponse[] | undefined {
    return this._cities;
  }
  set cities(value: CityResponse[] | undefined) {
    this._cities = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    CitiesResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): CitiesResponse.AsObject {
    return {
      cities: (this.cities || []).map(m => m.toObject())
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): CitiesResponse.AsProtobufJSON {
    return {
      cities: (this.cities || []).map(m => m.toProtobufJSON(options))
    };
  }
}
export module CitiesResponse {
  /**
   * Standard JavaScript object representation for CitiesResponse
   */
  export interface AsObject {
    cities?: CityResponse.AsObject[];
  }

  /**
   * Protobuf JSON representation for CitiesResponse
   */
  export interface AsProtobufJSON {
    cities: CityResponse.AsProtobufJSON[] | null;
  }
}

/**
 * Message implementation for epicore.admin.UploadPlantImageRequest
 */
export class UploadPlantImageRequest implements GrpcMessage {
  static id = 'epicore.admin.UploadPlantImageRequest';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new UploadPlantImageRequest();
    UploadPlantImageRequest.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: UploadPlantImageRequest) {}

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: UploadPlantImageRequest,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.info = new ImageInfo();
          _reader.readMessage(
            _instance.info,
            ImageInfo.deserializeBinaryFromReader
          );
          break;
        case 2:
          _instance.chunkData = _reader.readBytes();
          break;
        default:
          _reader.skipField();
      }
    }

    UploadPlantImageRequest.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: UploadPlantImageRequest,
    _writer: BinaryWriter
  ) {
    if (_instance.info) {
      _writer.writeMessage(
        1,
        _instance.info as any,
        ImageInfo.serializeBinaryToWriter
      );
    }
    if (_instance.chunkData && _instance.chunkData.length) {
      _writer.writeBytes(2, _instance.chunkData);
    }
  }

  private _info?: ImageInfo;
  private _chunkData: Uint8Array;

  private _data: UploadPlantImageRequest.DataCase =
    UploadPlantImageRequest.DataCase.none;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of UploadPlantImageRequest to deeply clone from
   */
  constructor(_value?: RecursivePartial<UploadPlantImageRequest.AsObject>) {
    _value = _value || {};
    this.info = _value.info ? new ImageInfo(_value.info) : undefined;
    this.chunkData = _value.chunkData;
    UploadPlantImageRequest.refineValues(this);
  }
  get info(): ImageInfo | undefined {
    return this._info;
  }
  set info(value: ImageInfo | undefined) {
    if (value !== undefined && value !== null) {
      this._chunkData = undefined;
      this._data = UploadPlantImageRequest.DataCase.info;
    }
    this._info = value;
  }
  get chunkData(): Uint8Array {
    return this._chunkData;
  }
  set chunkData(value: Uint8Array) {
    if (value !== undefined && value !== null) {
      this._info = undefined;
      this._data = UploadPlantImageRequest.DataCase.chunkData;
    }
    this._chunkData = value;
  }
  get data() {
    return this._data;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    UploadPlantImageRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): UploadPlantImageRequest.AsObject {
    return {
      info: this.info ? this.info.toObject() : undefined,
      chunkData: this.chunkData ? this.chunkData.subarray(0) : new Uint8Array()
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): UploadPlantImageRequest.AsProtobufJSON {
    return {
      info: this.info ? this.info.toProtobufJSON(options) : null,
      chunkData: this.chunkData ? uint8ArrayToBase64(this.chunkData) : ''
    };
  }
}
export module UploadPlantImageRequest {
  /**
   * Standard JavaScript object representation for UploadPlantImageRequest
   */
  export interface AsObject {
    info?: ImageInfo.AsObject;
    chunkData: Uint8Array;
  }

  /**
   * Protobuf JSON representation for UploadPlantImageRequest
   */
  export interface AsProtobufJSON {
    info: ImageInfo.AsProtobufJSON | null;
    chunkData: string;
  }
  export enum DataCase {
    none = 0,
    info = 1,
    chunkData = 2
  }
}

/**
 * Message implementation for epicore.admin.ImageInfo
 */
export class ImageInfo implements GrpcMessage {
  static id = 'epicore.admin.ImageInfo';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new ImageInfo();
    ImageInfo.deserializeBinaryFromReader(instance, new BinaryReader(bytes));
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: ImageInfo) {
    _instance.plantId = _instance.plantId || 0;
    _instance.imageType = _instance.imageType || '';
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: ImageInfo,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.plantId = _reader.readInt32();
          break;
        case 2:
          _instance.imageType = _reader.readString();
          break;
        default:
          _reader.skipField();
      }
    }

    ImageInfo.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(_instance: ImageInfo, _writer: BinaryWriter) {
    if (_instance.plantId) {
      _writer.writeInt32(1, _instance.plantId);
    }
    if (_instance.imageType) {
      _writer.writeString(2, _instance.imageType);
    }
  }

  private _plantId: number;
  private _imageType: string;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of ImageInfo to deeply clone from
   */
  constructor(_value?: RecursivePartial<ImageInfo.AsObject>) {
    _value = _value || {};
    this.plantId = _value.plantId;
    this.imageType = _value.imageType;
    ImageInfo.refineValues(this);
  }
  get plantId(): number {
    return this._plantId;
  }
  set plantId(value: number) {
    this._plantId = value;
  }
  get imageType(): string {
    return this._imageType;
  }
  set imageType(value: string) {
    this._imageType = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    ImageInfo.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): ImageInfo.AsObject {
    return {
      plantId: this.plantId,
      imageType: this.imageType
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): ImageInfo.AsProtobufJSON {
    return {
      plantId: this.plantId,
      imageType: this.imageType
    };
  }
}
export module ImageInfo {
  /**
   * Standard JavaScript object representation for ImageInfo
   */
  export interface AsObject {
    plantId: number;
    imageType: string;
  }

  /**
   * Protobuf JSON representation for ImageInfo
   */
  export interface AsProtobufJSON {
    plantId: number;
    imageType: string;
  }
}

/**
 * Message implementation for epicore.admin.UploadPlantImageResponse
 */
export class UploadPlantImageResponse implements GrpcMessage {
  static id = 'epicore.admin.UploadPlantImageResponse';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new UploadPlantImageResponse();
    UploadPlantImageResponse.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: UploadPlantImageResponse) {
    _instance.id = _instance.id || '';
    _instance.size = _instance.size || 0;
    _instance.imageUrl = _instance.imageUrl || '';
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: UploadPlantImageResponse,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.id = _reader.readString();
          break;
        case 2:
          _instance.size = _reader.readUint32();
          break;
        case 3:
          _instance.imageUrl = _reader.readString();
          break;
        default:
          _reader.skipField();
      }
    }

    UploadPlantImageResponse.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: UploadPlantImageResponse,
    _writer: BinaryWriter
  ) {
    if (_instance.id) {
      _writer.writeString(1, _instance.id);
    }
    if (_instance.size) {
      _writer.writeUint32(2, _instance.size);
    }
    if (_instance.imageUrl) {
      _writer.writeString(3, _instance.imageUrl);
    }
  }

  private _id: string;
  private _size: number;
  private _imageUrl: string;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of UploadPlantImageResponse to deeply clone from
   */
  constructor(_value?: RecursivePartial<UploadPlantImageResponse.AsObject>) {
    _value = _value || {};
    this.id = _value.id;
    this.size = _value.size;
    this.imageUrl = _value.imageUrl;
    UploadPlantImageResponse.refineValues(this);
  }
  get id(): string {
    return this._id;
  }
  set id(value: string) {
    this._id = value;
  }
  get size(): number {
    return this._size;
  }
  set size(value: number) {
    this._size = value;
  }
  get imageUrl(): string {
    return this._imageUrl;
  }
  set imageUrl(value: string) {
    this._imageUrl = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    UploadPlantImageResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): UploadPlantImageResponse.AsObject {
    return {
      id: this.id,
      size: this.size,
      imageUrl: this.imageUrl
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): UploadPlantImageResponse.AsProtobufJSON {
    return {
      id: this.id,
      size: this.size,
      imageUrl: this.imageUrl
    };
  }
}
export module UploadPlantImageResponse {
  /**
   * Standard JavaScript object representation for UploadPlantImageResponse
   */
  export interface AsObject {
    id: string;
    size: number;
    imageUrl: string;
  }

  /**
   * Protobuf JSON representation for UploadPlantImageResponse
   */
  export interface AsProtobufJSON {
    id: string;
    size: number;
    imageUrl: string;
  }
}

/**
 * Message implementation for epicore.admin.GetPlantImageRequest
 */
export class GetPlantImageRequest implements GrpcMessage {
  static id = 'epicore.admin.GetPlantImageRequest';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new GetPlantImageRequest();
    GetPlantImageRequest.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: GetPlantImageRequest) {
    _instance.id = _instance.id || '';
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: GetPlantImageRequest,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.id = _reader.readString();
          break;
        default:
          _reader.skipField();
      }
    }

    GetPlantImageRequest.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: GetPlantImageRequest,
    _writer: BinaryWriter
  ) {
    if (_instance.id) {
      _writer.writeString(1, _instance.id);
    }
  }

  private _id: string;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of GetPlantImageRequest to deeply clone from
   */
  constructor(_value?: RecursivePartial<GetPlantImageRequest.AsObject>) {
    _value = _value || {};
    this.id = _value.id;
    GetPlantImageRequest.refineValues(this);
  }
  get id(): string {
    return this._id;
  }
  set id(value: string) {
    this._id = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    GetPlantImageRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): GetPlantImageRequest.AsObject {
    return {
      id: this.id
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): GetPlantImageRequest.AsProtobufJSON {
    return {
      id: this.id
    };
  }
}
export module GetPlantImageRequest {
  /**
   * Standard JavaScript object representation for GetPlantImageRequest
   */
  export interface AsObject {
    id: string;
  }

  /**
   * Protobuf JSON representation for GetPlantImageRequest
   */
  export interface AsProtobufJSON {
    id: string;
  }
}

/**
 * Message implementation for epicore.admin.GetPlantImageResponse
 */
export class GetPlantImageResponse implements GrpcMessage {
  static id = 'epicore.admin.GetPlantImageResponse';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new GetPlantImageResponse();
    GetPlantImageResponse.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: GetPlantImageResponse) {
    _instance.chunkData = _instance.chunkData || new Uint8Array();
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: GetPlantImageResponse,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.chunkData = _reader.readBytes();
          break;
        default:
          _reader.skipField();
      }
    }

    GetPlantImageResponse.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: GetPlantImageResponse,
    _writer: BinaryWriter
  ) {
    if (_instance.chunkData && _instance.chunkData.length) {
      _writer.writeBytes(1, _instance.chunkData);
    }
  }

  private _chunkData: Uint8Array;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of GetPlantImageResponse to deeply clone from
   */
  constructor(_value?: RecursivePartial<GetPlantImageResponse.AsObject>) {
    _value = _value || {};
    this.chunkData = _value.chunkData;
    GetPlantImageResponse.refineValues(this);
  }
  get chunkData(): Uint8Array {
    return this._chunkData;
  }
  set chunkData(value: Uint8Array) {
    this._chunkData = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    GetPlantImageResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): GetPlantImageResponse.AsObject {
    return {
      chunkData: this.chunkData ? this.chunkData.subarray(0) : new Uint8Array()
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): GetPlantImageResponse.AsProtobufJSON {
    return {
      chunkData: this.chunkData ? uint8ArrayToBase64(this.chunkData) : ''
    };
  }
}
export module GetPlantImageResponse {
  /**
   * Standard JavaScript object representation for GetPlantImageResponse
   */
  export interface AsObject {
    chunkData: Uint8Array;
  }

  /**
   * Protobuf JSON representation for GetPlantImageResponse
   */
  export interface AsProtobufJSON {
    chunkData: string;
  }
}

/**
 * Message implementation for epicore.admin.GetPlantImageUrlResponse
 */
export class GetPlantImageUrlResponse implements GrpcMessage {
  static id = 'epicore.admin.GetPlantImageUrlResponse';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new GetPlantImageUrlResponse();
    GetPlantImageUrlResponse.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: GetPlantImageUrlResponse) {
    _instance.url = _instance.url || '';
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: GetPlantImageUrlResponse,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.url = _reader.readString();
          break;
        default:
          _reader.skipField();
      }
    }

    GetPlantImageUrlResponse.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: GetPlantImageUrlResponse,
    _writer: BinaryWriter
  ) {
    if (_instance.url) {
      _writer.writeString(1, _instance.url);
    }
  }

  private _url: string;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of GetPlantImageUrlResponse to deeply clone from
   */
  constructor(_value?: RecursivePartial<GetPlantImageUrlResponse.AsObject>) {
    _value = _value || {};
    this.url = _value.url;
    GetPlantImageUrlResponse.refineValues(this);
  }
  get url(): string {
    return this._url;
  }
  set url(value: string) {
    this._url = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    GetPlantImageUrlResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): GetPlantImageUrlResponse.AsObject {
    return {
      url: this.url
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): GetPlantImageUrlResponse.AsProtobufJSON {
    return {
      url: this.url
    };
  }
}
export module GetPlantImageUrlResponse {
  /**
   * Standard JavaScript object representation for GetPlantImageUrlResponse
   */
  export interface AsObject {
    url: string;
  }

  /**
   * Protobuf JSON representation for GetPlantImageUrlResponse
   */
  export interface AsProtobufJSON {
    url: string;
  }
}

/**
 * Message implementation for epicore.admin.GetB2BPlantsResponse
 */
export class GetB2BPlantsResponse implements GrpcMessage {
  static id = 'epicore.admin.GetB2BPlantsResponse';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new GetB2BPlantsResponse();
    GetB2BPlantsResponse.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: GetB2BPlantsResponse) {
    _instance.plants = _instance.plants || [];
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: GetB2BPlantsResponse,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          const messageInitializer1 = new BusinessPlantResponse();
          _reader.readMessage(
            messageInitializer1,
            BusinessPlantResponse.deserializeBinaryFromReader
          );
          (_instance.plants = _instance.plants || []).push(messageInitializer1);
          break;
        default:
          _reader.skipField();
      }
    }

    GetB2BPlantsResponse.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: GetB2BPlantsResponse,
    _writer: BinaryWriter
  ) {
    if (_instance.plants && _instance.plants.length) {
      _writer.writeRepeatedMessage(
        1,
        _instance.plants as any,
        BusinessPlantResponse.serializeBinaryToWriter
      );
    }
  }

  private _plants?: BusinessPlantResponse[];

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of GetB2BPlantsResponse to deeply clone from
   */
  constructor(_value?: RecursivePartial<GetB2BPlantsResponse.AsObject>) {
    _value = _value || {};
    this.plants = (_value.plants || []).map(m => new BusinessPlantResponse(m));
    GetB2BPlantsResponse.refineValues(this);
  }
  get plants(): BusinessPlantResponse[] | undefined {
    return this._plants;
  }
  set plants(value: BusinessPlantResponse[] | undefined) {
    this._plants = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    GetB2BPlantsResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): GetB2BPlantsResponse.AsObject {
    return {
      plants: (this.plants || []).map(m => m.toObject())
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): GetB2BPlantsResponse.AsProtobufJSON {
    return {
      plants: (this.plants || []).map(m => m.toProtobufJSON(options))
    };
  }
}
export module GetB2BPlantsResponse {
  /**
   * Standard JavaScript object representation for GetB2BPlantsResponse
   */
  export interface AsObject {
    plants?: BusinessPlantResponse.AsObject[];
  }

  /**
   * Protobuf JSON representation for GetB2BPlantsResponse
   */
  export interface AsProtobufJSON {
    plants: BusinessPlantResponse.AsProtobufJSON[] | null;
  }
}

/**
 * Message implementation for epicore.admin.BusinessPlantResponse
 */
export class BusinessPlantResponse implements GrpcMessage {
  static id = 'epicore.admin.BusinessPlantResponse';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new BusinessPlantResponse();
    BusinessPlantResponse.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: BusinessPlantResponse) {
    _instance.id = _instance.id || 0;
    _instance.serialNumber = _instance.serialNumber || [];
    _instance.cityId = _instance.cityId || 0;
    _instance.latitude = _instance.latitude || '';
    _instance.longitude = _instance.longitude || '';
    _instance.address = _instance.address || '';
    _instance.disabled = _instance.disabled || false;
    _instance.createdAt = _instance.createdAt || undefined;
    _instance.lastUpdate = _instance.lastUpdate || undefined;
    _instance.userId = _instance.userId || 0;
    _instance.externalReferences = _instance.externalReferences || [];
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: BusinessPlantResponse,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.id = _reader.readInt32();
          break;
        case 2:
          (_instance.serialNumber = _instance.serialNumber || []).push(
            _reader.readString()
          );
          break;
        case 3:
          _instance.cityId = _reader.readInt32();
          break;
        case 4:
          _instance.latitude = _reader.readString();
          break;
        case 5:
          _instance.longitude = _reader.readString();
          break;
        case 6:
          _instance.address = _reader.readString();
          break;
        case 7:
          _instance.disabled = _reader.readBool();
          break;
        case 8:
          _instance.createdAt = new googleProtobuf001.Timestamp();
          _reader.readMessage(
            _instance.createdAt,
            googleProtobuf001.Timestamp.deserializeBinaryFromReader
          );
          break;
        case 9:
          _instance.lastUpdate = new googleProtobuf001.Timestamp();
          _reader.readMessage(
            _instance.lastUpdate,
            googleProtobuf001.Timestamp.deserializeBinaryFromReader
          );
          break;
        case 10:
          _instance.userId = _reader.readInt32();
          break;
        case 11:
          const messageInitializer11 = new BusinessExternalReferences();
          _reader.readMessage(
            messageInitializer11,
            BusinessExternalReferences.deserializeBinaryFromReader
          );
          (_instance.externalReferences =
            _instance.externalReferences || []).push(messageInitializer11);
          break;
        default:
          _reader.skipField();
      }
    }

    BusinessPlantResponse.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: BusinessPlantResponse,
    _writer: BinaryWriter
  ) {
    if (_instance.id) {
      _writer.writeInt32(1, _instance.id);
    }
    if (_instance.serialNumber && _instance.serialNumber.length) {
      _writer.writeRepeatedString(2, _instance.serialNumber);
    }
    if (_instance.cityId) {
      _writer.writeInt32(3, _instance.cityId);
    }
    if (_instance.latitude) {
      _writer.writeString(4, _instance.latitude);
    }
    if (_instance.longitude) {
      _writer.writeString(5, _instance.longitude);
    }
    if (_instance.address) {
      _writer.writeString(6, _instance.address);
    }
    if (_instance.disabled) {
      _writer.writeBool(7, _instance.disabled);
    }
    if (_instance.createdAt) {
      _writer.writeMessage(
        8,
        _instance.createdAt as any,
        googleProtobuf001.Timestamp.serializeBinaryToWriter
      );
    }
    if (_instance.lastUpdate) {
      _writer.writeMessage(
        9,
        _instance.lastUpdate as any,
        googleProtobuf001.Timestamp.serializeBinaryToWriter
      );
    }
    if (_instance.userId) {
      _writer.writeInt32(10, _instance.userId);
    }
    if (_instance.externalReferences && _instance.externalReferences.length) {
      _writer.writeRepeatedMessage(
        11,
        _instance.externalReferences as any,
        BusinessExternalReferences.serializeBinaryToWriter
      );
    }
  }

  private _id: number;
  private _serialNumber: string[];
  private _cityId: number;
  private _latitude: string;
  private _longitude: string;
  private _address: string;
  private _disabled: boolean;
  private _createdAt?: googleProtobuf001.Timestamp;
  private _lastUpdate?: googleProtobuf001.Timestamp;
  private _userId: number;
  private _externalReferences?: BusinessExternalReferences[];

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of BusinessPlantResponse to deeply clone from
   */
  constructor(_value?: RecursivePartial<BusinessPlantResponse.AsObject>) {
    _value = _value || {};
    this.id = _value.id;
    this.serialNumber = (_value.serialNumber || []).slice();
    this.cityId = _value.cityId;
    this.latitude = _value.latitude;
    this.longitude = _value.longitude;
    this.address = _value.address;
    this.disabled = _value.disabled;
    this.createdAt = _value.createdAt
      ? new googleProtobuf001.Timestamp(_value.createdAt)
      : undefined;
    this.lastUpdate = _value.lastUpdate
      ? new googleProtobuf001.Timestamp(_value.lastUpdate)
      : undefined;
    this.userId = _value.userId;
    this.externalReferences = (_value.externalReferences || []).map(
      m => new BusinessExternalReferences(m)
    );
    BusinessPlantResponse.refineValues(this);
  }
  get id(): number {
    return this._id;
  }
  set id(value: number) {
    this._id = value;
  }
  get serialNumber(): string[] {
    return this._serialNumber;
  }
  set serialNumber(value: string[]) {
    this._serialNumber = value;
  }
  get cityId(): number {
    return this._cityId;
  }
  set cityId(value: number) {
    this._cityId = value;
  }
  get latitude(): string {
    return this._latitude;
  }
  set latitude(value: string) {
    this._latitude = value;
  }
  get longitude(): string {
    return this._longitude;
  }
  set longitude(value: string) {
    this._longitude = value;
  }
  get address(): string {
    return this._address;
  }
  set address(value: string) {
    this._address = value;
  }
  get disabled(): boolean {
    return this._disabled;
  }
  set disabled(value: boolean) {
    this._disabled = value;
  }
  get createdAt(): googleProtobuf001.Timestamp | undefined {
    return this._createdAt;
  }
  set createdAt(value: googleProtobuf001.Timestamp | undefined) {
    this._createdAt = value;
  }
  get lastUpdate(): googleProtobuf001.Timestamp | undefined {
    return this._lastUpdate;
  }
  set lastUpdate(value: googleProtobuf001.Timestamp | undefined) {
    this._lastUpdate = value;
  }
  get userId(): number {
    return this._userId;
  }
  set userId(value: number) {
    this._userId = value;
  }
  get externalReferences(): BusinessExternalReferences[] | undefined {
    return this._externalReferences;
  }
  set externalReferences(value: BusinessExternalReferences[] | undefined) {
    this._externalReferences = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    BusinessPlantResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): BusinessPlantResponse.AsObject {
    return {
      id: this.id,
      serialNumber: (this.serialNumber || []).slice(),
      cityId: this.cityId,
      latitude: this.latitude,
      longitude: this.longitude,
      address: this.address,
      disabled: this.disabled,
      createdAt: this.createdAt ? this.createdAt.toObject() : undefined,
      lastUpdate: this.lastUpdate ? this.lastUpdate.toObject() : undefined,
      userId: this.userId,
      externalReferences: (this.externalReferences || []).map(m => m.toObject())
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): BusinessPlantResponse.AsProtobufJSON {
    return {
      id: this.id,
      serialNumber: (this.serialNumber || []).slice(),
      cityId: this.cityId,
      latitude: this.latitude,
      longitude: this.longitude,
      address: this.address,
      disabled: this.disabled,
      createdAt: this.createdAt ? this.createdAt.toProtobufJSON(options) : null,
      lastUpdate: this.lastUpdate
        ? this.lastUpdate.toProtobufJSON(options)
        : null,
      userId: this.userId,
      externalReferences: (this.externalReferences || []).map(m =>
        m.toProtobufJSON(options)
      )
    };
  }
}
export module BusinessPlantResponse {
  /**
   * Standard JavaScript object representation for BusinessPlantResponse
   */
  export interface AsObject {
    id: number;
    serialNumber: string[];
    cityId: number;
    latitude: string;
    longitude: string;
    address: string;
    disabled: boolean;
    createdAt?: googleProtobuf001.Timestamp.AsObject;
    lastUpdate?: googleProtobuf001.Timestamp.AsObject;
    userId: number;
    externalReferences?: BusinessExternalReferences.AsObject[];
  }

  /**
   * Protobuf JSON representation for BusinessPlantResponse
   */
  export interface AsProtobufJSON {
    id: number;
    serialNumber: string[];
    cityId: number;
    latitude: string;
    longitude: string;
    address: string;
    disabled: boolean;
    createdAt: googleProtobuf001.Timestamp.AsProtobufJSON | null;
    lastUpdate: googleProtobuf001.Timestamp.AsProtobufJSON | null;
    userId: number;
    externalReferences: BusinessExternalReferences.AsProtobufJSON[] | null;
  }
}

/**
 * Message implementation for epicore.admin.BusinessExternalReferences
 */
export class BusinessExternalReferences implements GrpcMessage {
  static id = 'epicore.admin.BusinessExternalReferences';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new BusinessExternalReferences();
    BusinessExternalReferences.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: BusinessExternalReferences) {
    _instance.serviceName = _instance.serviceName || '';
    _instance.serviceValue = _instance.serviceValue || '';
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: BusinessExternalReferences,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.serviceName = _reader.readString();
          break;
        case 2:
          _instance.serviceValue = _reader.readString();
          break;
        default:
          _reader.skipField();
      }
    }

    BusinessExternalReferences.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: BusinessExternalReferences,
    _writer: BinaryWriter
  ) {
    if (_instance.serviceName) {
      _writer.writeString(1, _instance.serviceName);
    }
    if (_instance.serviceValue) {
      _writer.writeString(2, _instance.serviceValue);
    }
  }

  private _serviceName: string;
  private _serviceValue: string;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of BusinessExternalReferences to deeply clone from
   */
  constructor(_value?: RecursivePartial<BusinessExternalReferences.AsObject>) {
    _value = _value || {};
    this.serviceName = _value.serviceName;
    this.serviceValue = _value.serviceValue;
    BusinessExternalReferences.refineValues(this);
  }
  get serviceName(): string {
    return this._serviceName;
  }
  set serviceName(value: string) {
    this._serviceName = value;
  }
  get serviceValue(): string {
    return this._serviceValue;
  }
  set serviceValue(value: string) {
    this._serviceValue = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    BusinessExternalReferences.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): BusinessExternalReferences.AsObject {
    return {
      serviceName: this.serviceName,
      serviceValue: this.serviceValue
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): BusinessExternalReferences.AsProtobufJSON {
    return {
      serviceName: this.serviceName,
      serviceValue: this.serviceValue
    };
  }
}
export module BusinessExternalReferences {
  /**
   * Standard JavaScript object representation for BusinessExternalReferences
   */
  export interface AsObject {
    serviceName: string;
    serviceValue: string;
  }

  /**
   * Protobuf JSON representation for BusinessExternalReferences
   */
  export interface AsProtobufJSON {
    serviceName: string;
    serviceValue: string;
  }
}

/**
 * Message implementation for epicore.admin.LogRequest
 */
export class LogRequest implements GrpcMessage {
  static id = 'epicore.admin.LogRequest';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new LogRequest();
    LogRequest.deserializeBinaryFromReader(instance, new BinaryReader(bytes));
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: LogRequest) {
    _instance.filter = _instance.filter || '';
    _instance.startTime = _instance.startTime || undefined;
    _instance.endTime = _instance.endTime || undefined;
    _instance.sourceContext = _instance.sourceContext || '';
    _instance.method = _instance.method || '';
    _instance.severity = _instance.severity || 0;
    _instance.id = _instance.id || 0;
    _instance.pageNumber = _instance.pageNumber || 0;
    _instance.pageSize = _instance.pageSize || 0;
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: LogRequest,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.filter = _reader.readString();
          break;
        case 2:
          _instance.startTime = new googleProtobuf001.Timestamp();
          _reader.readMessage(
            _instance.startTime,
            googleProtobuf001.Timestamp.deserializeBinaryFromReader
          );
          break;
        case 3:
          _instance.endTime = new googleProtobuf001.Timestamp();
          _reader.readMessage(
            _instance.endTime,
            googleProtobuf001.Timestamp.deserializeBinaryFromReader
          );
          break;
        case 4:
          _instance.sourceContext = _reader.readString();
          break;
        case 5:
          _instance.method = _reader.readString();
          break;
        case 6:
          _instance.severity = _reader.readEnum();
          break;
        case 7:
          _instance.id = _reader.readInt32();
          break;
        case 8:
          _instance.pageNumber = _reader.readInt32();
          break;
        case 9:
          _instance.pageSize = _reader.readInt32();
          break;
        default:
          _reader.skipField();
      }
    }

    LogRequest.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(_instance: LogRequest, _writer: BinaryWriter) {
    if (_instance.filter) {
      _writer.writeString(1, _instance.filter);
    }
    if (_instance.startTime) {
      _writer.writeMessage(
        2,
        _instance.startTime as any,
        googleProtobuf001.Timestamp.serializeBinaryToWriter
      );
    }
    if (_instance.endTime) {
      _writer.writeMessage(
        3,
        _instance.endTime as any,
        googleProtobuf001.Timestamp.serializeBinaryToWriter
      );
    }
    if (_instance.sourceContext) {
      _writer.writeString(4, _instance.sourceContext);
    }
    if (_instance.method) {
      _writer.writeString(5, _instance.method);
    }
    if (_instance.severity) {
      _writer.writeEnum(6, _instance.severity);
    }
    if (_instance.id) {
      _writer.writeInt32(7, _instance.id);
    }
    if (_instance.pageNumber) {
      _writer.writeInt32(8, _instance.pageNumber);
    }
    if (_instance.pageSize) {
      _writer.writeInt32(9, _instance.pageSize);
    }
  }

  private _filter: string;
  private _startTime?: googleProtobuf001.Timestamp;
  private _endTime?: googleProtobuf001.Timestamp;
  private _sourceContext: string;
  private _method: string;
  private _severity: GRPC_Severity;
  private _id: number;
  private _pageNumber: number;
  private _pageSize: number;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of LogRequest to deeply clone from
   */
  constructor(_value?: RecursivePartial<LogRequest.AsObject>) {
    _value = _value || {};
    this.filter = _value.filter;
    this.startTime = _value.startTime
      ? new googleProtobuf001.Timestamp(_value.startTime)
      : undefined;
    this.endTime = _value.endTime
      ? new googleProtobuf001.Timestamp(_value.endTime)
      : undefined;
    this.sourceContext = _value.sourceContext;
    this.method = _value.method;
    this.severity = _value.severity;
    this.id = _value.id;
    this.pageNumber = _value.pageNumber;
    this.pageSize = _value.pageSize;
    LogRequest.refineValues(this);
  }
  get filter(): string {
    return this._filter;
  }
  set filter(value: string) {
    this._filter = value;
  }
  get startTime(): googleProtobuf001.Timestamp | undefined {
    return this._startTime;
  }
  set startTime(value: googleProtobuf001.Timestamp | undefined) {
    this._startTime = value;
  }
  get endTime(): googleProtobuf001.Timestamp | undefined {
    return this._endTime;
  }
  set endTime(value: googleProtobuf001.Timestamp | undefined) {
    this._endTime = value;
  }
  get sourceContext(): string {
    return this._sourceContext;
  }
  set sourceContext(value: string) {
    this._sourceContext = value;
  }
  get method(): string {
    return this._method;
  }
  set method(value: string) {
    this._method = value;
  }
  get severity(): GRPC_Severity {
    return this._severity;
  }
  set severity(value: GRPC_Severity) {
    this._severity = value;
  }
  get id(): number {
    return this._id;
  }
  set id(value: number) {
    this._id = value;
  }
  get pageNumber(): number {
    return this._pageNumber;
  }
  set pageNumber(value: number) {
    this._pageNumber = value;
  }
  get pageSize(): number {
    return this._pageSize;
  }
  set pageSize(value: number) {
    this._pageSize = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    LogRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): LogRequest.AsObject {
    return {
      filter: this.filter,
      startTime: this.startTime ? this.startTime.toObject() : undefined,
      endTime: this.endTime ? this.endTime.toObject() : undefined,
      sourceContext: this.sourceContext,
      method: this.method,
      severity: this.severity,
      id: this.id,
      pageNumber: this.pageNumber,
      pageSize: this.pageSize
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): LogRequest.AsProtobufJSON {
    return {
      filter: this.filter,
      startTime: this.startTime ? this.startTime.toProtobufJSON(options) : null,
      endTime: this.endTime ? this.endTime.toProtobufJSON(options) : null,
      sourceContext: this.sourceContext,
      method: this.method,
      severity:
        GRPC_Severity[
          this.severity === null || this.severity === undefined
            ? 0
            : this.severity
        ],
      id: this.id,
      pageNumber: this.pageNumber,
      pageSize: this.pageSize
    };
  }
}
export module LogRequest {
  /**
   * Standard JavaScript object representation for LogRequest
   */
  export interface AsObject {
    filter: string;
    startTime?: googleProtobuf001.Timestamp.AsObject;
    endTime?: googleProtobuf001.Timestamp.AsObject;
    sourceContext: string;
    method: string;
    severity: GRPC_Severity;
    id: number;
    pageNumber: number;
    pageSize: number;
  }

  /**
   * Protobuf JSON representation for LogRequest
   */
  export interface AsProtobufJSON {
    filter: string;
    startTime: googleProtobuf001.Timestamp.AsProtobufJSON | null;
    endTime: googleProtobuf001.Timestamp.AsProtobufJSON | null;
    sourceContext: string;
    method: string;
    severity: string;
    id: number;
    pageNumber: number;
    pageSize: number;
  }
}

/**
 * Message implementation for epicore.admin.LogResponseList
 */
export class LogResponseList implements GrpcMessage {
  static id = 'epicore.admin.LogResponseList';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new LogResponseList();
    LogResponseList.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: LogResponseList) {
    _instance.logs = _instance.logs || [];
    _instance.numberOfRecords = _instance.numberOfRecords || 0;
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: LogResponseList,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          const messageInitializer1 = new LogResponse();
          _reader.readMessage(
            messageInitializer1,
            LogResponse.deserializeBinaryFromReader
          );
          (_instance.logs = _instance.logs || []).push(messageInitializer1);
          break;
        case 2:
          _instance.numberOfRecords = _reader.readInt32();
          break;
        default:
          _reader.skipField();
      }
    }

    LogResponseList.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: LogResponseList,
    _writer: BinaryWriter
  ) {
    if (_instance.logs && _instance.logs.length) {
      _writer.writeRepeatedMessage(
        1,
        _instance.logs as any,
        LogResponse.serializeBinaryToWriter
      );
    }
    if (_instance.numberOfRecords) {
      _writer.writeInt32(2, _instance.numberOfRecords);
    }
  }

  private _logs?: LogResponse[];
  private _numberOfRecords: number;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of LogResponseList to deeply clone from
   */
  constructor(_value?: RecursivePartial<LogResponseList.AsObject>) {
    _value = _value || {};
    this.logs = (_value.logs || []).map(m => new LogResponse(m));
    this.numberOfRecords = _value.numberOfRecords;
    LogResponseList.refineValues(this);
  }
  get logs(): LogResponse[] | undefined {
    return this._logs;
  }
  set logs(value: LogResponse[] | undefined) {
    this._logs = value;
  }
  get numberOfRecords(): number {
    return this._numberOfRecords;
  }
  set numberOfRecords(value: number) {
    this._numberOfRecords = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    LogResponseList.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): LogResponseList.AsObject {
    return {
      logs: (this.logs || []).map(m => m.toObject()),
      numberOfRecords: this.numberOfRecords
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): LogResponseList.AsProtobufJSON {
    return {
      logs: (this.logs || []).map(m => m.toProtobufJSON(options)),
      numberOfRecords: this.numberOfRecords
    };
  }
}
export module LogResponseList {
  /**
   * Standard JavaScript object representation for LogResponseList
   */
  export interface AsObject {
    logs?: LogResponse.AsObject[];
    numberOfRecords: number;
  }

  /**
   * Protobuf JSON representation for LogResponseList
   */
  export interface AsProtobufJSON {
    logs: LogResponse.AsProtobufJSON[] | null;
    numberOfRecords: number;
  }
}

/**
 * Message implementation for epicore.admin.LogResponse
 */
export class LogResponse implements GrpcMessage {
  static id = 'epicore.admin.LogResponse';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new LogResponse();
    LogResponse.deserializeBinaryFromReader(instance, new BinaryReader(bytes));
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: LogResponse) {
    _instance.id = _instance.id || 0;
    _instance.msg = _instance.msg || '';
    _instance.severity = _instance.severity || 0;
    _instance.timestamp = _instance.timestamp || undefined;
    _instance.timestampStr = _instance.timestampStr || '';
    _instance.ex = _instance.ex || '';
    _instance.logEvent = _instance.logEvent || '';
    _instance.traceId = _instance.traceId || '';
    _instance.spandId = _instance.spandId || '';
    _instance.sourceContext = _instance.sourceContext || '';
    _instance.requestPath = _instance.requestPath || '';
    _instance.lineNumber = _instance.lineNumber || 0;
    _instance.columnNumber = _instance.columnNumber || 0;
    _instance.method = _instance.method || '';
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: LogResponse,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.id = _reader.readInt32();
          break;
        case 2:
          _instance.msg = _reader.readString();
          break;
        case 3:
          _instance.severity = _reader.readEnum();
          break;
        case 4:
          _instance.timestamp = new googleProtobuf001.Timestamp();
          _reader.readMessage(
            _instance.timestamp,
            googleProtobuf001.Timestamp.deserializeBinaryFromReader
          );
          break;
        case 5:
          _instance.timestampStr = _reader.readString();
          break;
        case 6:
          _instance.ex = _reader.readString();
          break;
        case 7:
          _instance.logEvent = _reader.readString();
          break;
        case 8:
          _instance.traceId = _reader.readString();
          break;
        case 9:
          _instance.spandId = _reader.readString();
          break;
        case 10:
          _instance.sourceContext = _reader.readString();
          break;
        case 11:
          _instance.requestPath = _reader.readString();
          break;
        case 12:
          _instance.lineNumber = _reader.readInt32();
          break;
        case 13:
          _instance.columnNumber = _reader.readInt32();
          break;
        case 14:
          _instance.method = _reader.readString();
          break;
        default:
          _reader.skipField();
      }
    }

    LogResponse.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: LogResponse,
    _writer: BinaryWriter
  ) {
    if (_instance.id) {
      _writer.writeInt32(1, _instance.id);
    }
    if (_instance.msg) {
      _writer.writeString(2, _instance.msg);
    }
    if (_instance.severity) {
      _writer.writeEnum(3, _instance.severity);
    }
    if (_instance.timestamp) {
      _writer.writeMessage(
        4,
        _instance.timestamp as any,
        googleProtobuf001.Timestamp.serializeBinaryToWriter
      );
    }
    if (_instance.timestampStr) {
      _writer.writeString(5, _instance.timestampStr);
    }
    if (_instance.ex) {
      _writer.writeString(6, _instance.ex);
    }
    if (_instance.logEvent) {
      _writer.writeString(7, _instance.logEvent);
    }
    if (_instance.traceId) {
      _writer.writeString(8, _instance.traceId);
    }
    if (_instance.spandId) {
      _writer.writeString(9, _instance.spandId);
    }
    if (_instance.sourceContext) {
      _writer.writeString(10, _instance.sourceContext);
    }
    if (_instance.requestPath) {
      _writer.writeString(11, _instance.requestPath);
    }
    if (_instance.lineNumber) {
      _writer.writeInt32(12, _instance.lineNumber);
    }
    if (_instance.columnNumber) {
      _writer.writeInt32(13, _instance.columnNumber);
    }
    if (_instance.method) {
      _writer.writeString(14, _instance.method);
    }
  }

  private _id: number;
  private _msg: string;
  private _severity: GRPC_Severity;
  private _timestamp?: googleProtobuf001.Timestamp;
  private _timestampStr: string;
  private _ex: string;
  private _logEvent: string;
  private _traceId: string;
  private _spandId: string;
  private _sourceContext: string;
  private _requestPath: string;
  private _lineNumber: number;
  private _columnNumber: number;
  private _method: string;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of LogResponse to deeply clone from
   */
  constructor(_value?: RecursivePartial<LogResponse.AsObject>) {
    _value = _value || {};
    this.id = _value.id;
    this.msg = _value.msg;
    this.severity = _value.severity;
    this.timestamp = _value.timestamp
      ? new googleProtobuf001.Timestamp(_value.timestamp)
      : undefined;
    this.timestampStr = _value.timestampStr;
    this.ex = _value.ex;
    this.logEvent = _value.logEvent;
    this.traceId = _value.traceId;
    this.spandId = _value.spandId;
    this.sourceContext = _value.sourceContext;
    this.requestPath = _value.requestPath;
    this.lineNumber = _value.lineNumber;
    this.columnNumber = _value.columnNumber;
    this.method = _value.method;
    LogResponse.refineValues(this);
  }
  get id(): number {
    return this._id;
  }
  set id(value: number) {
    this._id = value;
  }
  get msg(): string {
    return this._msg;
  }
  set msg(value: string) {
    this._msg = value;
  }
  get severity(): GRPC_Severity {
    return this._severity;
  }
  set severity(value: GRPC_Severity) {
    this._severity = value;
  }
  get timestamp(): googleProtobuf001.Timestamp | undefined {
    return this._timestamp;
  }
  set timestamp(value: googleProtobuf001.Timestamp | undefined) {
    this._timestamp = value;
  }
  get timestampStr(): string {
    return this._timestampStr;
  }
  set timestampStr(value: string) {
    this._timestampStr = value;
  }
  get ex(): string {
    return this._ex;
  }
  set ex(value: string) {
    this._ex = value;
  }
  get logEvent(): string {
    return this._logEvent;
  }
  set logEvent(value: string) {
    this._logEvent = value;
  }
  get traceId(): string {
    return this._traceId;
  }
  set traceId(value: string) {
    this._traceId = value;
  }
  get spandId(): string {
    return this._spandId;
  }
  set spandId(value: string) {
    this._spandId = value;
  }
  get sourceContext(): string {
    return this._sourceContext;
  }
  set sourceContext(value: string) {
    this._sourceContext = value;
  }
  get requestPath(): string {
    return this._requestPath;
  }
  set requestPath(value: string) {
    this._requestPath = value;
  }
  get lineNumber(): number {
    return this._lineNumber;
  }
  set lineNumber(value: number) {
    this._lineNumber = value;
  }
  get columnNumber(): number {
    return this._columnNumber;
  }
  set columnNumber(value: number) {
    this._columnNumber = value;
  }
  get method(): string {
    return this._method;
  }
  set method(value: string) {
    this._method = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    LogResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): LogResponse.AsObject {
    return {
      id: this.id,
      msg: this.msg,
      severity: this.severity,
      timestamp: this.timestamp ? this.timestamp.toObject() : undefined,
      timestampStr: this.timestampStr,
      ex: this.ex,
      logEvent: this.logEvent,
      traceId: this.traceId,
      spandId: this.spandId,
      sourceContext: this.sourceContext,
      requestPath: this.requestPath,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      method: this.method
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): LogResponse.AsProtobufJSON {
    return {
      id: this.id,
      msg: this.msg,
      severity:
        GRPC_Severity[
          this.severity === null || this.severity === undefined
            ? 0
            : this.severity
        ],
      timestamp: this.timestamp ? this.timestamp.toProtobufJSON(options) : null,
      timestampStr: this.timestampStr,
      ex: this.ex,
      logEvent: this.logEvent,
      traceId: this.traceId,
      spandId: this.spandId,
      sourceContext: this.sourceContext,
      requestPath: this.requestPath,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      method: this.method
    };
  }
}
export module LogResponse {
  /**
   * Standard JavaScript object representation for LogResponse
   */
  export interface AsObject {
    id: number;
    msg: string;
    severity: GRPC_Severity;
    timestamp?: googleProtobuf001.Timestamp.AsObject;
    timestampStr: string;
    ex: string;
    logEvent: string;
    traceId: string;
    spandId: string;
    sourceContext: string;
    requestPath: string;
    lineNumber: number;
    columnNumber: number;
    method: string;
  }

  /**
   * Protobuf JSON representation for LogResponse
   */
  export interface AsProtobufJSON {
    id: number;
    msg: string;
    severity: string;
    timestamp: googleProtobuf001.Timestamp.AsProtobufJSON | null;
    timestampStr: string;
    ex: string;
    logEvent: string;
    traceId: string;
    spandId: string;
    sourceContext: string;
    requestPath: string;
    lineNumber: number;
    columnNumber: number;
    method: string;
  }
}

/**
 * Message implementation for epicore.admin.DeleteLogsResponse
 */
export class DeleteLogsResponse implements GrpcMessage {
  static id = 'epicore.admin.DeleteLogsResponse';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new DeleteLogsResponse();
    DeleteLogsResponse.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: DeleteLogsResponse) {
    _instance.result = _instance.result || '';
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: DeleteLogsResponse,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.result = _reader.readString();
          break;
        default:
          _reader.skipField();
      }
    }

    DeleteLogsResponse.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: DeleteLogsResponse,
    _writer: BinaryWriter
  ) {
    if (_instance.result) {
      _writer.writeString(1, _instance.result);
    }
  }

  private _result: string;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of DeleteLogsResponse to deeply clone from
   */
  constructor(_value?: RecursivePartial<DeleteLogsResponse.AsObject>) {
    _value = _value || {};
    this.result = _value.result;
    DeleteLogsResponse.refineValues(this);
  }
  get result(): string {
    return this._result;
  }
  set result(value: string) {
    this._result = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    DeleteLogsResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): DeleteLogsResponse.AsObject {
    return {
      result: this.result
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): DeleteLogsResponse.AsProtobufJSON {
    return {
      result: this.result
    };
  }
}
export module DeleteLogsResponse {
  /**
   * Standard JavaScript object representation for DeleteLogsResponse
   */
  export interface AsObject {
    result: string;
  }

  /**
   * Protobuf JSON representation for DeleteLogsResponse
   */
  export interface AsProtobufJSON {
    result: string;
  }
}

/**
 * Message implementation for epicore.admin.AddOrderRequest
 */
export class AddOrderRequest implements GrpcMessage {
  static id = 'epicore.admin.AddOrderRequest';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new AddOrderRequest();
    AddOrderRequest.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: AddOrderRequest) {
    _instance.userId = _instance.userId || 0;
    _instance.plantId = _instance.plantId || 0;
    _instance.subscriptionId = _instance.subscriptionId || 0;
    _instance.startDate = _instance.startDate || undefined;
    _instance.expireDate = _instance.expireDate || undefined;
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: AddOrderRequest,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.userId = _reader.readInt32();
          break;
        case 2:
          _instance.plantId = _reader.readInt32();
          break;
        case 3:
          _instance.subscriptionId = _reader.readInt32();
          break;
        case 4:
          _instance.startDate = new googleProtobuf001.Timestamp();
          _reader.readMessage(
            _instance.startDate,
            googleProtobuf001.Timestamp.deserializeBinaryFromReader
          );
          break;
        case 5:
          _instance.expireDate = new googleProtobuf001.Timestamp();
          _reader.readMessage(
            _instance.expireDate,
            googleProtobuf001.Timestamp.deserializeBinaryFromReader
          );
          break;
        default:
          _reader.skipField();
      }
    }

    AddOrderRequest.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: AddOrderRequest,
    _writer: BinaryWriter
  ) {
    if (_instance.userId) {
      _writer.writeInt32(1, _instance.userId);
    }
    if (_instance.plantId) {
      _writer.writeInt32(2, _instance.plantId);
    }
    if (_instance.subscriptionId) {
      _writer.writeInt32(3, _instance.subscriptionId);
    }
    if (_instance.startDate) {
      _writer.writeMessage(
        4,
        _instance.startDate as any,
        googleProtobuf001.Timestamp.serializeBinaryToWriter
      );
    }
    if (_instance.expireDate) {
      _writer.writeMessage(
        5,
        _instance.expireDate as any,
        googleProtobuf001.Timestamp.serializeBinaryToWriter
      );
    }
  }

  private _userId: number;
  private _plantId: number;
  private _subscriptionId: number;
  private _startDate?: googleProtobuf001.Timestamp;
  private _expireDate?: googleProtobuf001.Timestamp;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of AddOrderRequest to deeply clone from
   */
  constructor(_value?: RecursivePartial<AddOrderRequest.AsObject>) {
    _value = _value || {};
    this.userId = _value.userId;
    this.plantId = _value.plantId;
    this.subscriptionId = _value.subscriptionId;
    this.startDate = _value.startDate
      ? new googleProtobuf001.Timestamp(_value.startDate)
      : undefined;
    this.expireDate = _value.expireDate
      ? new googleProtobuf001.Timestamp(_value.expireDate)
      : undefined;
    AddOrderRequest.refineValues(this);
  }
  get userId(): number {
    return this._userId;
  }
  set userId(value: number) {
    this._userId = value;
  }
  get plantId(): number {
    return this._plantId;
  }
  set plantId(value: number) {
    this._plantId = value;
  }
  get subscriptionId(): number {
    return this._subscriptionId;
  }
  set subscriptionId(value: number) {
    this._subscriptionId = value;
  }
  get startDate(): googleProtobuf001.Timestamp | undefined {
    return this._startDate;
  }
  set startDate(value: googleProtobuf001.Timestamp | undefined) {
    this._startDate = value;
  }
  get expireDate(): googleProtobuf001.Timestamp | undefined {
    return this._expireDate;
  }
  set expireDate(value: googleProtobuf001.Timestamp | undefined) {
    this._expireDate = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    AddOrderRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): AddOrderRequest.AsObject {
    return {
      userId: this.userId,
      plantId: this.plantId,
      subscriptionId: this.subscriptionId,
      startDate: this.startDate ? this.startDate.toObject() : undefined,
      expireDate: this.expireDate ? this.expireDate.toObject() : undefined
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): AddOrderRequest.AsProtobufJSON {
    return {
      userId: this.userId,
      plantId: this.plantId,
      subscriptionId: this.subscriptionId,
      startDate: this.startDate ? this.startDate.toProtobufJSON(options) : null,
      expireDate: this.expireDate
        ? this.expireDate.toProtobufJSON(options)
        : null
    };
  }
}
export module AddOrderRequest {
  /**
   * Standard JavaScript object representation for AddOrderRequest
   */
  export interface AsObject {
    userId: number;
    plantId: number;
    subscriptionId: number;
    startDate?: googleProtobuf001.Timestamp.AsObject;
    expireDate?: googleProtobuf001.Timestamp.AsObject;
  }

  /**
   * Protobuf JSON representation for AddOrderRequest
   */
  export interface AsProtobufJSON {
    userId: number;
    plantId: number;
    subscriptionId: number;
    startDate: googleProtobuf001.Timestamp.AsProtobufJSON | null;
    expireDate: googleProtobuf001.Timestamp.AsProtobufJSON | null;
  }
}

/**
 * Message implementation for epicore.admin.ToggleDisableOrderRequest
 */
export class ToggleDisableOrderRequest implements GrpcMessage {
  static id = 'epicore.admin.ToggleDisableOrderRequest';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new ToggleDisableOrderRequest();
    ToggleDisableOrderRequest.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: ToggleDisableOrderRequest) {
    _instance.userId = _instance.userId || 0;
    _instance.plantId = _instance.plantId || 0;
    _instance.orderId = _instance.orderId || 0;
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: ToggleDisableOrderRequest,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.userId = _reader.readInt32();
          break;
        case 2:
          _instance.plantId = _reader.readInt32();
          break;
        case 3:
          _instance.orderId = _reader.readInt32();
          break;
        default:
          _reader.skipField();
      }
    }

    ToggleDisableOrderRequest.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: ToggleDisableOrderRequest,
    _writer: BinaryWriter
  ) {
    if (_instance.userId) {
      _writer.writeInt32(1, _instance.userId);
    }
    if (_instance.plantId) {
      _writer.writeInt32(2, _instance.plantId);
    }
    if (_instance.orderId) {
      _writer.writeInt32(3, _instance.orderId);
    }
  }

  private _userId: number;
  private _plantId: number;
  private _orderId: number;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of ToggleDisableOrderRequest to deeply clone from
   */
  constructor(_value?: RecursivePartial<ToggleDisableOrderRequest.AsObject>) {
    _value = _value || {};
    this.userId = _value.userId;
    this.plantId = _value.plantId;
    this.orderId = _value.orderId;
    ToggleDisableOrderRequest.refineValues(this);
  }
  get userId(): number {
    return this._userId;
  }
  set userId(value: number) {
    this._userId = value;
  }
  get plantId(): number {
    return this._plantId;
  }
  set plantId(value: number) {
    this._plantId = value;
  }
  get orderId(): number {
    return this._orderId;
  }
  set orderId(value: number) {
    this._orderId = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    ToggleDisableOrderRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): ToggleDisableOrderRequest.AsObject {
    return {
      userId: this.userId,
      plantId: this.plantId,
      orderId: this.orderId
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): ToggleDisableOrderRequest.AsProtobufJSON {
    return {
      userId: this.userId,
      plantId: this.plantId,
      orderId: this.orderId
    };
  }
}
export module ToggleDisableOrderRequest {
  /**
   * Standard JavaScript object representation for ToggleDisableOrderRequest
   */
  export interface AsObject {
    userId: number;
    plantId: number;
    orderId: number;
  }

  /**
   * Protobuf JSON representation for ToggleDisableOrderRequest
   */
  export interface AsProtobufJSON {
    userId: number;
    plantId: number;
    orderId: number;
  }
}

/**
 * Message implementation for epicore.admin.UpdateOrderRequest
 */
export class UpdateOrderRequest implements GrpcMessage {
  static id = 'epicore.admin.UpdateOrderRequest';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new UpdateOrderRequest();
    UpdateOrderRequest.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: UpdateOrderRequest) {
    _instance.userId = _instance.userId || 0;
    _instance.plantId = _instance.plantId || 0;
    _instance.orderId = _instance.orderId || 0;
    _instance.startDate = _instance.startDate || undefined;
    _instance.expireDate = _instance.expireDate || undefined;
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: UpdateOrderRequest,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.userId = _reader.readInt32();
          break;
        case 2:
          _instance.plantId = _reader.readInt32();
          break;
        case 3:
          _instance.orderId = _reader.readInt32();
          break;
        case 4:
          _instance.startDate = new googleProtobuf001.Timestamp();
          _reader.readMessage(
            _instance.startDate,
            googleProtobuf001.Timestamp.deserializeBinaryFromReader
          );
          break;
        case 5:
          _instance.expireDate = new googleProtobuf001.Timestamp();
          _reader.readMessage(
            _instance.expireDate,
            googleProtobuf001.Timestamp.deserializeBinaryFromReader
          );
          break;
        default:
          _reader.skipField();
      }
    }

    UpdateOrderRequest.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: UpdateOrderRequest,
    _writer: BinaryWriter
  ) {
    if (_instance.userId) {
      _writer.writeInt32(1, _instance.userId);
    }
    if (_instance.plantId) {
      _writer.writeInt32(2, _instance.plantId);
    }
    if (_instance.orderId) {
      _writer.writeInt32(3, _instance.orderId);
    }
    if (_instance.startDate) {
      _writer.writeMessage(
        4,
        _instance.startDate as any,
        googleProtobuf001.Timestamp.serializeBinaryToWriter
      );
    }
    if (_instance.expireDate) {
      _writer.writeMessage(
        5,
        _instance.expireDate as any,
        googleProtobuf001.Timestamp.serializeBinaryToWriter
      );
    }
  }

  private _userId: number;
  private _plantId: number;
  private _orderId: number;
  private _startDate?: googleProtobuf001.Timestamp;
  private _expireDate?: googleProtobuf001.Timestamp;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of UpdateOrderRequest to deeply clone from
   */
  constructor(_value?: RecursivePartial<UpdateOrderRequest.AsObject>) {
    _value = _value || {};
    this.userId = _value.userId;
    this.plantId = _value.plantId;
    this.orderId = _value.orderId;
    this.startDate = _value.startDate
      ? new googleProtobuf001.Timestamp(_value.startDate)
      : undefined;
    this.expireDate = _value.expireDate
      ? new googleProtobuf001.Timestamp(_value.expireDate)
      : undefined;
    UpdateOrderRequest.refineValues(this);
  }
  get userId(): number {
    return this._userId;
  }
  set userId(value: number) {
    this._userId = value;
  }
  get plantId(): number {
    return this._plantId;
  }
  set plantId(value: number) {
    this._plantId = value;
  }
  get orderId(): number {
    return this._orderId;
  }
  set orderId(value: number) {
    this._orderId = value;
  }
  get startDate(): googleProtobuf001.Timestamp | undefined {
    return this._startDate;
  }
  set startDate(value: googleProtobuf001.Timestamp | undefined) {
    this._startDate = value;
  }
  get expireDate(): googleProtobuf001.Timestamp | undefined {
    return this._expireDate;
  }
  set expireDate(value: googleProtobuf001.Timestamp | undefined) {
    this._expireDate = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    UpdateOrderRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): UpdateOrderRequest.AsObject {
    return {
      userId: this.userId,
      plantId: this.plantId,
      orderId: this.orderId,
      startDate: this.startDate ? this.startDate.toObject() : undefined,
      expireDate: this.expireDate ? this.expireDate.toObject() : undefined
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): UpdateOrderRequest.AsProtobufJSON {
    return {
      userId: this.userId,
      plantId: this.plantId,
      orderId: this.orderId,
      startDate: this.startDate ? this.startDate.toProtobufJSON(options) : null,
      expireDate: this.expireDate
        ? this.expireDate.toProtobufJSON(options)
        : null
    };
  }
}
export module UpdateOrderRequest {
  /**
   * Standard JavaScript object representation for UpdateOrderRequest
   */
  export interface AsObject {
    userId: number;
    plantId: number;
    orderId: number;
    startDate?: googleProtobuf001.Timestamp.AsObject;
    expireDate?: googleProtobuf001.Timestamp.AsObject;
  }

  /**
   * Protobuf JSON representation for UpdateOrderRequest
   */
  export interface AsProtobufJSON {
    userId: number;
    plantId: number;
    orderId: number;
    startDate: googleProtobuf001.Timestamp.AsProtobufJSON | null;
    expireDate: googleProtobuf001.Timestamp.AsProtobufJSON | null;
  }
}

/**
 * Message implementation for epicore.admin.GetUserOrdersRequest
 */
export class GetUserOrdersRequest implements GrpcMessage {
  static id = 'epicore.admin.GetUserOrdersRequest';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new GetUserOrdersRequest();
    GetUserOrdersRequest.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: GetUserOrdersRequest) {
    _instance.plantId = _instance.plantId || 0;
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: GetUserOrdersRequest,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.plantId = _reader.readInt32();
          break;
        default:
          _reader.skipField();
      }
    }

    GetUserOrdersRequest.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: GetUserOrdersRequest,
    _writer: BinaryWriter
  ) {
    if (_instance.plantId) {
      _writer.writeInt32(1, _instance.plantId);
    }
  }

  private _plantId: number;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of GetUserOrdersRequest to deeply clone from
   */
  constructor(_value?: RecursivePartial<GetUserOrdersRequest.AsObject>) {
    _value = _value || {};
    this.plantId = _value.plantId;
    GetUserOrdersRequest.refineValues(this);
  }
  get plantId(): number {
    return this._plantId;
  }
  set plantId(value: number) {
    this._plantId = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    GetUserOrdersRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): GetUserOrdersRequest.AsObject {
    return {
      plantId: this.plantId
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): GetUserOrdersRequest.AsProtobufJSON {
    return {
      plantId: this.plantId
    };
  }
}
export module GetUserOrdersRequest {
  /**
   * Standard JavaScript object representation for GetUserOrdersRequest
   */
  export interface AsObject {
    plantId: number;
  }

  /**
   * Protobuf JSON representation for GetUserOrdersRequest
   */
  export interface AsProtobufJSON {
    plantId: number;
  }
}

/**
 * Message implementation for epicore.admin.GetUserOrdersResponse
 */
export class GetUserOrdersResponse implements GrpcMessage {
  static id = 'epicore.admin.GetUserOrdersResponse';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new GetUserOrdersResponse();
    GetUserOrdersResponse.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: GetUserOrdersResponse) {
    _instance.orders = _instance.orders || [];
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: GetUserOrdersResponse,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          const messageInitializer1 = new OrderDto();
          _reader.readMessage(
            messageInitializer1,
            OrderDto.deserializeBinaryFromReader
          );
          (_instance.orders = _instance.orders || []).push(messageInitializer1);
          break;
        default:
          _reader.skipField();
      }
    }

    GetUserOrdersResponse.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: GetUserOrdersResponse,
    _writer: BinaryWriter
  ) {
    if (_instance.orders && _instance.orders.length) {
      _writer.writeRepeatedMessage(
        1,
        _instance.orders as any,
        OrderDto.serializeBinaryToWriter
      );
    }
  }

  private _orders?: OrderDto[];

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of GetUserOrdersResponse to deeply clone from
   */
  constructor(_value?: RecursivePartial<GetUserOrdersResponse.AsObject>) {
    _value = _value || {};
    this.orders = (_value.orders || []).map(m => new OrderDto(m));
    GetUserOrdersResponse.refineValues(this);
  }
  get orders(): OrderDto[] | undefined {
    return this._orders;
  }
  set orders(value: OrderDto[] | undefined) {
    this._orders = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    GetUserOrdersResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): GetUserOrdersResponse.AsObject {
    return {
      orders: (this.orders || []).map(m => m.toObject())
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): GetUserOrdersResponse.AsProtobufJSON {
    return {
      orders: (this.orders || []).map(m => m.toProtobufJSON(options))
    };
  }
}
export module GetUserOrdersResponse {
  /**
   * Standard JavaScript object representation for GetUserOrdersResponse
   */
  export interface AsObject {
    orders?: OrderDto.AsObject[];
  }

  /**
   * Protobuf JSON representation for GetUserOrdersResponse
   */
  export interface AsProtobufJSON {
    orders: OrderDto.AsProtobufJSON[] | null;
  }
}

/**
 * Message implementation for epicore.admin.OrderDto
 */
export class OrderDto implements GrpcMessage {
  static id = 'epicore.admin.OrderDto';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new OrderDto();
    OrderDto.deserializeBinaryFromReader(instance, new BinaryReader(bytes));
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: OrderDto) {
    _instance.userId = _instance.userId || 0;
    _instance.plantId = _instance.plantId || 0;
    _instance.subscriptionId = _instance.subscriptionId || 0;
    _instance.disabled = _instance.disabled || false;
    _instance.createAt = _instance.createAt || undefined;
    _instance.lastUpdate = _instance.lastUpdate || undefined;
    _instance.startDate = _instance.startDate || undefined;
    _instance.endDate = _instance.endDate || undefined;
    _instance.featureImage = _instance.featureImage || [];
    _instance.orderLogs = _instance.orderLogs || [];
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: OrderDto,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.userId = _reader.readInt32();
          break;
        case 2:
          _instance.plantId = _reader.readInt32();
          break;
        case 3:
          _instance.subscriptionId = _reader.readInt32();
          break;
        case 4:
          _instance.disabled = _reader.readBool();
          break;
        case 5:
          _instance.createAt = new googleProtobuf001.Timestamp();
          _reader.readMessage(
            _instance.createAt,
            googleProtobuf001.Timestamp.deserializeBinaryFromReader
          );
          break;
        case 6:
          _instance.lastUpdate = new googleProtobuf001.Timestamp();
          _reader.readMessage(
            _instance.lastUpdate,
            googleProtobuf001.Timestamp.deserializeBinaryFromReader
          );
          break;
        case 7:
          _instance.startDate = new googleProtobuf001.Timestamp();
          _reader.readMessage(
            _instance.startDate,
            googleProtobuf001.Timestamp.deserializeBinaryFromReader
          );
          break;
        case 8:
          _instance.endDate = new googleProtobuf001.Timestamp();
          _reader.readMessage(
            _instance.endDate,
            googleProtobuf001.Timestamp.deserializeBinaryFromReader
          );
          break;
        case 9:
          const messageInitializer9 = new FeatureImageDto();
          _reader.readMessage(
            messageInitializer9,
            FeatureImageDto.deserializeBinaryFromReader
          );
          (_instance.featureImage = _instance.featureImage || []).push(
            messageInitializer9
          );
          break;
        case 10:
          const messageInitializer10 = new OrderLogsDto();
          _reader.readMessage(
            messageInitializer10,
            OrderLogsDto.deserializeBinaryFromReader
          );
          (_instance.orderLogs = _instance.orderLogs || []).push(
            messageInitializer10
          );
          break;
        default:
          _reader.skipField();
      }
    }

    OrderDto.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(_instance: OrderDto, _writer: BinaryWriter) {
    if (_instance.userId) {
      _writer.writeInt32(1, _instance.userId);
    }
    if (_instance.plantId) {
      _writer.writeInt32(2, _instance.plantId);
    }
    if (_instance.subscriptionId) {
      _writer.writeInt32(3, _instance.subscriptionId);
    }
    if (_instance.disabled) {
      _writer.writeBool(4, _instance.disabled);
    }
    if (_instance.createAt) {
      _writer.writeMessage(
        5,
        _instance.createAt as any,
        googleProtobuf001.Timestamp.serializeBinaryToWriter
      );
    }
    if (_instance.lastUpdate) {
      _writer.writeMessage(
        6,
        _instance.lastUpdate as any,
        googleProtobuf001.Timestamp.serializeBinaryToWriter
      );
    }
    if (_instance.startDate) {
      _writer.writeMessage(
        7,
        _instance.startDate as any,
        googleProtobuf001.Timestamp.serializeBinaryToWriter
      );
    }
    if (_instance.endDate) {
      _writer.writeMessage(
        8,
        _instance.endDate as any,
        googleProtobuf001.Timestamp.serializeBinaryToWriter
      );
    }
    if (_instance.featureImage && _instance.featureImage.length) {
      _writer.writeRepeatedMessage(
        9,
        _instance.featureImage as any,
        FeatureImageDto.serializeBinaryToWriter
      );
    }
    if (_instance.orderLogs && _instance.orderLogs.length) {
      _writer.writeRepeatedMessage(
        10,
        _instance.orderLogs as any,
        OrderLogsDto.serializeBinaryToWriter
      );
    }
  }

  private _userId: number;
  private _plantId: number;
  private _subscriptionId: number;
  private _disabled: boolean;
  private _createAt?: googleProtobuf001.Timestamp;
  private _lastUpdate?: googleProtobuf001.Timestamp;
  private _startDate?: googleProtobuf001.Timestamp;
  private _endDate?: googleProtobuf001.Timestamp;
  private _featureImage?: FeatureImageDto[];
  private _orderLogs?: OrderLogsDto[];

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of OrderDto to deeply clone from
   */
  constructor(_value?: RecursivePartial<OrderDto.AsObject>) {
    _value = _value || {};
    this.userId = _value.userId;
    this.plantId = _value.plantId;
    this.subscriptionId = _value.subscriptionId;
    this.disabled = _value.disabled;
    this.createAt = _value.createAt
      ? new googleProtobuf001.Timestamp(_value.createAt)
      : undefined;
    this.lastUpdate = _value.lastUpdate
      ? new googleProtobuf001.Timestamp(_value.lastUpdate)
      : undefined;
    this.startDate = _value.startDate
      ? new googleProtobuf001.Timestamp(_value.startDate)
      : undefined;
    this.endDate = _value.endDate
      ? new googleProtobuf001.Timestamp(_value.endDate)
      : undefined;
    this.featureImage = (_value.featureImage || []).map(
      m => new FeatureImageDto(m)
    );
    this.orderLogs = (_value.orderLogs || []).map(m => new OrderLogsDto(m));
    OrderDto.refineValues(this);
  }
  get userId(): number {
    return this._userId;
  }
  set userId(value: number) {
    this._userId = value;
  }
  get plantId(): number {
    return this._plantId;
  }
  set plantId(value: number) {
    this._plantId = value;
  }
  get subscriptionId(): number {
    return this._subscriptionId;
  }
  set subscriptionId(value: number) {
    this._subscriptionId = value;
  }
  get disabled(): boolean {
    return this._disabled;
  }
  set disabled(value: boolean) {
    this._disabled = value;
  }
  get createAt(): googleProtobuf001.Timestamp | undefined {
    return this._createAt;
  }
  set createAt(value: googleProtobuf001.Timestamp | undefined) {
    this._createAt = value;
  }
  get lastUpdate(): googleProtobuf001.Timestamp | undefined {
    return this._lastUpdate;
  }
  set lastUpdate(value: googleProtobuf001.Timestamp | undefined) {
    this._lastUpdate = value;
  }
  get startDate(): googleProtobuf001.Timestamp | undefined {
    return this._startDate;
  }
  set startDate(value: googleProtobuf001.Timestamp | undefined) {
    this._startDate = value;
  }
  get endDate(): googleProtobuf001.Timestamp | undefined {
    return this._endDate;
  }
  set endDate(value: googleProtobuf001.Timestamp | undefined) {
    this._endDate = value;
  }
  get featureImage(): FeatureImageDto[] | undefined {
    return this._featureImage;
  }
  set featureImage(value: FeatureImageDto[] | undefined) {
    this._featureImage = value;
  }
  get orderLogs(): OrderLogsDto[] | undefined {
    return this._orderLogs;
  }
  set orderLogs(value: OrderLogsDto[] | undefined) {
    this._orderLogs = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    OrderDto.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): OrderDto.AsObject {
    return {
      userId: this.userId,
      plantId: this.plantId,
      subscriptionId: this.subscriptionId,
      disabled: this.disabled,
      createAt: this.createAt ? this.createAt.toObject() : undefined,
      lastUpdate: this.lastUpdate ? this.lastUpdate.toObject() : undefined,
      startDate: this.startDate ? this.startDate.toObject() : undefined,
      endDate: this.endDate ? this.endDate.toObject() : undefined,
      featureImage: (this.featureImage || []).map(m => m.toObject()),
      orderLogs: (this.orderLogs || []).map(m => m.toObject())
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): OrderDto.AsProtobufJSON {
    return {
      userId: this.userId,
      plantId: this.plantId,
      subscriptionId: this.subscriptionId,
      disabled: this.disabled,
      createAt: this.createAt ? this.createAt.toProtobufJSON(options) : null,
      lastUpdate: this.lastUpdate
        ? this.lastUpdate.toProtobufJSON(options)
        : null,
      startDate: this.startDate ? this.startDate.toProtobufJSON(options) : null,
      endDate: this.endDate ? this.endDate.toProtobufJSON(options) : null,
      featureImage: (this.featureImage || []).map(m =>
        m.toProtobufJSON(options)
      ),
      orderLogs: (this.orderLogs || []).map(m => m.toProtobufJSON(options))
    };
  }
}
export module OrderDto {
  /**
   * Standard JavaScript object representation for OrderDto
   */
  export interface AsObject {
    userId: number;
    plantId: number;
    subscriptionId: number;
    disabled: boolean;
    createAt?: googleProtobuf001.Timestamp.AsObject;
    lastUpdate?: googleProtobuf001.Timestamp.AsObject;
    startDate?: googleProtobuf001.Timestamp.AsObject;
    endDate?: googleProtobuf001.Timestamp.AsObject;
    featureImage?: FeatureImageDto.AsObject[];
    orderLogs?: OrderLogsDto.AsObject[];
  }

  /**
   * Protobuf JSON representation for OrderDto
   */
  export interface AsProtobufJSON {
    userId: number;
    plantId: number;
    subscriptionId: number;
    disabled: boolean;
    createAt: googleProtobuf001.Timestamp.AsProtobufJSON | null;
    lastUpdate: googleProtobuf001.Timestamp.AsProtobufJSON | null;
    startDate: googleProtobuf001.Timestamp.AsProtobufJSON | null;
    endDate: googleProtobuf001.Timestamp.AsProtobufJSON | null;
    featureImage: FeatureImageDto.AsProtobufJSON[] | null;
    orderLogs: OrderLogsDto.AsProtobufJSON[] | null;
  }
}

/**
 * Message implementation for epicore.admin.OrderLogsDto
 */
export class OrderLogsDto implements GrpcMessage {
  static id = 'epicore.admin.OrderLogsDto';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new OrderLogsDto();
    OrderLogsDto.deserializeBinaryFromReader(instance, new BinaryReader(bytes));
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: OrderLogsDto) {
    _instance.orderId = _instance.orderId || 0;
    _instance.featureType = _instance.featureType || '';
    _instance.usedAt = _instance.usedAt || undefined;
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: OrderLogsDto,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.orderId = _reader.readInt32();
          break;
        case 2:
          _instance.featureType = _reader.readString();
          break;
        case 3:
          _instance.usedAt = new googleProtobuf001.Timestamp();
          _reader.readMessage(
            _instance.usedAt,
            googleProtobuf001.Timestamp.deserializeBinaryFromReader
          );
          break;
        default:
          _reader.skipField();
      }
    }

    OrderLogsDto.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: OrderLogsDto,
    _writer: BinaryWriter
  ) {
    if (_instance.orderId) {
      _writer.writeInt32(1, _instance.orderId);
    }
    if (_instance.featureType) {
      _writer.writeString(2, _instance.featureType);
    }
    if (_instance.usedAt) {
      _writer.writeMessage(
        3,
        _instance.usedAt as any,
        googleProtobuf001.Timestamp.serializeBinaryToWriter
      );
    }
  }

  private _orderId: number;
  private _featureType: string;
  private _usedAt?: googleProtobuf001.Timestamp;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of OrderLogsDto to deeply clone from
   */
  constructor(_value?: RecursivePartial<OrderLogsDto.AsObject>) {
    _value = _value || {};
    this.orderId = _value.orderId;
    this.featureType = _value.featureType;
    this.usedAt = _value.usedAt
      ? new googleProtobuf001.Timestamp(_value.usedAt)
      : undefined;
    OrderLogsDto.refineValues(this);
  }
  get orderId(): number {
    return this._orderId;
  }
  set orderId(value: number) {
    this._orderId = value;
  }
  get featureType(): string {
    return this._featureType;
  }
  set featureType(value: string) {
    this._featureType = value;
  }
  get usedAt(): googleProtobuf001.Timestamp | undefined {
    return this._usedAt;
  }
  set usedAt(value: googleProtobuf001.Timestamp | undefined) {
    this._usedAt = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    OrderLogsDto.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): OrderLogsDto.AsObject {
    return {
      orderId: this.orderId,
      featureType: this.featureType,
      usedAt: this.usedAt ? this.usedAt.toObject() : undefined
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): OrderLogsDto.AsProtobufJSON {
    return {
      orderId: this.orderId,
      featureType: this.featureType,
      usedAt: this.usedAt ? this.usedAt.toProtobufJSON(options) : null
    };
  }
}
export module OrderLogsDto {
  /**
   * Standard JavaScript object representation for OrderLogsDto
   */
  export interface AsObject {
    orderId: number;
    featureType: string;
    usedAt?: googleProtobuf001.Timestamp.AsObject;
  }

  /**
   * Protobuf JSON representation for OrderLogsDto
   */
  export interface AsProtobufJSON {
    orderId: number;
    featureType: string;
    usedAt: googleProtobuf001.Timestamp.AsProtobufJSON | null;
  }
}

/**
 * Message implementation for epicore.admin.FeatureImageDto
 */
export class FeatureImageDto implements GrpcMessage {
  static id = 'epicore.admin.FeatureImageDto';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new FeatureImageDto();
    FeatureImageDto.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: FeatureImageDto) {
    _instance.featureType = _instance.featureType || '';
    _instance.content = _instance.content || '';
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: FeatureImageDto,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.featureType = _reader.readString();
          break;
        case 2:
          _instance.content = _reader.readString();
          break;
        default:
          _reader.skipField();
      }
    }

    FeatureImageDto.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: FeatureImageDto,
    _writer: BinaryWriter
  ) {
    if (_instance.featureType) {
      _writer.writeString(1, _instance.featureType);
    }
    if (_instance.content) {
      _writer.writeString(2, _instance.content);
    }
  }

  private _featureType: string;
  private _content: string;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of FeatureImageDto to deeply clone from
   */
  constructor(_value?: RecursivePartial<FeatureImageDto.AsObject>) {
    _value = _value || {};
    this.featureType = _value.featureType;
    this.content = _value.content;
    FeatureImageDto.refineValues(this);
  }
  get featureType(): string {
    return this._featureType;
  }
  set featureType(value: string) {
    this._featureType = value;
  }
  get content(): string {
    return this._content;
  }
  set content(value: string) {
    this._content = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    FeatureImageDto.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): FeatureImageDto.AsObject {
    return {
      featureType: this.featureType,
      content: this.content
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): FeatureImageDto.AsProtobufJSON {
    return {
      featureType: this.featureType,
      content: this.content
    };
  }
}
export module FeatureImageDto {
  /**
   * Standard JavaScript object representation for FeatureImageDto
   */
  export interface AsObject {
    featureType: string;
    content: string;
  }

  /**
   * Protobuf JSON representation for FeatureImageDto
   */
  export interface AsProtobufJSON {
    featureType: string;
    content: string;
  }
}

/**
 * Message implementation for epicore.admin.ToggleDisableSubscriptionFeatureRequest
 */
export class ToggleDisableSubscriptionFeatureRequest implements GrpcMessage {
  static id = 'epicore.admin.ToggleDisableSubscriptionFeatureRequest';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new ToggleDisableSubscriptionFeatureRequest();
    ToggleDisableSubscriptionFeatureRequest.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: ToggleDisableSubscriptionFeatureRequest) {
    _instance.subscriptionId = _instance.subscriptionId || 0;
    _instance.featureId = _instance.featureId || 0;
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: ToggleDisableSubscriptionFeatureRequest,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.subscriptionId = _reader.readInt32();
          break;
        case 2:
          _instance.featureId = _reader.readInt32();
          break;
        default:
          _reader.skipField();
      }
    }

    ToggleDisableSubscriptionFeatureRequest.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: ToggleDisableSubscriptionFeatureRequest,
    _writer: BinaryWriter
  ) {
    if (_instance.subscriptionId) {
      _writer.writeInt32(1, _instance.subscriptionId);
    }
    if (_instance.featureId) {
      _writer.writeInt32(2, _instance.featureId);
    }
  }

  private _subscriptionId: number;
  private _featureId: number;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of ToggleDisableSubscriptionFeatureRequest to deeply clone from
   */
  constructor(
    _value?: RecursivePartial<ToggleDisableSubscriptionFeatureRequest.AsObject>
  ) {
    _value = _value || {};
    this.subscriptionId = _value.subscriptionId;
    this.featureId = _value.featureId;
    ToggleDisableSubscriptionFeatureRequest.refineValues(this);
  }
  get subscriptionId(): number {
    return this._subscriptionId;
  }
  set subscriptionId(value: number) {
    this._subscriptionId = value;
  }
  get featureId(): number {
    return this._featureId;
  }
  set featureId(value: number) {
    this._featureId = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    ToggleDisableSubscriptionFeatureRequest.serializeBinaryToWriter(
      this,
      writer
    );
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): ToggleDisableSubscriptionFeatureRequest.AsObject {
    return {
      subscriptionId: this.subscriptionId,
      featureId: this.featureId
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): ToggleDisableSubscriptionFeatureRequest.AsProtobufJSON {
    return {
      subscriptionId: this.subscriptionId,
      featureId: this.featureId
    };
  }
}
export module ToggleDisableSubscriptionFeatureRequest {
  /**
   * Standard JavaScript object representation for ToggleDisableSubscriptionFeatureRequest
   */
  export interface AsObject {
    subscriptionId: number;
    featureId: number;
  }

  /**
   * Protobuf JSON representation for ToggleDisableSubscriptionFeatureRequest
   */
  export interface AsProtobufJSON {
    subscriptionId: number;
    featureId: number;
  }
}

/**
 * Message implementation for epicore.admin.DisableToggleRequest
 */
export class DisableToggleRequest implements GrpcMessage {
  static id = 'epicore.admin.DisableToggleRequest';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new DisableToggleRequest();
    DisableToggleRequest.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: DisableToggleRequest) {
    _instance.id = _instance.id || 0;
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: DisableToggleRequest,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.id = _reader.readInt32();
          break;
        default:
          _reader.skipField();
      }
    }

    DisableToggleRequest.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: DisableToggleRequest,
    _writer: BinaryWriter
  ) {
    if (_instance.id) {
      _writer.writeInt32(1, _instance.id);
    }
  }

  private _id: number;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of DisableToggleRequest to deeply clone from
   */
  constructor(_value?: RecursivePartial<DisableToggleRequest.AsObject>) {
    _value = _value || {};
    this.id = _value.id;
    DisableToggleRequest.refineValues(this);
  }
  get id(): number {
    return this._id;
  }
  set id(value: number) {
    this._id = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    DisableToggleRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): DisableToggleRequest.AsObject {
    return {
      id: this.id
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): DisableToggleRequest.AsProtobufJSON {
    return {
      id: this.id
    };
  }
}
export module DisableToggleRequest {
  /**
   * Standard JavaScript object representation for DisableToggleRequest
   */
  export interface AsObject {
    id: number;
  }

  /**
   * Protobuf JSON representation for DisableToggleRequest
   */
  export interface AsProtobufJSON {
    id: number;
  }
}

/**
 * Message implementation for epicore.admin.GetSubscriptionRequest
 */
export class GetSubscriptionRequest implements GrpcMessage {
  static id = 'epicore.admin.GetSubscriptionRequest';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new GetSubscriptionRequest();
    GetSubscriptionRequest.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: GetSubscriptionRequest) {
    _instance.subscriptionId = _instance.subscriptionId || 0;
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: GetSubscriptionRequest,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.subscriptionId = _reader.readInt32();
          break;
        default:
          _reader.skipField();
      }
    }

    GetSubscriptionRequest.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: GetSubscriptionRequest,
    _writer: BinaryWriter
  ) {
    if (_instance.subscriptionId) {
      _writer.writeInt32(1, _instance.subscriptionId);
    }
  }

  private _subscriptionId: number;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of GetSubscriptionRequest to deeply clone from
   */
  constructor(_value?: RecursivePartial<GetSubscriptionRequest.AsObject>) {
    _value = _value || {};
    this.subscriptionId = _value.subscriptionId;
    GetSubscriptionRequest.refineValues(this);
  }
  get subscriptionId(): number {
    return this._subscriptionId;
  }
  set subscriptionId(value: number) {
    this._subscriptionId = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    GetSubscriptionRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): GetSubscriptionRequest.AsObject {
    return {
      subscriptionId: this.subscriptionId
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): GetSubscriptionRequest.AsProtobufJSON {
    return {
      subscriptionId: this.subscriptionId
    };
  }
}
export module GetSubscriptionRequest {
  /**
   * Standard JavaScript object representation for GetSubscriptionRequest
   */
  export interface AsObject {
    subscriptionId: number;
  }

  /**
   * Protobuf JSON representation for GetSubscriptionRequest
   */
  export interface AsProtobufJSON {
    subscriptionId: number;
  }
}

/**
 * Message implementation for epicore.admin.GetSubscriptionsResponse
 */
export class GetSubscriptionsResponse implements GrpcMessage {
  static id = 'epicore.admin.GetSubscriptionsResponse';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new GetSubscriptionsResponse();
    GetSubscriptionsResponse.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: GetSubscriptionsResponse) {
    _instance.subscriptions = _instance.subscriptions || [];
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: GetSubscriptionsResponse,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          const messageInitializer1 = new SubscriptionFullDetail();
          _reader.readMessage(
            messageInitializer1,
            SubscriptionFullDetail.deserializeBinaryFromReader
          );
          (_instance.subscriptions = _instance.subscriptions || []).push(
            messageInitializer1
          );
          break;
        default:
          _reader.skipField();
      }
    }

    GetSubscriptionsResponse.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: GetSubscriptionsResponse,
    _writer: BinaryWriter
  ) {
    if (_instance.subscriptions && _instance.subscriptions.length) {
      _writer.writeRepeatedMessage(
        1,
        _instance.subscriptions as any,
        SubscriptionFullDetail.serializeBinaryToWriter
      );
    }
  }

  private _subscriptions?: SubscriptionFullDetail[];

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of GetSubscriptionsResponse to deeply clone from
   */
  constructor(_value?: RecursivePartial<GetSubscriptionsResponse.AsObject>) {
    _value = _value || {};
    this.subscriptions = (_value.subscriptions || []).map(
      m => new SubscriptionFullDetail(m)
    );
    GetSubscriptionsResponse.refineValues(this);
  }
  get subscriptions(): SubscriptionFullDetail[] | undefined {
    return this._subscriptions;
  }
  set subscriptions(value: SubscriptionFullDetail[] | undefined) {
    this._subscriptions = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    GetSubscriptionsResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): GetSubscriptionsResponse.AsObject {
    return {
      subscriptions: (this.subscriptions || []).map(m => m.toObject())
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): GetSubscriptionsResponse.AsProtobufJSON {
    return {
      subscriptions: (this.subscriptions || []).map(m =>
        m.toProtobufJSON(options)
      )
    };
  }
}
export module GetSubscriptionsResponse {
  /**
   * Standard JavaScript object representation for GetSubscriptionsResponse
   */
  export interface AsObject {
    subscriptions?: SubscriptionFullDetail.AsObject[];
  }

  /**
   * Protobuf JSON representation for GetSubscriptionsResponse
   */
  export interface AsProtobufJSON {
    subscriptions: SubscriptionFullDetail.AsProtobufJSON[] | null;
  }
}

/**
 * Message implementation for epicore.admin.GetForAddSubscriptionPrerequisitesResponse
 */
export class GetForAddSubscriptionPrerequisitesResponse implements GrpcMessage {
  static id = 'epicore.admin.GetForAddSubscriptionPrerequisitesResponse';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new GetForAddSubscriptionPrerequisitesResponse();
    GetForAddSubscriptionPrerequisitesResponse.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: GetForAddSubscriptionPrerequisitesResponse) {
    _instance.featureParameterTypes = _instance.featureParameterTypes || [];
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: GetForAddSubscriptionPrerequisitesResponse,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          const messageInitializer1 = new FeatureParameterTypeDto();
          _reader.readMessage(
            messageInitializer1,
            FeatureParameterTypeDto.deserializeBinaryFromReader
          );
          (_instance.featureParameterTypes =
            _instance.featureParameterTypes || []).push(messageInitializer1);
          break;
        default:
          _reader.skipField();
      }
    }

    GetForAddSubscriptionPrerequisitesResponse.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: GetForAddSubscriptionPrerequisitesResponse,
    _writer: BinaryWriter
  ) {
    if (
      _instance.featureParameterTypes &&
      _instance.featureParameterTypes.length
    ) {
      _writer.writeRepeatedMessage(
        1,
        _instance.featureParameterTypes as any,
        FeatureParameterTypeDto.serializeBinaryToWriter
      );
    }
  }

  private _featureParameterTypes?: FeatureParameterTypeDto[];

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of GetForAddSubscriptionPrerequisitesResponse to deeply clone from
   */
  constructor(
    _value?: RecursivePartial<
      GetForAddSubscriptionPrerequisitesResponse.AsObject
    >
  ) {
    _value = _value || {};
    this.featureParameterTypes = (_value.featureParameterTypes || []).map(
      m => new FeatureParameterTypeDto(m)
    );
    GetForAddSubscriptionPrerequisitesResponse.refineValues(this);
  }
  get featureParameterTypes(): FeatureParameterTypeDto[] | undefined {
    return this._featureParameterTypes;
  }
  set featureParameterTypes(value: FeatureParameterTypeDto[] | undefined) {
    this._featureParameterTypes = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    GetForAddSubscriptionPrerequisitesResponse.serializeBinaryToWriter(
      this,
      writer
    );
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): GetForAddSubscriptionPrerequisitesResponse.AsObject {
    return {
      featureParameterTypes: (this.featureParameterTypes || []).map(m =>
        m.toObject()
      )
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): GetForAddSubscriptionPrerequisitesResponse.AsProtobufJSON {
    return {
      featureParameterTypes: (this.featureParameterTypes || []).map(m =>
        m.toProtobufJSON(options)
      )
    };
  }
}
export module GetForAddSubscriptionPrerequisitesResponse {
  /**
   * Standard JavaScript object representation for GetForAddSubscriptionPrerequisitesResponse
   */
  export interface AsObject {
    featureParameterTypes?: FeatureParameterTypeDto.AsObject[];
  }

  /**
   * Protobuf JSON representation for GetForAddSubscriptionPrerequisitesResponse
   */
  export interface AsProtobufJSON {
    featureParameterTypes: FeatureParameterTypeDto.AsProtobufJSON[] | null;
  }
}

/**
 * Message implementation for epicore.admin.FeatureParameterTypeDto
 */
export class FeatureParameterTypeDto implements GrpcMessage {
  static id = 'epicore.admin.FeatureParameterTypeDto';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new FeatureParameterTypeDto();
    FeatureParameterTypeDto.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: FeatureParameterTypeDto) {
    _instance.title = _instance.title || '';
    _instance.description = _instance.description || '';
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: FeatureParameterTypeDto,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.title = _reader.readString();
          break;
        case 2:
          _instance.description = _reader.readString();
          break;
        default:
          _reader.skipField();
      }
    }

    FeatureParameterTypeDto.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: FeatureParameterTypeDto,
    _writer: BinaryWriter
  ) {
    if (_instance.title) {
      _writer.writeString(1, _instance.title);
    }
    if (_instance.description) {
      _writer.writeString(2, _instance.description);
    }
  }

  private _title: string;
  private _description: string;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of FeatureParameterTypeDto to deeply clone from
   */
  constructor(_value?: RecursivePartial<FeatureParameterTypeDto.AsObject>) {
    _value = _value || {};
    this.title = _value.title;
    this.description = _value.description;
    FeatureParameterTypeDto.refineValues(this);
  }
  get title(): string {
    return this._title;
  }
  set title(value: string) {
    this._title = value;
  }
  get description(): string {
    return this._description;
  }
  set description(value: string) {
    this._description = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    FeatureParameterTypeDto.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): FeatureParameterTypeDto.AsObject {
    return {
      title: this.title,
      description: this.description
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): FeatureParameterTypeDto.AsProtobufJSON {
    return {
      title: this.title,
      description: this.description
    };
  }
}
export module FeatureParameterTypeDto {
  /**
   * Standard JavaScript object representation for FeatureParameterTypeDto
   */
  export interface AsObject {
    title: string;
    description: string;
  }

  /**
   * Protobuf JSON representation for FeatureParameterTypeDto
   */
  export interface AsProtobufJSON {
    title: string;
    description: string;
  }
}

/**
 * Message implementation for epicore.admin.UpdateSubscriptionRequest
 */
export class UpdateSubscriptionRequest implements GrpcMessage {
  static id = 'epicore.admin.UpdateSubscriptionRequest';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new UpdateSubscriptionRequest();
    UpdateSubscriptionRequest.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: UpdateSubscriptionRequest) {
    _instance.id = _instance.id || 0;
    _instance.title = _instance.title || '';
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: UpdateSubscriptionRequest,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.id = _reader.readInt32();
          break;
        case 2:
          _instance.title = _reader.readString();
          break;
        default:
          _reader.skipField();
      }
    }

    UpdateSubscriptionRequest.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: UpdateSubscriptionRequest,
    _writer: BinaryWriter
  ) {
    if (_instance.id) {
      _writer.writeInt32(1, _instance.id);
    }
    if (_instance.title) {
      _writer.writeString(2, _instance.title);
    }
  }

  private _id: number;
  private _title: string;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of UpdateSubscriptionRequest to deeply clone from
   */
  constructor(_value?: RecursivePartial<UpdateSubscriptionRequest.AsObject>) {
    _value = _value || {};
    this.id = _value.id;
    this.title = _value.title;
    UpdateSubscriptionRequest.refineValues(this);
  }
  get id(): number {
    return this._id;
  }
  set id(value: number) {
    this._id = value;
  }
  get title(): string {
    return this._title;
  }
  set title(value: string) {
    this._title = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    UpdateSubscriptionRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): UpdateSubscriptionRequest.AsObject {
    return {
      id: this.id,
      title: this.title
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): UpdateSubscriptionRequest.AsProtobufJSON {
    return {
      id: this.id,
      title: this.title
    };
  }
}
export module UpdateSubscriptionRequest {
  /**
   * Standard JavaScript object representation for UpdateSubscriptionRequest
   */
  export interface AsObject {
    id: number;
    title: string;
  }

  /**
   * Protobuf JSON representation for UpdateSubscriptionRequest
   */
  export interface AsProtobufJSON {
    id: number;
    title: string;
  }
}

/**
 * Message implementation for epicore.admin.CreateSubscriptionRequest
 */
export class CreateSubscriptionRequest implements GrpcMessage {
  static id = 'epicore.admin.CreateSubscriptionRequest';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new CreateSubscriptionRequest();
    CreateSubscriptionRequest.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: CreateSubscriptionRequest) {
    _instance.title = _instance.title || '';
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: CreateSubscriptionRequest,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.title = _reader.readString();
          break;
        default:
          _reader.skipField();
      }
    }

    CreateSubscriptionRequest.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: CreateSubscriptionRequest,
    _writer: BinaryWriter
  ) {
    if (_instance.title) {
      _writer.writeString(1, _instance.title);
    }
  }

  private _title: string;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of CreateSubscriptionRequest to deeply clone from
   */
  constructor(_value?: RecursivePartial<CreateSubscriptionRequest.AsObject>) {
    _value = _value || {};
    this.title = _value.title;
    CreateSubscriptionRequest.refineValues(this);
  }
  get title(): string {
    return this._title;
  }
  set title(value: string) {
    this._title = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    CreateSubscriptionRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): CreateSubscriptionRequest.AsObject {
    return {
      title: this.title
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): CreateSubscriptionRequest.AsProtobufJSON {
    return {
      title: this.title
    };
  }
}
export module CreateSubscriptionRequest {
  /**
   * Standard JavaScript object representation for CreateSubscriptionRequest
   */
  export interface AsObject {
    title: string;
  }

  /**
   * Protobuf JSON representation for CreateSubscriptionRequest
   */
  export interface AsProtobufJSON {
    title: string;
  }
}

/**
 * Message implementation for epicore.admin.SubscriptionResponse
 */
export class SubscriptionResponse implements GrpcMessage {
  static id = 'epicore.admin.SubscriptionResponse';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new SubscriptionResponse();
    SubscriptionResponse.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: SubscriptionResponse) {
    _instance.id = _instance.id || 0;
    _instance.title = _instance.title || '';
    _instance.createdAt = _instance.createdAt || undefined;
    _instance.lastUpdate = _instance.lastUpdate || undefined;
    _instance.disable = _instance.disable || false;
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: SubscriptionResponse,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.id = _reader.readInt32();
          break;
        case 2:
          _instance.title = _reader.readString();
          break;
        case 3:
          _instance.createdAt = new googleProtobuf001.Timestamp();
          _reader.readMessage(
            _instance.createdAt,
            googleProtobuf001.Timestamp.deserializeBinaryFromReader
          );
          break;
        case 4:
          _instance.lastUpdate = new googleProtobuf001.Timestamp();
          _reader.readMessage(
            _instance.lastUpdate,
            googleProtobuf001.Timestamp.deserializeBinaryFromReader
          );
          break;
        case 5:
          _instance.disable = _reader.readBool();
          break;
        default:
          _reader.skipField();
      }
    }

    SubscriptionResponse.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: SubscriptionResponse,
    _writer: BinaryWriter
  ) {
    if (_instance.id) {
      _writer.writeInt32(1, _instance.id);
    }
    if (_instance.title) {
      _writer.writeString(2, _instance.title);
    }
    if (_instance.createdAt) {
      _writer.writeMessage(
        3,
        _instance.createdAt as any,
        googleProtobuf001.Timestamp.serializeBinaryToWriter
      );
    }
    if (_instance.lastUpdate) {
      _writer.writeMessage(
        4,
        _instance.lastUpdate as any,
        googleProtobuf001.Timestamp.serializeBinaryToWriter
      );
    }
    if (_instance.disable) {
      _writer.writeBool(5, _instance.disable);
    }
  }

  private _id: number;
  private _title: string;
  private _createdAt?: googleProtobuf001.Timestamp;
  private _lastUpdate?: googleProtobuf001.Timestamp;
  private _disable: boolean;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of SubscriptionResponse to deeply clone from
   */
  constructor(_value?: RecursivePartial<SubscriptionResponse.AsObject>) {
    _value = _value || {};
    this.id = _value.id;
    this.title = _value.title;
    this.createdAt = _value.createdAt
      ? new googleProtobuf001.Timestamp(_value.createdAt)
      : undefined;
    this.lastUpdate = _value.lastUpdate
      ? new googleProtobuf001.Timestamp(_value.lastUpdate)
      : undefined;
    this.disable = _value.disable;
    SubscriptionResponse.refineValues(this);
  }
  get id(): number {
    return this._id;
  }
  set id(value: number) {
    this._id = value;
  }
  get title(): string {
    return this._title;
  }
  set title(value: string) {
    this._title = value;
  }
  get createdAt(): googleProtobuf001.Timestamp | undefined {
    return this._createdAt;
  }
  set createdAt(value: googleProtobuf001.Timestamp | undefined) {
    this._createdAt = value;
  }
  get lastUpdate(): googleProtobuf001.Timestamp | undefined {
    return this._lastUpdate;
  }
  set lastUpdate(value: googleProtobuf001.Timestamp | undefined) {
    this._lastUpdate = value;
  }
  get disable(): boolean {
    return this._disable;
  }
  set disable(value: boolean) {
    this._disable = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    SubscriptionResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): SubscriptionResponse.AsObject {
    return {
      id: this.id,
      title: this.title,
      createdAt: this.createdAt ? this.createdAt.toObject() : undefined,
      lastUpdate: this.lastUpdate ? this.lastUpdate.toObject() : undefined,
      disable: this.disable
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): SubscriptionResponse.AsProtobufJSON {
    return {
      id: this.id,
      title: this.title,
      createdAt: this.createdAt ? this.createdAt.toProtobufJSON(options) : null,
      lastUpdate: this.lastUpdate
        ? this.lastUpdate.toProtobufJSON(options)
        : null,
      disable: this.disable
    };
  }
}
export module SubscriptionResponse {
  /**
   * Standard JavaScript object representation for SubscriptionResponse
   */
  export interface AsObject {
    id: number;
    title: string;
    createdAt?: googleProtobuf001.Timestamp.AsObject;
    lastUpdate?: googleProtobuf001.Timestamp.AsObject;
    disable: boolean;
  }

  /**
   * Protobuf JSON representation for SubscriptionResponse
   */
  export interface AsProtobufJSON {
    id: number;
    title: string;
    createdAt: googleProtobuf001.Timestamp.AsProtobufJSON | null;
    lastUpdate: googleProtobuf001.Timestamp.AsProtobufJSON | null;
    disable: boolean;
  }
}

/**
 * Message implementation for epicore.admin.SubscriptionFullDetail
 */
export class SubscriptionFullDetail implements GrpcMessage {
  static id = 'epicore.admin.SubscriptionFullDetail';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new SubscriptionFullDetail();
    SubscriptionFullDetail.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: SubscriptionFullDetail) {
    _instance.id = _instance.id || 0;
    _instance.title = _instance.title || '';
    _instance.createdAt = _instance.createdAt || undefined;
    _instance.lastUpdate = _instance.lastUpdate || undefined;
    _instance.disable = _instance.disable || false;
    _instance.subscriptionFeatures = _instance.subscriptionFeatures || [];
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: SubscriptionFullDetail,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.id = _reader.readInt32();
          break;
        case 2:
          _instance.title = _reader.readString();
          break;
        case 3:
          _instance.createdAt = new googleProtobuf001.Timestamp();
          _reader.readMessage(
            _instance.createdAt,
            googleProtobuf001.Timestamp.deserializeBinaryFromReader
          );
          break;
        case 4:
          _instance.lastUpdate = new googleProtobuf001.Timestamp();
          _reader.readMessage(
            _instance.lastUpdate,
            googleProtobuf001.Timestamp.deserializeBinaryFromReader
          );
          break;
        case 5:
          _instance.disable = _reader.readBool();
          break;
        case 6:
          const messageInitializer6 = new SubscriptionFeatureDto();
          _reader.readMessage(
            messageInitializer6,
            SubscriptionFeatureDto.deserializeBinaryFromReader
          );
          (_instance.subscriptionFeatures =
            _instance.subscriptionFeatures || []).push(messageInitializer6);
          break;
        default:
          _reader.skipField();
      }
    }

    SubscriptionFullDetail.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: SubscriptionFullDetail,
    _writer: BinaryWriter
  ) {
    if (_instance.id) {
      _writer.writeInt32(1, _instance.id);
    }
    if (_instance.title) {
      _writer.writeString(2, _instance.title);
    }
    if (_instance.createdAt) {
      _writer.writeMessage(
        3,
        _instance.createdAt as any,
        googleProtobuf001.Timestamp.serializeBinaryToWriter
      );
    }
    if (_instance.lastUpdate) {
      _writer.writeMessage(
        4,
        _instance.lastUpdate as any,
        googleProtobuf001.Timestamp.serializeBinaryToWriter
      );
    }
    if (_instance.disable) {
      _writer.writeBool(5, _instance.disable);
    }
    if (
      _instance.subscriptionFeatures &&
      _instance.subscriptionFeatures.length
    ) {
      _writer.writeRepeatedMessage(
        6,
        _instance.subscriptionFeatures as any,
        SubscriptionFeatureDto.serializeBinaryToWriter
      );
    }
  }

  private _id: number;
  private _title: string;
  private _createdAt?: googleProtobuf001.Timestamp;
  private _lastUpdate?: googleProtobuf001.Timestamp;
  private _disable: boolean;
  private _subscriptionFeatures?: SubscriptionFeatureDto[];

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of SubscriptionFullDetail to deeply clone from
   */
  constructor(_value?: RecursivePartial<SubscriptionFullDetail.AsObject>) {
    _value = _value || {};
    this.id = _value.id;
    this.title = _value.title;
    this.createdAt = _value.createdAt
      ? new googleProtobuf001.Timestamp(_value.createdAt)
      : undefined;
    this.lastUpdate = _value.lastUpdate
      ? new googleProtobuf001.Timestamp(_value.lastUpdate)
      : undefined;
    this.disable = _value.disable;
    this.subscriptionFeatures = (_value.subscriptionFeatures || []).map(
      m => new SubscriptionFeatureDto(m)
    );
    SubscriptionFullDetail.refineValues(this);
  }
  get id(): number {
    return this._id;
  }
  set id(value: number) {
    this._id = value;
  }
  get title(): string {
    return this._title;
  }
  set title(value: string) {
    this._title = value;
  }
  get createdAt(): googleProtobuf001.Timestamp | undefined {
    return this._createdAt;
  }
  set createdAt(value: googleProtobuf001.Timestamp | undefined) {
    this._createdAt = value;
  }
  get lastUpdate(): googleProtobuf001.Timestamp | undefined {
    return this._lastUpdate;
  }
  set lastUpdate(value: googleProtobuf001.Timestamp | undefined) {
    this._lastUpdate = value;
  }
  get disable(): boolean {
    return this._disable;
  }
  set disable(value: boolean) {
    this._disable = value;
  }
  get subscriptionFeatures(): SubscriptionFeatureDto[] | undefined {
    return this._subscriptionFeatures;
  }
  set subscriptionFeatures(value: SubscriptionFeatureDto[] | undefined) {
    this._subscriptionFeatures = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    SubscriptionFullDetail.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): SubscriptionFullDetail.AsObject {
    return {
      id: this.id,
      title: this.title,
      createdAt: this.createdAt ? this.createdAt.toObject() : undefined,
      lastUpdate: this.lastUpdate ? this.lastUpdate.toObject() : undefined,
      disable: this.disable,
      subscriptionFeatures: (this.subscriptionFeatures || []).map(m =>
        m.toObject()
      )
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): SubscriptionFullDetail.AsProtobufJSON {
    return {
      id: this.id,
      title: this.title,
      createdAt: this.createdAt ? this.createdAt.toProtobufJSON(options) : null,
      lastUpdate: this.lastUpdate
        ? this.lastUpdate.toProtobufJSON(options)
        : null,
      disable: this.disable,
      subscriptionFeatures: (this.subscriptionFeatures || []).map(m =>
        m.toProtobufJSON(options)
      )
    };
  }
}
export module SubscriptionFullDetail {
  /**
   * Standard JavaScript object representation for SubscriptionFullDetail
   */
  export interface AsObject {
    id: number;
    title: string;
    createdAt?: googleProtobuf001.Timestamp.AsObject;
    lastUpdate?: googleProtobuf001.Timestamp.AsObject;
    disable: boolean;
    subscriptionFeatures?: SubscriptionFeatureDto.AsObject[];
  }

  /**
   * Protobuf JSON representation for SubscriptionFullDetail
   */
  export interface AsProtobufJSON {
    id: number;
    title: string;
    createdAt: googleProtobuf001.Timestamp.AsProtobufJSON | null;
    lastUpdate: googleProtobuf001.Timestamp.AsProtobufJSON | null;
    disable: boolean;
    subscriptionFeatures: SubscriptionFeatureDto.AsProtobufJSON[] | null;
  }
}

/**
 * Message implementation for epicore.admin.CreateFeatureForSubscriptionRequest
 */
export class CreateFeatureForSubscriptionRequest implements GrpcMessage {
  static id = 'epicore.admin.CreateFeatureForSubscriptionRequest';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new CreateFeatureForSubscriptionRequest();
    CreateFeatureForSubscriptionRequest.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: CreateFeatureForSubscriptionRequest) {
    _instance.subscriptionId = _instance.subscriptionId || 0;
    _instance.subscriptionFeatures = _instance.subscriptionFeatures || [];
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: CreateFeatureForSubscriptionRequest,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.subscriptionId = _reader.readInt32();
          break;
        case 2:
          const messageInitializer2 = new SubscriptionFeatureDto();
          _reader.readMessage(
            messageInitializer2,
            SubscriptionFeatureDto.deserializeBinaryFromReader
          );
          (_instance.subscriptionFeatures =
            _instance.subscriptionFeatures || []).push(messageInitializer2);
          break;
        default:
          _reader.skipField();
      }
    }

    CreateFeatureForSubscriptionRequest.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: CreateFeatureForSubscriptionRequest,
    _writer: BinaryWriter
  ) {
    if (_instance.subscriptionId) {
      _writer.writeInt32(1, _instance.subscriptionId);
    }
    if (
      _instance.subscriptionFeatures &&
      _instance.subscriptionFeatures.length
    ) {
      _writer.writeRepeatedMessage(
        2,
        _instance.subscriptionFeatures as any,
        SubscriptionFeatureDto.serializeBinaryToWriter
      );
    }
  }

  private _subscriptionId: number;
  private _subscriptionFeatures?: SubscriptionFeatureDto[];

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of CreateFeatureForSubscriptionRequest to deeply clone from
   */
  constructor(
    _value?: RecursivePartial<CreateFeatureForSubscriptionRequest.AsObject>
  ) {
    _value = _value || {};
    this.subscriptionId = _value.subscriptionId;
    this.subscriptionFeatures = (_value.subscriptionFeatures || []).map(
      m => new SubscriptionFeatureDto(m)
    );
    CreateFeatureForSubscriptionRequest.refineValues(this);
  }
  get subscriptionId(): number {
    return this._subscriptionId;
  }
  set subscriptionId(value: number) {
    this._subscriptionId = value;
  }
  get subscriptionFeatures(): SubscriptionFeatureDto[] | undefined {
    return this._subscriptionFeatures;
  }
  set subscriptionFeatures(value: SubscriptionFeatureDto[] | undefined) {
    this._subscriptionFeatures = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    CreateFeatureForSubscriptionRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): CreateFeatureForSubscriptionRequest.AsObject {
    return {
      subscriptionId: this.subscriptionId,
      subscriptionFeatures: (this.subscriptionFeatures || []).map(m =>
        m.toObject()
      )
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): CreateFeatureForSubscriptionRequest.AsProtobufJSON {
    return {
      subscriptionId: this.subscriptionId,
      subscriptionFeatures: (this.subscriptionFeatures || []).map(m =>
        m.toProtobufJSON(options)
      )
    };
  }
}
export module CreateFeatureForSubscriptionRequest {
  /**
   * Standard JavaScript object representation for CreateFeatureForSubscriptionRequest
   */
  export interface AsObject {
    subscriptionId: number;
    subscriptionFeatures?: SubscriptionFeatureDto.AsObject[];
  }

  /**
   * Protobuf JSON representation for CreateFeatureForSubscriptionRequest
   */
  export interface AsProtobufJSON {
    subscriptionId: number;
    subscriptionFeatures: SubscriptionFeatureDto.AsProtobufJSON[] | null;
  }
}

/**
 * Message implementation for epicore.admin.SubscriptionFeatureDto
 */
export class SubscriptionFeatureDto implements GrpcMessage {
  static id = 'epicore.admin.SubscriptionFeatureDto';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new SubscriptionFeatureDto();
    SubscriptionFeatureDto.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: SubscriptionFeatureDto) {
    _instance.type = _instance.type || '';
    _instance.value = _instance.value || '';
    _instance.disable = _instance.disable || false;
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: SubscriptionFeatureDto,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.type = _reader.readString();
          break;
        case 2:
          _instance.value = _reader.readString();
          break;
        case 3:
          _instance.disable = _reader.readBool();
          break;
        default:
          _reader.skipField();
      }
    }

    SubscriptionFeatureDto.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: SubscriptionFeatureDto,
    _writer: BinaryWriter
  ) {
    if (_instance.type) {
      _writer.writeString(1, _instance.type);
    }
    if (_instance.value) {
      _writer.writeString(2, _instance.value);
    }
    if (_instance.disable) {
      _writer.writeBool(3, _instance.disable);
    }
  }

  private _type: string;
  private _value: string;
  private _disable: boolean;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of SubscriptionFeatureDto to deeply clone from
   */
  constructor(_value?: RecursivePartial<SubscriptionFeatureDto.AsObject>) {
    _value = _value || {};
    this.type = _value.type;
    this.value = _value.value;
    this.disable = _value.disable;
    SubscriptionFeatureDto.refineValues(this);
  }
  get type(): string {
    return this._type;
  }
  set type(value: string) {
    this._type = value;
  }
  get value(): string {
    return this._value;
  }
  set value(value: string) {
    this._value = value;
  }
  get disable(): boolean {
    return this._disable;
  }
  set disable(value: boolean) {
    this._disable = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    SubscriptionFeatureDto.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): SubscriptionFeatureDto.AsObject {
    return {
      type: this.type,
      value: this.value,
      disable: this.disable
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): SubscriptionFeatureDto.AsProtobufJSON {
    return {
      type: this.type,
      value: this.value,
      disable: this.disable
    };
  }
}
export module SubscriptionFeatureDto {
  /**
   * Standard JavaScript object representation for SubscriptionFeatureDto
   */
  export interface AsObject {
    type: string;
    value: string;
    disable: boolean;
  }

  /**
   * Protobuf JSON representation for SubscriptionFeatureDto
   */
  export interface AsProtobufJSON {
    type: string;
    value: string;
    disable: boolean;
  }
}

/**
 * Message implementation for epicore.admin.GetUserReportRequest
 */
export class GetUserReportRequest implements GrpcMessage {
  static id = 'epicore.admin.GetUserReportRequest';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new GetUserReportRequest();
    GetUserReportRequest.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: GetUserReportRequest) {
    _instance.userId = _instance.userId || 0;
    _instance.startDate = _instance.startDate || undefined;
    _instance.endDate = _instance.endDate || undefined;
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: GetUserReportRequest,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.userId = _reader.readInt32();
          break;
        case 2:
          _instance.startDate = new googleProtobuf001.Timestamp();
          _reader.readMessage(
            _instance.startDate,
            googleProtobuf001.Timestamp.deserializeBinaryFromReader
          );
          break;
        case 3:
          _instance.endDate = new googleProtobuf001.Timestamp();
          _reader.readMessage(
            _instance.endDate,
            googleProtobuf001.Timestamp.deserializeBinaryFromReader
          );
          break;
        default:
          _reader.skipField();
      }
    }

    GetUserReportRequest.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: GetUserReportRequest,
    _writer: BinaryWriter
  ) {
    if (_instance.userId) {
      _writer.writeInt32(1, _instance.userId);
    }
    if (_instance.startDate) {
      _writer.writeMessage(
        2,
        _instance.startDate as any,
        googleProtobuf001.Timestamp.serializeBinaryToWriter
      );
    }
    if (_instance.endDate) {
      _writer.writeMessage(
        3,
        _instance.endDate as any,
        googleProtobuf001.Timestamp.serializeBinaryToWriter
      );
    }
  }

  private _userId: number;
  private _startDate?: googleProtobuf001.Timestamp;
  private _endDate?: googleProtobuf001.Timestamp;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of GetUserReportRequest to deeply clone from
   */
  constructor(_value?: RecursivePartial<GetUserReportRequest.AsObject>) {
    _value = _value || {};
    this.userId = _value.userId;
    this.startDate = _value.startDate
      ? new googleProtobuf001.Timestamp(_value.startDate)
      : undefined;
    this.endDate = _value.endDate
      ? new googleProtobuf001.Timestamp(_value.endDate)
      : undefined;
    GetUserReportRequest.refineValues(this);
  }
  get userId(): number {
    return this._userId;
  }
  set userId(value: number) {
    this._userId = value;
  }
  get startDate(): googleProtobuf001.Timestamp | undefined {
    return this._startDate;
  }
  set startDate(value: googleProtobuf001.Timestamp | undefined) {
    this._startDate = value;
  }
  get endDate(): googleProtobuf001.Timestamp | undefined {
    return this._endDate;
  }
  set endDate(value: googleProtobuf001.Timestamp | undefined) {
    this._endDate = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    GetUserReportRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): GetUserReportRequest.AsObject {
    return {
      userId: this.userId,
      startDate: this.startDate ? this.startDate.toObject() : undefined,
      endDate: this.endDate ? this.endDate.toObject() : undefined
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): GetUserReportRequest.AsProtobufJSON {
    return {
      userId: this.userId,
      startDate: this.startDate ? this.startDate.toProtobufJSON(options) : null,
      endDate: this.endDate ? this.endDate.toProtobufJSON(options) : null
    };
  }
}
export module GetUserReportRequest {
  /**
   * Standard JavaScript object representation for GetUserReportRequest
   */
  export interface AsObject {
    userId: number;
    startDate?: googleProtobuf001.Timestamp.AsObject;
    endDate?: googleProtobuf001.Timestamp.AsObject;
  }

  /**
   * Protobuf JSON representation for GetUserReportRequest
   */
  export interface AsProtobufJSON {
    userId: number;
    startDate: googleProtobuf001.Timestamp.AsProtobufJSON | null;
    endDate: googleProtobuf001.Timestamp.AsProtobufJSON | null;
  }
}

/**
 * Message implementation for epicore.admin.GetUserReportResponse
 */
export class GetUserReportResponse implements GrpcMessage {
  static id = 'epicore.admin.GetUserReportResponse';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new GetUserReportResponse();
    GetUserReportResponse.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: GetUserReportResponse) {
    _instance.items = _instance.items || [];
    _instance.automaticTotals = _instance.automaticTotals || [];
    _instance.manualTotals = _instance.manualTotals || [];
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: GetUserReportResponse,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          const messageInitializer1 = new GetUserReportResponseItem();
          _reader.readMessage(
            messageInitializer1,
            GetUserReportResponseItem.deserializeBinaryFromReader
          );
          (_instance.items = _instance.items || []).push(messageInitializer1);
          break;
        case 2:
          const messageInitializer2 = new TotalsReport();
          _reader.readMessage(
            messageInitializer2,
            TotalsReport.deserializeBinaryFromReader
          );
          (_instance.automaticTotals = _instance.automaticTotals || []).push(
            messageInitializer2
          );
          break;
        case 3:
          const messageInitializer3 = new TotalsReport();
          _reader.readMessage(
            messageInitializer3,
            TotalsReport.deserializeBinaryFromReader
          );
          (_instance.manualTotals = _instance.manualTotals || []).push(
            messageInitializer3
          );
          break;
        default:
          _reader.skipField();
      }
    }

    GetUserReportResponse.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: GetUserReportResponse,
    _writer: BinaryWriter
  ) {
    if (_instance.items && _instance.items.length) {
      _writer.writeRepeatedMessage(
        1,
        _instance.items as any,
        GetUserReportResponseItem.serializeBinaryToWriter
      );
    }
    if (_instance.automaticTotals && _instance.automaticTotals.length) {
      _writer.writeRepeatedMessage(
        2,
        _instance.automaticTotals as any,
        TotalsReport.serializeBinaryToWriter
      );
    }
    if (_instance.manualTotals && _instance.manualTotals.length) {
      _writer.writeRepeatedMessage(
        3,
        _instance.manualTotals as any,
        TotalsReport.serializeBinaryToWriter
      );
    }
  }

  private _items?: GetUserReportResponseItem[];
  private _automaticTotals?: TotalsReport[];
  private _manualTotals?: TotalsReport[];

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of GetUserReportResponse to deeply clone from
   */
  constructor(_value?: RecursivePartial<GetUserReportResponse.AsObject>) {
    _value = _value || {};
    this.items = (_value.items || []).map(
      m => new GetUserReportResponseItem(m)
    );
    this.automaticTotals = (_value.automaticTotals || []).map(
      m => new TotalsReport(m)
    );
    this.manualTotals = (_value.manualTotals || []).map(
      m => new TotalsReport(m)
    );
    GetUserReportResponse.refineValues(this);
  }
  get items(): GetUserReportResponseItem[] | undefined {
    return this._items;
  }
  set items(value: GetUserReportResponseItem[] | undefined) {
    this._items = value;
  }
  get automaticTotals(): TotalsReport[] | undefined {
    return this._automaticTotals;
  }
  set automaticTotals(value: TotalsReport[] | undefined) {
    this._automaticTotals = value;
  }
  get manualTotals(): TotalsReport[] | undefined {
    return this._manualTotals;
  }
  set manualTotals(value: TotalsReport[] | undefined) {
    this._manualTotals = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    GetUserReportResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): GetUserReportResponse.AsObject {
    return {
      items: (this.items || []).map(m => m.toObject()),
      automaticTotals: (this.automaticTotals || []).map(m => m.toObject()),
      manualTotals: (this.manualTotals || []).map(m => m.toObject())
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): GetUserReportResponse.AsProtobufJSON {
    return {
      items: (this.items || []).map(m => m.toProtobufJSON(options)),
      automaticTotals: (this.automaticTotals || []).map(m =>
        m.toProtobufJSON(options)
      ),
      manualTotals: (this.manualTotals || []).map(m =>
        m.toProtobufJSON(options)
      )
    };
  }
}
export module GetUserReportResponse {
  /**
   * Standard JavaScript object representation for GetUserReportResponse
   */
  export interface AsObject {
    items?: GetUserReportResponseItem.AsObject[];
    automaticTotals?: TotalsReport.AsObject[];
    manualTotals?: TotalsReport.AsObject[];
  }

  /**
   * Protobuf JSON representation for GetUserReportResponse
   */
  export interface AsProtobufJSON {
    items: GetUserReportResponseItem.AsProtobufJSON[] | null;
    automaticTotals: TotalsReport.AsProtobufJSON[] | null;
    manualTotals: TotalsReport.AsProtobufJSON[] | null;
  }
}

/**
 * Message implementation for epicore.admin.GetUserReportResponseItem
 */
export class GetUserReportResponseItem implements GrpcMessage {
  static id = 'epicore.admin.GetUserReportResponseItem';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new GetUserReportResponseItem();
    GetUserReportResponseItem.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: GetUserReportResponseItem) {
    _instance.localDate = _instance.localDate || '';
    _instance.hour = _instance.hour || 0;
    _instance.chargedKwh = _instance.chargedKwh || 0;
    _instance.dischargedKwh = _instance.dischargedKwh || 0;
    _instance.electricityPrice = _instance.electricityPrice || 0;
    _instance.totalPrice = _instance.totalPrice || 0;
    _instance.serialNumber = _instance.serialNumber || '';
    _instance.solarProductionKwh = _instance.solarProductionKwh || 0;
    _instance.chargedFromGridKwh = _instance.chargedFromGridKwh || 0;
    _instance.isAutomatic = _instance.isAutomatic || false;
    _instance.acCharge = _instance.acCharge || undefined;
    _instance.dischargeLimitPercentage =
      _instance.dischargeLimitPercentage || undefined;
    _instance.chargeIsSet = _instance.chargeIsSet || undefined;
    _instance.dischargeIsSet = _instance.dischargeIsSet || undefined;
    _instance.soc = _instance.soc || undefined;
    _instance.consumptionKwh = _instance.consumptionKwh || undefined;
    _instance.chargeLimitPercentage =
      _instance.chargeLimitPercentage || undefined;
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: GetUserReportResponseItem,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.localDate = _reader.readString();
          break;
        case 2:
          _instance.hour = _reader.readInt32();
          break;
        case 3:
          _instance.chargedKwh = _reader.readDouble();
          break;
        case 4:
          _instance.dischargedKwh = _reader.readDouble();
          break;
        case 5:
          _instance.electricityPrice = _reader.readDouble();
          break;
        case 6:
          _instance.totalPrice = _reader.readDouble();
          break;
        case 7:
          _instance.serialNumber = _reader.readString();
          break;
        case 8:
          _instance.solarProductionKwh = _reader.readDouble();
          break;
        case 9:
          _instance.chargedFromGridKwh = _reader.readDouble();
          break;
        case 10:
          _instance.isAutomatic = _reader.readBool();
          break;
        case 11:
          _instance.acCharge = new googleProtobuf002.BoolValue();
          _reader.readMessage(
            _instance.acCharge,
            googleProtobuf002.BoolValue.deserializeBinaryFromReader
          );
          break;
        case 12:
          _instance.dischargeLimitPercentage = new googleProtobuf002.Int32Value();
          _reader.readMessage(
            _instance.dischargeLimitPercentage,
            googleProtobuf002.Int32Value.deserializeBinaryFromReader
          );
          break;
        case 13:
          _instance.chargeIsSet = new googleProtobuf002.BoolValue();
          _reader.readMessage(
            _instance.chargeIsSet,
            googleProtobuf002.BoolValue.deserializeBinaryFromReader
          );
          break;
        case 14:
          _instance.dischargeIsSet = new googleProtobuf002.BoolValue();
          _reader.readMessage(
            _instance.dischargeIsSet,
            googleProtobuf002.BoolValue.deserializeBinaryFromReader
          );
          break;
        case 15:
          _instance.soc = new googleProtobuf002.Int32Value();
          _reader.readMessage(
            _instance.soc,
            googleProtobuf002.Int32Value.deserializeBinaryFromReader
          );
          break;
        case 16:
          _instance.consumptionKwh = new googleProtobuf002.DoubleValue();
          _reader.readMessage(
            _instance.consumptionKwh,
            googleProtobuf002.DoubleValue.deserializeBinaryFromReader
          );
          break;
        case 17:
          _instance.chargeLimitPercentage = new googleProtobuf002.Int32Value();
          _reader.readMessage(
            _instance.chargeLimitPercentage,
            googleProtobuf002.Int32Value.deserializeBinaryFromReader
          );
          break;
        default:
          _reader.skipField();
      }
    }

    GetUserReportResponseItem.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: GetUserReportResponseItem,
    _writer: BinaryWriter
  ) {
    if (_instance.localDate) {
      _writer.writeString(1, _instance.localDate);
    }
    if (_instance.hour) {
      _writer.writeInt32(2, _instance.hour);
    }
    if (_instance.chargedKwh) {
      _writer.writeDouble(3, _instance.chargedKwh);
    }
    if (_instance.dischargedKwh) {
      _writer.writeDouble(4, _instance.dischargedKwh);
    }
    if (_instance.electricityPrice) {
      _writer.writeDouble(5, _instance.electricityPrice);
    }
    if (_instance.totalPrice) {
      _writer.writeDouble(6, _instance.totalPrice);
    }
    if (_instance.serialNumber) {
      _writer.writeString(7, _instance.serialNumber);
    }
    if (_instance.solarProductionKwh) {
      _writer.writeDouble(8, _instance.solarProductionKwh);
    }
    if (_instance.chargedFromGridKwh) {
      _writer.writeDouble(9, _instance.chargedFromGridKwh);
    }
    if (_instance.isAutomatic) {
      _writer.writeBool(10, _instance.isAutomatic);
    }
    if (_instance.acCharge) {
      _writer.writeMessage(
        11,
        _instance.acCharge as any,
        googleProtobuf002.BoolValue.serializeBinaryToWriter
      );
    }
    if (_instance.dischargeLimitPercentage) {
      _writer.writeMessage(
        12,
        _instance.dischargeLimitPercentage as any,
        googleProtobuf002.Int32Value.serializeBinaryToWriter
      );
    }
    if (_instance.chargeIsSet) {
      _writer.writeMessage(
        13,
        _instance.chargeIsSet as any,
        googleProtobuf002.BoolValue.serializeBinaryToWriter
      );
    }
    if (_instance.dischargeIsSet) {
      _writer.writeMessage(
        14,
        _instance.dischargeIsSet as any,
        googleProtobuf002.BoolValue.serializeBinaryToWriter
      );
    }
    if (_instance.soc) {
      _writer.writeMessage(
        15,
        _instance.soc as any,
        googleProtobuf002.Int32Value.serializeBinaryToWriter
      );
    }
    if (_instance.consumptionKwh) {
      _writer.writeMessage(
        16,
        _instance.consumptionKwh as any,
        googleProtobuf002.DoubleValue.serializeBinaryToWriter
      );
    }
    if (_instance.chargeLimitPercentage) {
      _writer.writeMessage(
        17,
        _instance.chargeLimitPercentage as any,
        googleProtobuf002.Int32Value.serializeBinaryToWriter
      );
    }
  }

  private _localDate: string;
  private _hour: number;
  private _chargedKwh: number;
  private _dischargedKwh: number;
  private _electricityPrice: number;
  private _totalPrice: number;
  private _serialNumber: string;
  private _solarProductionKwh: number;
  private _chargedFromGridKwh: number;
  private _isAutomatic: boolean;
  private _acCharge?: googleProtobuf002.BoolValue;
  private _dischargeLimitPercentage?: googleProtobuf002.Int32Value;
  private _chargeIsSet?: googleProtobuf002.BoolValue;
  private _dischargeIsSet?: googleProtobuf002.BoolValue;
  private _soc?: googleProtobuf002.Int32Value;
  private _consumptionKwh?: googleProtobuf002.DoubleValue;
  private _chargeLimitPercentage?: googleProtobuf002.Int32Value;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of GetUserReportResponseItem to deeply clone from
   */
  constructor(_value?: RecursivePartial<GetUserReportResponseItem.AsObject>) {
    _value = _value || {};
    this.localDate = _value.localDate;
    this.hour = _value.hour;
    this.chargedKwh = _value.chargedKwh;
    this.dischargedKwh = _value.dischargedKwh;
    this.electricityPrice = _value.electricityPrice;
    this.totalPrice = _value.totalPrice;
    this.serialNumber = _value.serialNumber;
    this.solarProductionKwh = _value.solarProductionKwh;
    this.chargedFromGridKwh = _value.chargedFromGridKwh;
    this.isAutomatic = _value.isAutomatic;
    this.acCharge = _value.acCharge
      ? new googleProtobuf002.BoolValue(_value.acCharge)
      : undefined;
    this.dischargeLimitPercentage = _value.dischargeLimitPercentage
      ? new googleProtobuf002.Int32Value(_value.dischargeLimitPercentage)
      : undefined;
    this.chargeIsSet = _value.chargeIsSet
      ? new googleProtobuf002.BoolValue(_value.chargeIsSet)
      : undefined;
    this.dischargeIsSet = _value.dischargeIsSet
      ? new googleProtobuf002.BoolValue(_value.dischargeIsSet)
      : undefined;
    this.soc = _value.soc
      ? new googleProtobuf002.Int32Value(_value.soc)
      : undefined;
    this.consumptionKwh = _value.consumptionKwh
      ? new googleProtobuf002.DoubleValue(_value.consumptionKwh)
      : undefined;
    this.chargeLimitPercentage = _value.chargeLimitPercentage
      ? new googleProtobuf002.Int32Value(_value.chargeLimitPercentage)
      : undefined;
    GetUserReportResponseItem.refineValues(this);
  }
  get localDate(): string {
    return this._localDate;
  }
  set localDate(value: string) {
    this._localDate = value;
  }
  get hour(): number {
    return this._hour;
  }
  set hour(value: number) {
    this._hour = value;
  }
  get chargedKwh(): number {
    return this._chargedKwh;
  }
  set chargedKwh(value: number) {
    this._chargedKwh = value;
  }
  get dischargedKwh(): number {
    return this._dischargedKwh;
  }
  set dischargedKwh(value: number) {
    this._dischargedKwh = value;
  }
  get electricityPrice(): number {
    return this._electricityPrice;
  }
  set electricityPrice(value: number) {
    this._electricityPrice = value;
  }
  get totalPrice(): number {
    return this._totalPrice;
  }
  set totalPrice(value: number) {
    this._totalPrice = value;
  }
  get serialNumber(): string {
    return this._serialNumber;
  }
  set serialNumber(value: string) {
    this._serialNumber = value;
  }
  get solarProductionKwh(): number {
    return this._solarProductionKwh;
  }
  set solarProductionKwh(value: number) {
    this._solarProductionKwh = value;
  }
  get chargedFromGridKwh(): number {
    return this._chargedFromGridKwh;
  }
  set chargedFromGridKwh(value: number) {
    this._chargedFromGridKwh = value;
  }
  get isAutomatic(): boolean {
    return this._isAutomatic;
  }
  set isAutomatic(value: boolean) {
    this._isAutomatic = value;
  }
  get acCharge(): googleProtobuf002.BoolValue | undefined {
    return this._acCharge;
  }
  set acCharge(value: googleProtobuf002.BoolValue | undefined) {
    this._acCharge = value;
  }
  get dischargeLimitPercentage(): googleProtobuf002.Int32Value | undefined {
    return this._dischargeLimitPercentage;
  }
  set dischargeLimitPercentage(
    value: googleProtobuf002.Int32Value | undefined
  ) {
    this._dischargeLimitPercentage = value;
  }
  get chargeIsSet(): googleProtobuf002.BoolValue | undefined {
    return this._chargeIsSet;
  }
  set chargeIsSet(value: googleProtobuf002.BoolValue | undefined) {
    this._chargeIsSet = value;
  }
  get dischargeIsSet(): googleProtobuf002.BoolValue | undefined {
    return this._dischargeIsSet;
  }
  set dischargeIsSet(value: googleProtobuf002.BoolValue | undefined) {
    this._dischargeIsSet = value;
  }
  get soc(): googleProtobuf002.Int32Value | undefined {
    return this._soc;
  }
  set soc(value: googleProtobuf002.Int32Value | undefined) {
    this._soc = value;
  }
  get consumptionKwh(): googleProtobuf002.DoubleValue | undefined {
    return this._consumptionKwh;
  }
  set consumptionKwh(value: googleProtobuf002.DoubleValue | undefined) {
    this._consumptionKwh = value;
  }
  get chargeLimitPercentage(): googleProtobuf002.Int32Value | undefined {
    return this._chargeLimitPercentage;
  }
  set chargeLimitPercentage(value: googleProtobuf002.Int32Value | undefined) {
    this._chargeLimitPercentage = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    GetUserReportResponseItem.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): GetUserReportResponseItem.AsObject {
    return {
      localDate: this.localDate,
      hour: this.hour,
      chargedKwh: this.chargedKwh,
      dischargedKwh: this.dischargedKwh,
      electricityPrice: this.electricityPrice,
      totalPrice: this.totalPrice,
      serialNumber: this.serialNumber,
      solarProductionKwh: this.solarProductionKwh,
      chargedFromGridKwh: this.chargedFromGridKwh,
      isAutomatic: this.isAutomatic,
      acCharge: this.acCharge ? this.acCharge.toObject() : undefined,
      dischargeLimitPercentage: this.dischargeLimitPercentage
        ? this.dischargeLimitPercentage.toObject()
        : undefined,
      chargeIsSet: this.chargeIsSet ? this.chargeIsSet.toObject() : undefined,
      dischargeIsSet: this.dischargeIsSet
        ? this.dischargeIsSet.toObject()
        : undefined,
      soc: this.soc ? this.soc.toObject() : undefined,
      consumptionKwh: this.consumptionKwh
        ? this.consumptionKwh.toObject()
        : undefined,
      chargeLimitPercentage: this.chargeLimitPercentage
        ? this.chargeLimitPercentage.toObject()
        : undefined
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): GetUserReportResponseItem.AsProtobufJSON {
    return {
      localDate: this.localDate,
      hour: this.hour,
      chargedKwh: this.chargedKwh,
      dischargedKwh: this.dischargedKwh,
      electricityPrice: this.electricityPrice,
      totalPrice: this.totalPrice,
      serialNumber: this.serialNumber,
      solarProductionKwh: this.solarProductionKwh,
      chargedFromGridKwh: this.chargedFromGridKwh,
      isAutomatic: this.isAutomatic,
      acCharge: this.acCharge ? this.acCharge.toProtobufJSON(options) : null,
      dischargeLimitPercentage: this.dischargeLimitPercentage
        ? this.dischargeLimitPercentage.toProtobufJSON(options)
        : null,
      chargeIsSet: this.chargeIsSet
        ? this.chargeIsSet.toProtobufJSON(options)
        : null,
      dischargeIsSet: this.dischargeIsSet
        ? this.dischargeIsSet.toProtobufJSON(options)
        : null,
      soc: this.soc ? this.soc.toProtobufJSON(options) : null,
      consumptionKwh: this.consumptionKwh
        ? this.consumptionKwh.toProtobufJSON(options)
        : null,
      chargeLimitPercentage: this.chargeLimitPercentage
        ? this.chargeLimitPercentage.toProtobufJSON(options)
        : null
    };
  }
}
export module GetUserReportResponseItem {
  /**
   * Standard JavaScript object representation for GetUserReportResponseItem
   */
  export interface AsObject {
    localDate: string;
    hour: number;
    chargedKwh: number;
    dischargedKwh: number;
    electricityPrice: number;
    totalPrice: number;
    serialNumber: string;
    solarProductionKwh: number;
    chargedFromGridKwh: number;
    isAutomatic: boolean;
    acCharge?: googleProtobuf002.BoolValue.AsObject;
    dischargeLimitPercentage?: googleProtobuf002.Int32Value.AsObject;
    chargeIsSet?: googleProtobuf002.BoolValue.AsObject;
    dischargeIsSet?: googleProtobuf002.BoolValue.AsObject;
    soc?: googleProtobuf002.Int32Value.AsObject;
    consumptionKwh?: googleProtobuf002.DoubleValue.AsObject;
    chargeLimitPercentage?: googleProtobuf002.Int32Value.AsObject;
  }

  /**
   * Protobuf JSON representation for GetUserReportResponseItem
   */
  export interface AsProtobufJSON {
    localDate: string;
    hour: number;
    chargedKwh: number;
    dischargedKwh: number;
    electricityPrice: number;
    totalPrice: number;
    serialNumber: string;
    solarProductionKwh: number;
    chargedFromGridKwh: number;
    isAutomatic: boolean;
    acCharge: googleProtobuf002.BoolValue.AsProtobufJSON | null;
    dischargeLimitPercentage: googleProtobuf002.Int32Value.AsProtobufJSON | null;
    chargeIsSet: googleProtobuf002.BoolValue.AsProtobufJSON | null;
    dischargeIsSet: googleProtobuf002.BoolValue.AsProtobufJSON | null;
    soc: googleProtobuf002.Int32Value.AsProtobufJSON | null;
    consumptionKwh: googleProtobuf002.DoubleValue.AsProtobufJSON | null;
    chargeLimitPercentage: googleProtobuf002.Int32Value.AsProtobufJSON | null;
  }
}

/**
 * Message implementation for epicore.admin.TotalsReport
 */
export class TotalsReport implements GrpcMessage {
  static id = 'epicore.admin.TotalsReport';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new TotalsReport();
    TotalsReport.deserializeBinaryFromReader(instance, new BinaryReader(bytes));
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: TotalsReport) {
    _instance.serialNumber = _instance.serialNumber || '';
    _instance.totalChargedKwh = _instance.totalChargedKwh || 0;
    _instance.totalDischargedKwh = _instance.totalDischargedKwh || 0;
    _instance.totalSolarProductionKwh = _instance.totalSolarProductionKwh || 0;
    _instance.totalPrice = _instance.totalPrice || 0;
    _instance.totalConsumptionKwh = _instance.totalConsumptionKwh || 0;
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: TotalsReport,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.serialNumber = _reader.readString();
          break;
        case 2:
          _instance.totalChargedKwh = _reader.readDouble();
          break;
        case 3:
          _instance.totalDischargedKwh = _reader.readDouble();
          break;
        case 4:
          _instance.totalSolarProductionKwh = _reader.readDouble();
          break;
        case 5:
          _instance.totalPrice = _reader.readDouble();
          break;
        case 6:
          _instance.totalConsumptionKwh = _reader.readDouble();
          break;
        default:
          _reader.skipField();
      }
    }

    TotalsReport.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: TotalsReport,
    _writer: BinaryWriter
  ) {
    if (_instance.serialNumber) {
      _writer.writeString(1, _instance.serialNumber);
    }
    if (_instance.totalChargedKwh) {
      _writer.writeDouble(2, _instance.totalChargedKwh);
    }
    if (_instance.totalDischargedKwh) {
      _writer.writeDouble(3, _instance.totalDischargedKwh);
    }
    if (_instance.totalSolarProductionKwh) {
      _writer.writeDouble(4, _instance.totalSolarProductionKwh);
    }
    if (_instance.totalPrice) {
      _writer.writeDouble(5, _instance.totalPrice);
    }
    if (_instance.totalConsumptionKwh) {
      _writer.writeDouble(6, _instance.totalConsumptionKwh);
    }
  }

  private _serialNumber: string;
  private _totalChargedKwh: number;
  private _totalDischargedKwh: number;
  private _totalSolarProductionKwh: number;
  private _totalPrice: number;
  private _totalConsumptionKwh: number;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of TotalsReport to deeply clone from
   */
  constructor(_value?: RecursivePartial<TotalsReport.AsObject>) {
    _value = _value || {};
    this.serialNumber = _value.serialNumber;
    this.totalChargedKwh = _value.totalChargedKwh;
    this.totalDischargedKwh = _value.totalDischargedKwh;
    this.totalSolarProductionKwh = _value.totalSolarProductionKwh;
    this.totalPrice = _value.totalPrice;
    this.totalConsumptionKwh = _value.totalConsumptionKwh;
    TotalsReport.refineValues(this);
  }
  get serialNumber(): string {
    return this._serialNumber;
  }
  set serialNumber(value: string) {
    this._serialNumber = value;
  }
  get totalChargedKwh(): number {
    return this._totalChargedKwh;
  }
  set totalChargedKwh(value: number) {
    this._totalChargedKwh = value;
  }
  get totalDischargedKwh(): number {
    return this._totalDischargedKwh;
  }
  set totalDischargedKwh(value: number) {
    this._totalDischargedKwh = value;
  }
  get totalSolarProductionKwh(): number {
    return this._totalSolarProductionKwh;
  }
  set totalSolarProductionKwh(value: number) {
    this._totalSolarProductionKwh = value;
  }
  get totalPrice(): number {
    return this._totalPrice;
  }
  set totalPrice(value: number) {
    this._totalPrice = value;
  }
  get totalConsumptionKwh(): number {
    return this._totalConsumptionKwh;
  }
  set totalConsumptionKwh(value: number) {
    this._totalConsumptionKwh = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    TotalsReport.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): TotalsReport.AsObject {
    return {
      serialNumber: this.serialNumber,
      totalChargedKwh: this.totalChargedKwh,
      totalDischargedKwh: this.totalDischargedKwh,
      totalSolarProductionKwh: this.totalSolarProductionKwh,
      totalPrice: this.totalPrice,
      totalConsumptionKwh: this.totalConsumptionKwh
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): TotalsReport.AsProtobufJSON {
    return {
      serialNumber: this.serialNumber,
      totalChargedKwh: this.totalChargedKwh,
      totalDischargedKwh: this.totalDischargedKwh,
      totalSolarProductionKwh: this.totalSolarProductionKwh,
      totalPrice: this.totalPrice,
      totalConsumptionKwh: this.totalConsumptionKwh
    };
  }
}
export module TotalsReport {
  /**
   * Standard JavaScript object representation for TotalsReport
   */
  export interface AsObject {
    serialNumber: string;
    totalChargedKwh: number;
    totalDischargedKwh: number;
    totalSolarProductionKwh: number;
    totalPrice: number;
    totalConsumptionKwh: number;
  }

  /**
   * Protobuf JSON representation for TotalsReport
   */
  export interface AsProtobufJSON {
    serialNumber: string;
    totalChargedKwh: number;
    totalDischargedKwh: number;
    totalSolarProductionKwh: number;
    totalPrice: number;
    totalConsumptionKwh: number;
  }
}

/**
 * Message implementation for epicore.admin.GetTotalSavedRequest
 */
export class GetTotalSavedRequest implements GrpcMessage {
  static id = 'epicore.admin.GetTotalSavedRequest';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new GetTotalSavedRequest();
    GetTotalSavedRequest.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: GetTotalSavedRequest) {
    _instance.userId = _instance.userId || 0;
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: GetTotalSavedRequest,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.userId = _reader.readInt32();
          break;
        default:
          _reader.skipField();
      }
    }

    GetTotalSavedRequest.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: GetTotalSavedRequest,
    _writer: BinaryWriter
  ) {
    if (_instance.userId) {
      _writer.writeInt32(1, _instance.userId);
    }
  }

  private _userId: number;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of GetTotalSavedRequest to deeply clone from
   */
  constructor(_value?: RecursivePartial<GetTotalSavedRequest.AsObject>) {
    _value = _value || {};
    this.userId = _value.userId;
    GetTotalSavedRequest.refineValues(this);
  }
  get userId(): number {
    return this._userId;
  }
  set userId(value: number) {
    this._userId = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    GetTotalSavedRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): GetTotalSavedRequest.AsObject {
    return {
      userId: this.userId
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): GetTotalSavedRequest.AsProtobufJSON {
    return {
      userId: this.userId
    };
  }
}
export module GetTotalSavedRequest {
  /**
   * Standard JavaScript object representation for GetTotalSavedRequest
   */
  export interface AsObject {
    userId: number;
  }

  /**
   * Protobuf JSON representation for GetTotalSavedRequest
   */
  export interface AsProtobufJSON {
    userId: number;
  }
}

/**
 * Message implementation for epicore.admin.GetTotalSavedRequestResponse
 */
export class GetTotalSavedRequestResponse implements GrpcMessage {
  static id = 'epicore.admin.GetTotalSavedRequestResponse';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new GetTotalSavedRequestResponse();
    GetTotalSavedRequestResponse.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: GetTotalSavedRequestResponse) {
    _instance.totalSaved = _instance.totalSaved || 0;
    _instance.inverterTotals = _instance.inverterTotals || [];
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: GetTotalSavedRequestResponse,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.totalSaved = _reader.readDouble();
          break;
        case 2:
          const messageInitializer2 = new InverterTotalSaved();
          _reader.readMessage(
            messageInitializer2,
            InverterTotalSaved.deserializeBinaryFromReader
          );
          (_instance.inverterTotals = _instance.inverterTotals || []).push(
            messageInitializer2
          );
          break;
        default:
          _reader.skipField();
      }
    }

    GetTotalSavedRequestResponse.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: GetTotalSavedRequestResponse,
    _writer: BinaryWriter
  ) {
    if (_instance.totalSaved) {
      _writer.writeDouble(1, _instance.totalSaved);
    }
    if (_instance.inverterTotals && _instance.inverterTotals.length) {
      _writer.writeRepeatedMessage(
        2,
        _instance.inverterTotals as any,
        InverterTotalSaved.serializeBinaryToWriter
      );
    }
  }

  private _totalSaved: number;
  private _inverterTotals?: InverterTotalSaved[];

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of GetTotalSavedRequestResponse to deeply clone from
   */
  constructor(
    _value?: RecursivePartial<GetTotalSavedRequestResponse.AsObject>
  ) {
    _value = _value || {};
    this.totalSaved = _value.totalSaved;
    this.inverterTotals = (_value.inverterTotals || []).map(
      m => new InverterTotalSaved(m)
    );
    GetTotalSavedRequestResponse.refineValues(this);
  }
  get totalSaved(): number {
    return this._totalSaved;
  }
  set totalSaved(value: number) {
    this._totalSaved = value;
  }
  get inverterTotals(): InverterTotalSaved[] | undefined {
    return this._inverterTotals;
  }
  set inverterTotals(value: InverterTotalSaved[] | undefined) {
    this._inverterTotals = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    GetTotalSavedRequestResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): GetTotalSavedRequestResponse.AsObject {
    return {
      totalSaved: this.totalSaved,
      inverterTotals: (this.inverterTotals || []).map(m => m.toObject())
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): GetTotalSavedRequestResponse.AsProtobufJSON {
    return {
      totalSaved: this.totalSaved,
      inverterTotals: (this.inverterTotals || []).map(m =>
        m.toProtobufJSON(options)
      )
    };
  }
}
export module GetTotalSavedRequestResponse {
  /**
   * Standard JavaScript object representation for GetTotalSavedRequestResponse
   */
  export interface AsObject {
    totalSaved: number;
    inverterTotals?: InverterTotalSaved.AsObject[];
  }

  /**
   * Protobuf JSON representation for GetTotalSavedRequestResponse
   */
  export interface AsProtobufJSON {
    totalSaved: number;
    inverterTotals: InverterTotalSaved.AsProtobufJSON[] | null;
  }
}

/**
 * Message implementation for epicore.admin.InverterTotalSaved
 */
export class InverterTotalSaved implements GrpcMessage {
  static id = 'epicore.admin.InverterTotalSaved';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new InverterTotalSaved();
    InverterTotalSaved.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: InverterTotalSaved) {
    _instance.userId = _instance.userId || 0;
    _instance.settingId = _instance.settingId || 0;
    _instance.plantId = _instance.plantId || 0;
    _instance.serialNumber = _instance.serialNumber || '';
    _instance.totalSaved = _instance.totalSaved || 0;
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: InverterTotalSaved,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.userId = _reader.readInt32();
          break;
        case 2:
          _instance.settingId = _reader.readInt32();
          break;
        case 3:
          _instance.plantId = _reader.readInt32();
          break;
        case 4:
          _instance.serialNumber = _reader.readString();
          break;
        case 5:
          _instance.totalSaved = _reader.readDouble();
          break;
        default:
          _reader.skipField();
      }
    }

    InverterTotalSaved.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: InverterTotalSaved,
    _writer: BinaryWriter
  ) {
    if (_instance.userId) {
      _writer.writeInt32(1, _instance.userId);
    }
    if (_instance.settingId) {
      _writer.writeInt32(2, _instance.settingId);
    }
    if (_instance.plantId) {
      _writer.writeInt32(3, _instance.plantId);
    }
    if (_instance.serialNumber) {
      _writer.writeString(4, _instance.serialNumber);
    }
    if (_instance.totalSaved) {
      _writer.writeDouble(5, _instance.totalSaved);
    }
  }

  private _userId: number;
  private _settingId: number;
  private _plantId: number;
  private _serialNumber: string;
  private _totalSaved: number;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of InverterTotalSaved to deeply clone from
   */
  constructor(_value?: RecursivePartial<InverterTotalSaved.AsObject>) {
    _value = _value || {};
    this.userId = _value.userId;
    this.settingId = _value.settingId;
    this.plantId = _value.plantId;
    this.serialNumber = _value.serialNumber;
    this.totalSaved = _value.totalSaved;
    InverterTotalSaved.refineValues(this);
  }
  get userId(): number {
    return this._userId;
  }
  set userId(value: number) {
    this._userId = value;
  }
  get settingId(): number {
    return this._settingId;
  }
  set settingId(value: number) {
    this._settingId = value;
  }
  get plantId(): number {
    return this._plantId;
  }
  set plantId(value: number) {
    this._plantId = value;
  }
  get serialNumber(): string {
    return this._serialNumber;
  }
  set serialNumber(value: string) {
    this._serialNumber = value;
  }
  get totalSaved(): number {
    return this._totalSaved;
  }
  set totalSaved(value: number) {
    this._totalSaved = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    InverterTotalSaved.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): InverterTotalSaved.AsObject {
    return {
      userId: this.userId,
      settingId: this.settingId,
      plantId: this.plantId,
      serialNumber: this.serialNumber,
      totalSaved: this.totalSaved
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): InverterTotalSaved.AsProtobufJSON {
    return {
      userId: this.userId,
      settingId: this.settingId,
      plantId: this.plantId,
      serialNumber: this.serialNumber,
      totalSaved: this.totalSaved
    };
  }
}
export module InverterTotalSaved {
  /**
   * Standard JavaScript object representation for InverterTotalSaved
   */
  export interface AsObject {
    userId: number;
    settingId: number;
    plantId: number;
    serialNumber: string;
    totalSaved: number;
  }

  /**
   * Protobuf JSON representation for InverterTotalSaved
   */
  export interface AsProtobufJSON {
    userId: number;
    settingId: number;
    plantId: number;
    serialNumber: string;
    totalSaved: number;
  }
}

/**
 * Message implementation for epicore.admin.GetElPricesByUserIdRequest
 */
export class GetElPricesByUserIdRequest implements GrpcMessage {
  static id = 'epicore.admin.GetElPricesByUserIdRequest';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new GetElPricesByUserIdRequest();
    GetElPricesByUserIdRequest.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: GetElPricesByUserIdRequest) {
    _instance.date = _instance.date || '';
    _instance.priceClass = _instance.priceClass || 0;
    _instance.userId = _instance.userId || 0;
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: GetElPricesByUserIdRequest,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.date = _reader.readString();
          break;
        case 2:
          _instance.priceClass = _reader.readInt32();
          break;
        case 3:
          _instance.userId = _reader.readInt32();
          break;
        default:
          _reader.skipField();
      }
    }

    GetElPricesByUserIdRequest.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: GetElPricesByUserIdRequest,
    _writer: BinaryWriter
  ) {
    if (_instance.date) {
      _writer.writeString(1, _instance.date);
    }
    if (_instance.priceClass) {
      _writer.writeInt32(2, _instance.priceClass);
    }
    if (_instance.userId) {
      _writer.writeInt32(3, _instance.userId);
    }
  }

  private _date: string;
  private _priceClass: number;
  private _userId: number;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of GetElPricesByUserIdRequest to deeply clone from
   */
  constructor(_value?: RecursivePartial<GetElPricesByUserIdRequest.AsObject>) {
    _value = _value || {};
    this.date = _value.date;
    this.priceClass = _value.priceClass;
    this.userId = _value.userId;
    GetElPricesByUserIdRequest.refineValues(this);
  }
  get date(): string {
    return this._date;
  }
  set date(value: string) {
    this._date = value;
  }
  get priceClass(): number {
    return this._priceClass;
  }
  set priceClass(value: number) {
    this._priceClass = value;
  }
  get userId(): number {
    return this._userId;
  }
  set userId(value: number) {
    this._userId = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    GetElPricesByUserIdRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): GetElPricesByUserIdRequest.AsObject {
    return {
      date: this.date,
      priceClass: this.priceClass,
      userId: this.userId
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): GetElPricesByUserIdRequest.AsProtobufJSON {
    return {
      date: this.date,
      priceClass: this.priceClass,
      userId: this.userId
    };
  }
}
export module GetElPricesByUserIdRequest {
  /**
   * Standard JavaScript object representation for GetElPricesByUserIdRequest
   */
  export interface AsObject {
    date: string;
    priceClass: number;
    userId: number;
  }

  /**
   * Protobuf JSON representation for GetElPricesByUserIdRequest
   */
  export interface AsProtobufJSON {
    date: string;
    priceClass: number;
    userId: number;
  }
}

/**
 * Message implementation for epicore.admin.GetElPricesByUserIdResponse
 */
export class GetElPricesByUserIdResponse implements GrpcMessage {
  static id = 'epicore.admin.GetElPricesByUserIdResponse';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new GetElPricesByUserIdResponse();
    GetElPricesByUserIdResponse.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: GetElPricesByUserIdResponse) {
    _instance.eloverblikTarrifPrices =
      _instance.eloverblikTarrifPrices || undefined;
    _instance.spotPriceItems = _instance.spotPriceItems || [];
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: GetElPricesByUserIdResponse,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.eloverblikTarrifPrices = new EloverblikTariffResponse();
          _reader.readMessage(
            _instance.eloverblikTarrifPrices,
            EloverblikTariffResponse.deserializeBinaryFromReader
          );
          break;
        case 2:
          const messageInitializer2 = new SpotPriceItem();
          _reader.readMessage(
            messageInitializer2,
            SpotPriceItem.deserializeBinaryFromReader
          );
          (_instance.spotPriceItems = _instance.spotPriceItems || []).push(
            messageInitializer2
          );
          break;
        default:
          _reader.skipField();
      }
    }

    GetElPricesByUserIdResponse.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: GetElPricesByUserIdResponse,
    _writer: BinaryWriter
  ) {
    if (_instance.eloverblikTarrifPrices) {
      _writer.writeMessage(
        1,
        _instance.eloverblikTarrifPrices as any,
        EloverblikTariffResponse.serializeBinaryToWriter
      );
    }
    if (_instance.spotPriceItems && _instance.spotPriceItems.length) {
      _writer.writeRepeatedMessage(
        2,
        _instance.spotPriceItems as any,
        SpotPriceItem.serializeBinaryToWriter
      );
    }
  }

  private _eloverblikTarrifPrices?: EloverblikTariffResponse;
  private _spotPriceItems?: SpotPriceItem[];

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of GetElPricesByUserIdResponse to deeply clone from
   */
  constructor(_value?: RecursivePartial<GetElPricesByUserIdResponse.AsObject>) {
    _value = _value || {};
    this.eloverblikTarrifPrices = _value.eloverblikTarrifPrices
      ? new EloverblikTariffResponse(_value.eloverblikTarrifPrices)
      : undefined;
    this.spotPriceItems = (_value.spotPriceItems || []).map(
      m => new SpotPriceItem(m)
    );
    GetElPricesByUserIdResponse.refineValues(this);
  }
  get eloverblikTarrifPrices(): EloverblikTariffResponse | undefined {
    return this._eloverblikTarrifPrices;
  }
  set eloverblikTarrifPrices(value: EloverblikTariffResponse | undefined) {
    this._eloverblikTarrifPrices = value;
  }
  get spotPriceItems(): SpotPriceItem[] | undefined {
    return this._spotPriceItems;
  }
  set spotPriceItems(value: SpotPriceItem[] | undefined) {
    this._spotPriceItems = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    GetElPricesByUserIdResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): GetElPricesByUserIdResponse.AsObject {
    return {
      eloverblikTarrifPrices: this.eloverblikTarrifPrices
        ? this.eloverblikTarrifPrices.toObject()
        : undefined,
      spotPriceItems: (this.spotPriceItems || []).map(m => m.toObject())
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): GetElPricesByUserIdResponse.AsProtobufJSON {
    return {
      eloverblikTarrifPrices: this.eloverblikTarrifPrices
        ? this.eloverblikTarrifPrices.toProtobufJSON(options)
        : null,
      spotPriceItems: (this.spotPriceItems || []).map(m =>
        m.toProtobufJSON(options)
      )
    };
  }
}
export module GetElPricesByUserIdResponse {
  /**
   * Standard JavaScript object representation for GetElPricesByUserIdResponse
   */
  export interface AsObject {
    eloverblikTarrifPrices?: EloverblikTariffResponse.AsObject;
    spotPriceItems?: SpotPriceItem.AsObject[];
  }

  /**
   * Protobuf JSON representation for GetElPricesByUserIdResponse
   */
  export interface AsProtobufJSON {
    eloverblikTarrifPrices: EloverblikTariffResponse.AsProtobufJSON | null;
    spotPriceItems: SpotPriceItem.AsProtobufJSON[] | null;
  }
}

/**
 * Message implementation for epicore.admin.EloverblikTariffResponse
 */
export class EloverblikTariffResponse implements GrpcMessage {
  static id = 'epicore.admin.EloverblikTariffResponse';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new EloverblikTariffResponse();
    EloverblikTariffResponse.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: EloverblikTariffResponse) {
    _instance.eloverblikTarrifInverterItems =
      _instance.eloverblikTarrifInverterItems || [];
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: EloverblikTariffResponse,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          const messageInitializer1 = new EloverblikTarrifInverterItem();
          _reader.readMessage(
            messageInitializer1,
            EloverblikTarrifInverterItem.deserializeBinaryFromReader
          );
          (_instance.eloverblikTarrifInverterItems =
            _instance.eloverblikTarrifInverterItems || []).push(
            messageInitializer1
          );
          break;
        default:
          _reader.skipField();
      }
    }

    EloverblikTariffResponse.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: EloverblikTariffResponse,
    _writer: BinaryWriter
  ) {
    if (
      _instance.eloverblikTarrifInverterItems &&
      _instance.eloverblikTarrifInverterItems.length
    ) {
      _writer.writeRepeatedMessage(
        1,
        _instance.eloverblikTarrifInverterItems as any,
        EloverblikTarrifInverterItem.serializeBinaryToWriter
      );
    }
  }

  private _eloverblikTarrifInverterItems?: EloverblikTarrifInverterItem[];

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of EloverblikTariffResponse to deeply clone from
   */
  constructor(_value?: RecursivePartial<EloverblikTariffResponse.AsObject>) {
    _value = _value || {};
    this.eloverblikTarrifInverterItems = (
      _value.eloverblikTarrifInverterItems || []
    ).map(m => new EloverblikTarrifInverterItem(m));
    EloverblikTariffResponse.refineValues(this);
  }
  get eloverblikTarrifInverterItems():
    | EloverblikTarrifInverterItem[]
    | undefined {
    return this._eloverblikTarrifInverterItems;
  }
  set eloverblikTarrifInverterItems(
    value: EloverblikTarrifInverterItem[] | undefined
  ) {
    this._eloverblikTarrifInverterItems = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    EloverblikTariffResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): EloverblikTariffResponse.AsObject {
    return {
      eloverblikTarrifInverterItems: (
        this.eloverblikTarrifInverterItems || []
      ).map(m => m.toObject())
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): EloverblikTariffResponse.AsProtobufJSON {
    return {
      eloverblikTarrifInverterItems: (
        this.eloverblikTarrifInverterItems || []
      ).map(m => m.toProtobufJSON(options))
    };
  }
}
export module EloverblikTariffResponse {
  /**
   * Standard JavaScript object representation for EloverblikTariffResponse
   */
  export interface AsObject {
    eloverblikTarrifInverterItems?: EloverblikTarrifInverterItem.AsObject[];
  }

  /**
   * Protobuf JSON representation for EloverblikTariffResponse
   */
  export interface AsProtobufJSON {
    eloverblikTarrifInverterItems:
      | EloverblikTarrifInverterItem.AsProtobufJSON[]
      | null;
  }
}

/**
 * Message implementation for epicore.admin.EloverblikTarrifInverterItem
 */
export class EloverblikTarrifInverterItem implements GrpcMessage {
  static id = 'epicore.admin.EloverblikTarrifInverterItem';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new EloverblikTarrifInverterItem();
    EloverblikTarrifInverterItem.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: EloverblikTarrifInverterItem) {
    _instance.serialNumber = _instance.serialNumber || '';
    _instance.meteringPointIds = _instance.meteringPointIds || [];
    _instance.eloverblikTariffItems = _instance.eloverblikTariffItems || [];
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: EloverblikTarrifInverterItem,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.serialNumber = _reader.readString();
          break;
        case 2:
          (_instance.meteringPointIds = _instance.meteringPointIds || []).push(
            _reader.readString()
          );
          break;
        case 3:
          const messageInitializer3 = new EloverblikTariffItem();
          _reader.readMessage(
            messageInitializer3,
            EloverblikTariffItem.deserializeBinaryFromReader
          );
          (_instance.eloverblikTariffItems =
            _instance.eloverblikTariffItems || []).push(messageInitializer3);
          break;
        default:
          _reader.skipField();
      }
    }

    EloverblikTarrifInverterItem.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: EloverblikTarrifInverterItem,
    _writer: BinaryWriter
  ) {
    if (_instance.serialNumber) {
      _writer.writeString(1, _instance.serialNumber);
    }
    if (_instance.meteringPointIds && _instance.meteringPointIds.length) {
      _writer.writeRepeatedString(2, _instance.meteringPointIds);
    }
    if (
      _instance.eloverblikTariffItems &&
      _instance.eloverblikTariffItems.length
    ) {
      _writer.writeRepeatedMessage(
        3,
        _instance.eloverblikTariffItems as any,
        EloverblikTariffItem.serializeBinaryToWriter
      );
    }
  }

  private _serialNumber: string;
  private _meteringPointIds: string[];
  private _eloverblikTariffItems?: EloverblikTariffItem[];

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of EloverblikTarrifInverterItem to deeply clone from
   */
  constructor(
    _value?: RecursivePartial<EloverblikTarrifInverterItem.AsObject>
  ) {
    _value = _value || {};
    this.serialNumber = _value.serialNumber;
    this.meteringPointIds = (_value.meteringPointIds || []).slice();
    this.eloverblikTariffItems = (_value.eloverblikTariffItems || []).map(
      m => new EloverblikTariffItem(m)
    );
    EloverblikTarrifInverterItem.refineValues(this);
  }
  get serialNumber(): string {
    return this._serialNumber;
  }
  set serialNumber(value: string) {
    this._serialNumber = value;
  }
  get meteringPointIds(): string[] {
    return this._meteringPointIds;
  }
  set meteringPointIds(value: string[]) {
    this._meteringPointIds = value;
  }
  get eloverblikTariffItems(): EloverblikTariffItem[] | undefined {
    return this._eloverblikTariffItems;
  }
  set eloverblikTariffItems(value: EloverblikTariffItem[] | undefined) {
    this._eloverblikTariffItems = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    EloverblikTarrifInverterItem.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): EloverblikTarrifInverterItem.AsObject {
    return {
      serialNumber: this.serialNumber,
      meteringPointIds: (this.meteringPointIds || []).slice(),
      eloverblikTariffItems: (this.eloverblikTariffItems || []).map(m =>
        m.toObject()
      )
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): EloverblikTarrifInverterItem.AsProtobufJSON {
    return {
      serialNumber: this.serialNumber,
      meteringPointIds: (this.meteringPointIds || []).slice(),
      eloverblikTariffItems: (this.eloverblikTariffItems || []).map(m =>
        m.toProtobufJSON(options)
      )
    };
  }
}
export module EloverblikTarrifInverterItem {
  /**
   * Standard JavaScript object representation for EloverblikTarrifInverterItem
   */
  export interface AsObject {
    serialNumber: string;
    meteringPointIds: string[];
    eloverblikTariffItems?: EloverblikTariffItem.AsObject[];
  }

  /**
   * Protobuf JSON representation for EloverblikTarrifInverterItem
   */
  export interface AsProtobufJSON {
    serialNumber: string;
    meteringPointIds: string[];
    eloverblikTariffItems: EloverblikTariffItem.AsProtobufJSON[] | null;
  }
}

/**
 * Message implementation for epicore.admin.EloverblikTariffItem
 */
export class EloverblikTariffItem implements GrpcMessage {
  static id = 'epicore.admin.EloverblikTariffItem';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new EloverblikTariffItem();
    EloverblikTariffItem.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: EloverblikTariffItem) {
    _instance.title = _instance.title || '';
    _instance.tariff = _instance.tariff || [];
    _instance.meteringPointId = _instance.meteringPointId || '';
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: EloverblikTariffItem,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.title = _reader.readString();
          break;
        case 2:
          (_instance.tariff = _instance.tariff || []).push(
            ...(_reader.readPackedDouble() || [])
          );
          break;
        case 3:
          _instance.meteringPointId = _reader.readString();
          break;
        default:
          _reader.skipField();
      }
    }

    EloverblikTariffItem.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: EloverblikTariffItem,
    _writer: BinaryWriter
  ) {
    if (_instance.title) {
      _writer.writeString(1, _instance.title);
    }
    if (_instance.tariff && _instance.tariff.length) {
      _writer.writePackedDouble(2, _instance.tariff);
    }
    if (_instance.meteringPointId) {
      _writer.writeString(3, _instance.meteringPointId);
    }
  }

  private _title: string;
  private _tariff: number[];
  private _meteringPointId: string;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of EloverblikTariffItem to deeply clone from
   */
  constructor(_value?: RecursivePartial<EloverblikTariffItem.AsObject>) {
    _value = _value || {};
    this.title = _value.title;
    this.tariff = (_value.tariff || []).slice();
    this.meteringPointId = _value.meteringPointId;
    EloverblikTariffItem.refineValues(this);
  }
  get title(): string {
    return this._title;
  }
  set title(value: string) {
    this._title = value;
  }
  get tariff(): number[] {
    return this._tariff;
  }
  set tariff(value: number[]) {
    this._tariff = value;
  }
  get meteringPointId(): string {
    return this._meteringPointId;
  }
  set meteringPointId(value: string) {
    this._meteringPointId = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    EloverblikTariffItem.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): EloverblikTariffItem.AsObject {
    return {
      title: this.title,
      tariff: (this.tariff || []).slice(),
      meteringPointId: this.meteringPointId
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): EloverblikTariffItem.AsProtobufJSON {
    return {
      title: this.title,
      tariff: (this.tariff || []).slice(),
      meteringPointId: this.meteringPointId
    };
  }
}
export module EloverblikTariffItem {
  /**
   * Standard JavaScript object representation for EloverblikTariffItem
   */
  export interface AsObject {
    title: string;
    tariff: number[];
    meteringPointId: string;
  }

  /**
   * Protobuf JSON representation for EloverblikTariffItem
   */
  export interface AsProtobufJSON {
    title: string;
    tariff: number[];
    meteringPointId: string;
  }
}

/**
 * Message implementation for epicore.admin.SpotPriceItem
 */
export class SpotPriceItem implements GrpcMessage {
  static id = 'epicore.admin.SpotPriceItem';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new SpotPriceItem();
    SpotPriceItem.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: SpotPriceItem) {
    _instance.id = _instance.id || 0;
    _instance.date = _instance.date || '';
    _instance.dkkPerKwh = _instance.dkkPerKwh || '';
    _instance.eurPerKwh = _instance.eurPerKwh || '';
    _instance.exr = _instance.exr || '';
    _instance.priceClass = _instance.priceClass || 0;
    _instance.hour = _instance.hour || 0;
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: SpotPriceItem,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.id = _reader.readInt32();
          break;
        case 2:
          _instance.date = _reader.readString();
          break;
        case 3:
          _instance.dkkPerKwh = _reader.readString();
          break;
        case 4:
          _instance.eurPerKwh = _reader.readString();
          break;
        case 5:
          _instance.exr = _reader.readString();
          break;
        case 6:
          _instance.priceClass = _reader.readInt32();
          break;
        case 7:
          _instance.hour = _reader.readInt32();
          break;
        default:
          _reader.skipField();
      }
    }

    SpotPriceItem.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: SpotPriceItem,
    _writer: BinaryWriter
  ) {
    if (_instance.id) {
      _writer.writeInt32(1, _instance.id);
    }
    if (_instance.date) {
      _writer.writeString(2, _instance.date);
    }
    if (_instance.dkkPerKwh) {
      _writer.writeString(3, _instance.dkkPerKwh);
    }
    if (_instance.eurPerKwh) {
      _writer.writeString(4, _instance.eurPerKwh);
    }
    if (_instance.exr) {
      _writer.writeString(5, _instance.exr);
    }
    if (_instance.priceClass) {
      _writer.writeInt32(6, _instance.priceClass);
    }
    if (_instance.hour) {
      _writer.writeInt32(7, _instance.hour);
    }
  }

  private _id: number;
  private _date: string;
  private _dkkPerKwh: string;
  private _eurPerKwh: string;
  private _exr: string;
  private _priceClass: number;
  private _hour: number;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of SpotPriceItem to deeply clone from
   */
  constructor(_value?: RecursivePartial<SpotPriceItem.AsObject>) {
    _value = _value || {};
    this.id = _value.id;
    this.date = _value.date;
    this.dkkPerKwh = _value.dkkPerKwh;
    this.eurPerKwh = _value.eurPerKwh;
    this.exr = _value.exr;
    this.priceClass = _value.priceClass;
    this.hour = _value.hour;
    SpotPriceItem.refineValues(this);
  }
  get id(): number {
    return this._id;
  }
  set id(value: number) {
    this._id = value;
  }
  get date(): string {
    return this._date;
  }
  set date(value: string) {
    this._date = value;
  }
  get dkkPerKwh(): string {
    return this._dkkPerKwh;
  }
  set dkkPerKwh(value: string) {
    this._dkkPerKwh = value;
  }
  get eurPerKwh(): string {
    return this._eurPerKwh;
  }
  set eurPerKwh(value: string) {
    this._eurPerKwh = value;
  }
  get exr(): string {
    return this._exr;
  }
  set exr(value: string) {
    this._exr = value;
  }
  get priceClass(): number {
    return this._priceClass;
  }
  set priceClass(value: number) {
    this._priceClass = value;
  }
  get hour(): number {
    return this._hour;
  }
  set hour(value: number) {
    this._hour = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    SpotPriceItem.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): SpotPriceItem.AsObject {
    return {
      id: this.id,
      date: this.date,
      dkkPerKwh: this.dkkPerKwh,
      eurPerKwh: this.eurPerKwh,
      exr: this.exr,
      priceClass: this.priceClass,
      hour: this.hour
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): SpotPriceItem.AsProtobufJSON {
    return {
      id: this.id,
      date: this.date,
      dkkPerKwh: this.dkkPerKwh,
      eurPerKwh: this.eurPerKwh,
      exr: this.exr,
      priceClass: this.priceClass,
      hour: this.hour
    };
  }
}
export module SpotPriceItem {
  /**
   * Standard JavaScript object representation for SpotPriceItem
   */
  export interface AsObject {
    id: number;
    date: string;
    dkkPerKwh: string;
    eurPerKwh: string;
    exr: string;
    priceClass: number;
    hour: number;
  }

  /**
   * Protobuf JSON representation for SpotPriceItem
   */
  export interface AsProtobufJSON {
    id: number;
    date: string;
    dkkPerKwh: string;
    eurPerKwh: string;
    exr: string;
    priceClass: number;
    hour: number;
  }
}

/**
 * Message implementation for epicore.admin.GetMainDashboardDataResponse
 */
export class GetMainDashboardDataResponse implements GrpcMessage {
  static id = 'epicore.admin.GetMainDashboardDataResponse';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new GetMainDashboardDataResponse();
    GetMainDashboardDataResponse.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: GetMainDashboardDataResponse) {
    _instance.plants = _instance.plants || [];
    _instance.totalSharingModelData =
      _instance.totalSharingModelData || undefined;
    _instance.totalGreenData = _instance.totalGreenData || undefined;
    _instance.todaySharingModelData =
      _instance.todaySharingModelData || undefined;
    _instance.todayGreenData = _instance.todayGreenData || undefined;
    _instance.inverterStatuses = _instance.inverterStatuses || undefined;
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: GetMainDashboardDataResponse,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          const messageInitializer1 = new Plant();
          _reader.readMessage(
            messageInitializer1,
            Plant.deserializeBinaryFromReader
          );
          (_instance.plants = _instance.plants || []).push(messageInitializer1);
          break;
        case 2:
          _instance.totalSharingModelData = new AggregateSharingModelData();
          _reader.readMessage(
            _instance.totalSharingModelData,
            AggregateSharingModelData.deserializeBinaryFromReader
          );
          break;
        case 3:
          _instance.totalGreenData = new AggregateGreenData();
          _reader.readMessage(
            _instance.totalGreenData,
            AggregateGreenData.deserializeBinaryFromReader
          );
          break;
        case 4:
          _instance.todaySharingModelData = new AggregateSharingModelData();
          _reader.readMessage(
            _instance.todaySharingModelData,
            AggregateSharingModelData.deserializeBinaryFromReader
          );
          break;
        case 5:
          _instance.todayGreenData = new AggregateGreenData();
          _reader.readMessage(
            _instance.todayGreenData,
            AggregateGreenData.deserializeBinaryFromReader
          );
          break;
        case 6:
          _instance.inverterStatuses = new InverterStatuses();
          _reader.readMessage(
            _instance.inverterStatuses,
            InverterStatuses.deserializeBinaryFromReader
          );
          break;
        default:
          _reader.skipField();
      }
    }

    GetMainDashboardDataResponse.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: GetMainDashboardDataResponse,
    _writer: BinaryWriter
  ) {
    if (_instance.plants && _instance.plants.length) {
      _writer.writeRepeatedMessage(
        1,
        _instance.plants as any,
        Plant.serializeBinaryToWriter
      );
    }
    if (_instance.totalSharingModelData) {
      _writer.writeMessage(
        2,
        _instance.totalSharingModelData as any,
        AggregateSharingModelData.serializeBinaryToWriter
      );
    }
    if (_instance.totalGreenData) {
      _writer.writeMessage(
        3,
        _instance.totalGreenData as any,
        AggregateGreenData.serializeBinaryToWriter
      );
    }
    if (_instance.todaySharingModelData) {
      _writer.writeMessage(
        4,
        _instance.todaySharingModelData as any,
        AggregateSharingModelData.serializeBinaryToWriter
      );
    }
    if (_instance.todayGreenData) {
      _writer.writeMessage(
        5,
        _instance.todayGreenData as any,
        AggregateGreenData.serializeBinaryToWriter
      );
    }
    if (_instance.inverterStatuses) {
      _writer.writeMessage(
        6,
        _instance.inverterStatuses as any,
        InverterStatuses.serializeBinaryToWriter
      );
    }
  }

  private _plants?: Plant[];
  private _totalSharingModelData?: AggregateSharingModelData;
  private _totalGreenData?: AggregateGreenData;
  private _todaySharingModelData?: AggregateSharingModelData;
  private _todayGreenData?: AggregateGreenData;
  private _inverterStatuses?: InverterStatuses;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of GetMainDashboardDataResponse to deeply clone from
   */
  constructor(
    _value?: RecursivePartial<GetMainDashboardDataResponse.AsObject>
  ) {
    _value = _value || {};
    this.plants = (_value.plants || []).map(m => new Plant(m));
    this.totalSharingModelData = _value.totalSharingModelData
      ? new AggregateSharingModelData(_value.totalSharingModelData)
      : undefined;
    this.totalGreenData = _value.totalGreenData
      ? new AggregateGreenData(_value.totalGreenData)
      : undefined;
    this.todaySharingModelData = _value.todaySharingModelData
      ? new AggregateSharingModelData(_value.todaySharingModelData)
      : undefined;
    this.todayGreenData = _value.todayGreenData
      ? new AggregateGreenData(_value.todayGreenData)
      : undefined;
    this.inverterStatuses = _value.inverterStatuses
      ? new InverterStatuses(_value.inverterStatuses)
      : undefined;
    GetMainDashboardDataResponse.refineValues(this);
  }
  get plants(): Plant[] | undefined {
    return this._plants;
  }
  set plants(value: Plant[] | undefined) {
    this._plants = value;
  }
  get totalSharingModelData(): AggregateSharingModelData | undefined {
    return this._totalSharingModelData;
  }
  set totalSharingModelData(value: AggregateSharingModelData | undefined) {
    this._totalSharingModelData = value;
  }
  get totalGreenData(): AggregateGreenData | undefined {
    return this._totalGreenData;
  }
  set totalGreenData(value: AggregateGreenData | undefined) {
    this._totalGreenData = value;
  }
  get todaySharingModelData(): AggregateSharingModelData | undefined {
    return this._todaySharingModelData;
  }
  set todaySharingModelData(value: AggregateSharingModelData | undefined) {
    this._todaySharingModelData = value;
  }
  get todayGreenData(): AggregateGreenData | undefined {
    return this._todayGreenData;
  }
  set todayGreenData(value: AggregateGreenData | undefined) {
    this._todayGreenData = value;
  }
  get inverterStatuses(): InverterStatuses | undefined {
    return this._inverterStatuses;
  }
  set inverterStatuses(value: InverterStatuses | undefined) {
    this._inverterStatuses = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    GetMainDashboardDataResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): GetMainDashboardDataResponse.AsObject {
    return {
      plants: (this.plants || []).map(m => m.toObject()),
      totalSharingModelData: this.totalSharingModelData
        ? this.totalSharingModelData.toObject()
        : undefined,
      totalGreenData: this.totalGreenData
        ? this.totalGreenData.toObject()
        : undefined,
      todaySharingModelData: this.todaySharingModelData
        ? this.todaySharingModelData.toObject()
        : undefined,
      todayGreenData: this.todayGreenData
        ? this.todayGreenData.toObject()
        : undefined,
      inverterStatuses: this.inverterStatuses
        ? this.inverterStatuses.toObject()
        : undefined
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): GetMainDashboardDataResponse.AsProtobufJSON {
    return {
      plants: (this.plants || []).map(m => m.toProtobufJSON(options)),
      totalSharingModelData: this.totalSharingModelData
        ? this.totalSharingModelData.toProtobufJSON(options)
        : null,
      totalGreenData: this.totalGreenData
        ? this.totalGreenData.toProtobufJSON(options)
        : null,
      todaySharingModelData: this.todaySharingModelData
        ? this.todaySharingModelData.toProtobufJSON(options)
        : null,
      todayGreenData: this.todayGreenData
        ? this.todayGreenData.toProtobufJSON(options)
        : null,
      inverterStatuses: this.inverterStatuses
        ? this.inverterStatuses.toProtobufJSON(options)
        : null
    };
  }
}
export module GetMainDashboardDataResponse {
  /**
   * Standard JavaScript object representation for GetMainDashboardDataResponse
   */
  export interface AsObject {
    plants?: Plant.AsObject[];
    totalSharingModelData?: AggregateSharingModelData.AsObject;
    totalGreenData?: AggregateGreenData.AsObject;
    todaySharingModelData?: AggregateSharingModelData.AsObject;
    todayGreenData?: AggregateGreenData.AsObject;
    inverterStatuses?: InverterStatuses.AsObject;
  }

  /**
   * Protobuf JSON representation for GetMainDashboardDataResponse
   */
  export interface AsProtobufJSON {
    plants: Plant.AsProtobufJSON[] | null;
    totalSharingModelData: AggregateSharingModelData.AsProtobufJSON | null;
    totalGreenData: AggregateGreenData.AsProtobufJSON | null;
    todaySharingModelData: AggregateSharingModelData.AsProtobufJSON | null;
    todayGreenData: AggregateGreenData.AsProtobufJSON | null;
    inverterStatuses: InverterStatuses.AsProtobufJSON | null;
  }
}

/**
 * Message implementation for epicore.admin.InverterStatuses
 */
export class InverterStatuses implements GrpcMessage {
  static id = 'epicore.admin.InverterStatuses';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new InverterStatuses();
    InverterStatuses.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: InverterStatuses) {
    _instance.onlineCount = _instance.onlineCount || 0;
    _instance.offlineCount = _instance.offlineCount || 0;
    _instance.disableCount = _instance.disableCount || 0;
    _instance.enabledCount = _instance.enabledCount || 0;
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: InverterStatuses,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.onlineCount = _reader.readInt32();
          break;
        case 2:
          _instance.offlineCount = _reader.readInt32();
          break;
        case 3:
          _instance.disableCount = _reader.readInt32();
          break;
        case 4:
          _instance.enabledCount = _reader.readInt32();
          break;
        default:
          _reader.skipField();
      }
    }

    InverterStatuses.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: InverterStatuses,
    _writer: BinaryWriter
  ) {
    if (_instance.onlineCount) {
      _writer.writeInt32(1, _instance.onlineCount);
    }
    if (_instance.offlineCount) {
      _writer.writeInt32(2, _instance.offlineCount);
    }
    if (_instance.disableCount) {
      _writer.writeInt32(3, _instance.disableCount);
    }
    if (_instance.enabledCount) {
      _writer.writeInt32(4, _instance.enabledCount);
    }
  }

  private _onlineCount: number;
  private _offlineCount: number;
  private _disableCount: number;
  private _enabledCount: number;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of InverterStatuses to deeply clone from
   */
  constructor(_value?: RecursivePartial<InverterStatuses.AsObject>) {
    _value = _value || {};
    this.onlineCount = _value.onlineCount;
    this.offlineCount = _value.offlineCount;
    this.disableCount = _value.disableCount;
    this.enabledCount = _value.enabledCount;
    InverterStatuses.refineValues(this);
  }
  get onlineCount(): number {
    return this._onlineCount;
  }
  set onlineCount(value: number) {
    this._onlineCount = value;
  }
  get offlineCount(): number {
    return this._offlineCount;
  }
  set offlineCount(value: number) {
    this._offlineCount = value;
  }
  get disableCount(): number {
    return this._disableCount;
  }
  set disableCount(value: number) {
    this._disableCount = value;
  }
  get enabledCount(): number {
    return this._enabledCount;
  }
  set enabledCount(value: number) {
    this._enabledCount = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    InverterStatuses.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): InverterStatuses.AsObject {
    return {
      onlineCount: this.onlineCount,
      offlineCount: this.offlineCount,
      disableCount: this.disableCount,
      enabledCount: this.enabledCount
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): InverterStatuses.AsProtobufJSON {
    return {
      onlineCount: this.onlineCount,
      offlineCount: this.offlineCount,
      disableCount: this.disableCount,
      enabledCount: this.enabledCount
    };
  }
}
export module InverterStatuses {
  /**
   * Standard JavaScript object representation for InverterStatuses
   */
  export interface AsObject {
    onlineCount: number;
    offlineCount: number;
    disableCount: number;
    enabledCount: number;
  }

  /**
   * Protobuf JSON representation for InverterStatuses
   */
  export interface AsProtobufJSON {
    onlineCount: number;
    offlineCount: number;
    disableCount: number;
    enabledCount: number;
  }
}

/**
 * Message implementation for epicore.admin.Plant
 */
export class Plant implements GrpcMessage {
  static id = 'epicore.admin.Plant';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new Plant();
    Plant.deserializeBinaryFromReader(instance, new BinaryReader(bytes));
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: Plant) {
    _instance.plantId = _instance.plantId || 0;
    _instance.userId = _instance.userId || 0;
    _instance.address = _instance.address || '';
    _instance.latitude = _instance.latitude || 0;
    _instance.longitude = _instance.longitude || 0;
    _instance.installationDate = _instance.installationDate || '';
    _instance.inverters = _instance.inverters || [];
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(_instance: Plant, _reader: BinaryReader) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.plantId = _reader.readInt32();
          break;
        case 2:
          _instance.userId = _reader.readInt32();
          break;
        case 3:
          _instance.address = _reader.readString();
          break;
        case 4:
          _instance.latitude = _reader.readDouble();
          break;
        case 5:
          _instance.longitude = _reader.readDouble();
          break;
        case 6:
          _instance.installationDate = _reader.readString();
          break;
        case 7:
          const messageInitializer7 = new Inverter();
          _reader.readMessage(
            messageInitializer7,
            Inverter.deserializeBinaryFromReader
          );
          (_instance.inverters = _instance.inverters || []).push(
            messageInitializer7
          );
          break;
        default:
          _reader.skipField();
      }
    }

    Plant.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(_instance: Plant, _writer: BinaryWriter) {
    if (_instance.plantId) {
      _writer.writeInt32(1, _instance.plantId);
    }
    if (_instance.userId) {
      _writer.writeInt32(2, _instance.userId);
    }
    if (_instance.address) {
      _writer.writeString(3, _instance.address);
    }
    if (_instance.latitude) {
      _writer.writeDouble(4, _instance.latitude);
    }
    if (_instance.longitude) {
      _writer.writeDouble(5, _instance.longitude);
    }
    if (_instance.installationDate) {
      _writer.writeString(6, _instance.installationDate);
    }
    if (_instance.inverters && _instance.inverters.length) {
      _writer.writeRepeatedMessage(
        7,
        _instance.inverters as any,
        Inverter.serializeBinaryToWriter
      );
    }
  }

  private _plantId: number;
  private _userId: number;
  private _address: string;
  private _latitude: number;
  private _longitude: number;
  private _installationDate: string;
  private _inverters?: Inverter[];

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of Plant to deeply clone from
   */
  constructor(_value?: RecursivePartial<Plant.AsObject>) {
    _value = _value || {};
    this.plantId = _value.plantId;
    this.userId = _value.userId;
    this.address = _value.address;
    this.latitude = _value.latitude;
    this.longitude = _value.longitude;
    this.installationDate = _value.installationDate;
    this.inverters = (_value.inverters || []).map(m => new Inverter(m));
    Plant.refineValues(this);
  }
  get plantId(): number {
    return this._plantId;
  }
  set plantId(value: number) {
    this._plantId = value;
  }
  get userId(): number {
    return this._userId;
  }
  set userId(value: number) {
    this._userId = value;
  }
  get address(): string {
    return this._address;
  }
  set address(value: string) {
    this._address = value;
  }
  get latitude(): number {
    return this._latitude;
  }
  set latitude(value: number) {
    this._latitude = value;
  }
  get longitude(): number {
    return this._longitude;
  }
  set longitude(value: number) {
    this._longitude = value;
  }
  get installationDate(): string {
    return this._installationDate;
  }
  set installationDate(value: string) {
    this._installationDate = value;
  }
  get inverters(): Inverter[] | undefined {
    return this._inverters;
  }
  set inverters(value: Inverter[] | undefined) {
    this._inverters = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    Plant.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): Plant.AsObject {
    return {
      plantId: this.plantId,
      userId: this.userId,
      address: this.address,
      latitude: this.latitude,
      longitude: this.longitude,
      installationDate: this.installationDate,
      inverters: (this.inverters || []).map(m => m.toObject())
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): Plant.AsProtobufJSON {
    return {
      plantId: this.plantId,
      userId: this.userId,
      address: this.address,
      latitude: this.latitude,
      longitude: this.longitude,
      installationDate: this.installationDate,
      inverters: (this.inverters || []).map(m => m.toProtobufJSON(options))
    };
  }
}
export module Plant {
  /**
   * Standard JavaScript object representation for Plant
   */
  export interface AsObject {
    plantId: number;
    userId: number;
    address: string;
    latitude: number;
    longitude: number;
    installationDate: string;
    inverters?: Inverter.AsObject[];
  }

  /**
   * Protobuf JSON representation for Plant
   */
  export interface AsProtobufJSON {
    plantId: number;
    userId: number;
    address: string;
    latitude: number;
    longitude: number;
    installationDate: string;
    inverters: Inverter.AsProtobufJSON[] | null;
  }
}

/**
 * Message implementation for epicore.admin.Inverter
 */
export class Inverter implements GrpcMessage {
  static id = 'epicore.admin.Inverter';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new Inverter();
    Inverter.deserializeBinaryFromReader(instance, new BinaryReader(bytes));
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: Inverter) {
    _instance.serialNumber = _instance.serialNumber || '';
    _instance.isOnline = _instance.isOnline || false;
    _instance.isDisabled = _instance.isDisabled || false;
    _instance.workingStatus = _instance.workingStatus || '';
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: Inverter,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.serialNumber = _reader.readString();
          break;
        case 2:
          _instance.isOnline = _reader.readBool();
          break;
        case 3:
          _instance.isDisabled = _reader.readBool();
          break;
        case 4:
          _instance.workingStatus = _reader.readString();
          break;
        default:
          _reader.skipField();
      }
    }

    Inverter.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(_instance: Inverter, _writer: BinaryWriter) {
    if (_instance.serialNumber) {
      _writer.writeString(1, _instance.serialNumber);
    }
    if (_instance.isOnline) {
      _writer.writeBool(2, _instance.isOnline);
    }
    if (_instance.isDisabled) {
      _writer.writeBool(3, _instance.isDisabled);
    }
    if (_instance.workingStatus) {
      _writer.writeString(4, _instance.workingStatus);
    }
  }

  private _serialNumber: string;
  private _isOnline: boolean;
  private _isDisabled: boolean;
  private _workingStatus: string;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of Inverter to deeply clone from
   */
  constructor(_value?: RecursivePartial<Inverter.AsObject>) {
    _value = _value || {};
    this.serialNumber = _value.serialNumber;
    this.isOnline = _value.isOnline;
    this.isDisabled = _value.isDisabled;
    this.workingStatus = _value.workingStatus;
    Inverter.refineValues(this);
  }
  get serialNumber(): string {
    return this._serialNumber;
  }
  set serialNumber(value: string) {
    this._serialNumber = value;
  }
  get isOnline(): boolean {
    return this._isOnline;
  }
  set isOnline(value: boolean) {
    this._isOnline = value;
  }
  get isDisabled(): boolean {
    return this._isDisabled;
  }
  set isDisabled(value: boolean) {
    this._isDisabled = value;
  }
  get workingStatus(): string {
    return this._workingStatus;
  }
  set workingStatus(value: string) {
    this._workingStatus = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    Inverter.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): Inverter.AsObject {
    return {
      serialNumber: this.serialNumber,
      isOnline: this.isOnline,
      isDisabled: this.isDisabled,
      workingStatus: this.workingStatus
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): Inverter.AsProtobufJSON {
    return {
      serialNumber: this.serialNumber,
      isOnline: this.isOnline,
      isDisabled: this.isDisabled,
      workingStatus: this.workingStatus
    };
  }
}
export module Inverter {
  /**
   * Standard JavaScript object representation for Inverter
   */
  export interface AsObject {
    serialNumber: string;
    isOnline: boolean;
    isDisabled: boolean;
    workingStatus: string;
  }

  /**
   * Protobuf JSON representation for Inverter
   */
  export interface AsProtobufJSON {
    serialNumber: string;
    isOnline: boolean;
    isDisabled: boolean;
    workingStatus: string;
  }
}

/**
 * Message implementation for epicore.admin.AggregateSharingModelData
 */
export class AggregateSharingModelData implements GrpcMessage {
  static id = 'epicore.admin.AggregateSharingModelData';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new AggregateSharingModelData();
    AggregateSharingModelData.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: AggregateSharingModelData) {
    _instance.totalProfit = _instance.totalProfit || 0;
    _instance.totalSolarProductionKwh = _instance.totalSolarProductionKwh || 0;
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: AggregateSharingModelData,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.totalProfit = _reader.readDouble();
          break;
        case 2:
          _instance.totalSolarProductionKwh = _reader.readDouble();
          break;
        default:
          _reader.skipField();
      }
    }

    AggregateSharingModelData.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: AggregateSharingModelData,
    _writer: BinaryWriter
  ) {
    if (_instance.totalProfit) {
      _writer.writeDouble(1, _instance.totalProfit);
    }
    if (_instance.totalSolarProductionKwh) {
      _writer.writeDouble(2, _instance.totalSolarProductionKwh);
    }
  }

  private _totalProfit: number;
  private _totalSolarProductionKwh: number;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of AggregateSharingModelData to deeply clone from
   */
  constructor(_value?: RecursivePartial<AggregateSharingModelData.AsObject>) {
    _value = _value || {};
    this.totalProfit = _value.totalProfit;
    this.totalSolarProductionKwh = _value.totalSolarProductionKwh;
    AggregateSharingModelData.refineValues(this);
  }
  get totalProfit(): number {
    return this._totalProfit;
  }
  set totalProfit(value: number) {
    this._totalProfit = value;
  }
  get totalSolarProductionKwh(): number {
    return this._totalSolarProductionKwh;
  }
  set totalSolarProductionKwh(value: number) {
    this._totalSolarProductionKwh = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    AggregateSharingModelData.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): AggregateSharingModelData.AsObject {
    return {
      totalProfit: this.totalProfit,
      totalSolarProductionKwh: this.totalSolarProductionKwh
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): AggregateSharingModelData.AsProtobufJSON {
    return {
      totalProfit: this.totalProfit,
      totalSolarProductionKwh: this.totalSolarProductionKwh
    };
  }
}
export module AggregateSharingModelData {
  /**
   * Standard JavaScript object representation for AggregateSharingModelData
   */
  export interface AsObject {
    totalProfit: number;
    totalSolarProductionKwh: number;
  }

  /**
   * Protobuf JSON representation for AggregateSharingModelData
   */
  export interface AsProtobufJSON {
    totalProfit: number;
    totalSolarProductionKwh: number;
  }
}

/**
 * Message implementation for epicore.admin.AggregateGreenData
 */
export class AggregateGreenData implements GrpcMessage {
  static id = 'epicore.admin.AggregateGreenData';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new AggregateGreenData();
    AggregateGreenData.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: AggregateGreenData) {
    _instance.totalEmissionReduction = _instance.totalEmissionReduction || 0;
    _instance.totalReducedDeforestation =
      _instance.totalReducedDeforestation || 0;
    _instance.totalCoalSaved = _instance.totalCoalSaved || 0;
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: AggregateGreenData,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.totalEmissionReduction = _reader.readDouble();
          break;
        case 2:
          _instance.totalReducedDeforestation = _reader.readDouble();
          break;
        case 3:
          _instance.totalCoalSaved = _reader.readDouble();
          break;
        default:
          _reader.skipField();
      }
    }

    AggregateGreenData.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: AggregateGreenData,
    _writer: BinaryWriter
  ) {
    if (_instance.totalEmissionReduction) {
      _writer.writeDouble(1, _instance.totalEmissionReduction);
    }
    if (_instance.totalReducedDeforestation) {
      _writer.writeDouble(2, _instance.totalReducedDeforestation);
    }
    if (_instance.totalCoalSaved) {
      _writer.writeDouble(3, _instance.totalCoalSaved);
    }
  }

  private _totalEmissionReduction: number;
  private _totalReducedDeforestation: number;
  private _totalCoalSaved: number;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of AggregateGreenData to deeply clone from
   */
  constructor(_value?: RecursivePartial<AggregateGreenData.AsObject>) {
    _value = _value || {};
    this.totalEmissionReduction = _value.totalEmissionReduction;
    this.totalReducedDeforestation = _value.totalReducedDeforestation;
    this.totalCoalSaved = _value.totalCoalSaved;
    AggregateGreenData.refineValues(this);
  }
  get totalEmissionReduction(): number {
    return this._totalEmissionReduction;
  }
  set totalEmissionReduction(value: number) {
    this._totalEmissionReduction = value;
  }
  get totalReducedDeforestation(): number {
    return this._totalReducedDeforestation;
  }
  set totalReducedDeforestation(value: number) {
    this._totalReducedDeforestation = value;
  }
  get totalCoalSaved(): number {
    return this._totalCoalSaved;
  }
  set totalCoalSaved(value: number) {
    this._totalCoalSaved = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    AggregateGreenData.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): AggregateGreenData.AsObject {
    return {
      totalEmissionReduction: this.totalEmissionReduction,
      totalReducedDeforestation: this.totalReducedDeforestation,
      totalCoalSaved: this.totalCoalSaved
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): AggregateGreenData.AsProtobufJSON {
    return {
      totalEmissionReduction: this.totalEmissionReduction,
      totalReducedDeforestation: this.totalReducedDeforestation,
      totalCoalSaved: this.totalCoalSaved
    };
  }
}
export module AggregateGreenData {
  /**
   * Standard JavaScript object representation for AggregateGreenData
   */
  export interface AsObject {
    totalEmissionReduction: number;
    totalReducedDeforestation: number;
    totalCoalSaved: number;
  }

  /**
   * Protobuf JSON representation for AggregateGreenData
   */
  export interface AsProtobufJSON {
    totalEmissionReduction: number;
    totalReducedDeforestation: number;
    totalCoalSaved: number;
  }
}
